/** @type {import("../typings/phaser")} */ var $ca2834f16a956c4f$export$5c5cddbd5caf0d99;
(function(BuildLevel) {
    BuildLevel[BuildLevel["Dev"] = 1] = "Dev";
    BuildLevel[BuildLevel["Prod"] = 2] = "Prod";
})($ca2834f16a956c4f$export$5c5cddbd5caf0d99 || ($ca2834f16a956c4f$export$5c5cddbd5caf0d99 = {}));
const $ca2834f16a956c4f$export$29cd7b75162a9425 = {
    GameVersion: "web1.1.5",
    BuildLevel: 2,
    AnalyticsEnabled: false
};


const $15b72a9ad2952278$export$842dc6aa1981869f = {
    ENDSCREEN: "./assets/endTexts/",
    AUDIO: "./assets/audio/",
    GENERIC: "./assets/generic/",
    BUTTONS: "./assets/buttons/",
    FONTS: "./assets/fonts/",
    ANIMATIONS: "./assets/animations/",
    PHYSICS: "./assets/physics/",
    LOAD: "./assets/00load/",
    MENU: "./assets/main_game/0Start/",
    BIRTH: "./assets/main_game/1Birth/",
    TALK: "./assets/main_game/3talk/",
    SCHOOL: "./assets/main_game/4school/",
    PUBERTY: "./assets/main_game/5puberty/",
    FINDHER: "./assets/main_game/6findher/",
    BEERPONG: "./assets/main_game/7beerpong/",
    COFFEE: "./assets/main_game/8coffee/",
    MARRIAGE: "./assets/main_game/9marriage/",
    KIDS: "./assets/main_game/10kids/",
    MIDLIFE: "./assets/main_game/11midlife/",
    GRANDCHILDREN: "./assets/main_game/12grandchildren/",
    PILLS: "./assets/main_game/13pills/",
    DIE: "./assets/main_game/14die/",
    HOME_BUTTON: "./assets/buttons/home/",
    //ARCADE MINIGAMES
    ARCADE_SCREEN: "./assets/_arcade/arcade_menu/",
    INSTRUMENT: "./assets/_arcade/instrument/",
    GRID_FILL: "./assets/_arcade/grid_fill/",
    DISTRACTION: "./assets/_arcade/distraction/",
    BURGER: "./assets/_arcade/burger/"
};
const $15b72a9ad2952278$export$fadd21211b40c08a = {
    REGISTRY: {
        ADBLOCKENABLED: "adblockEnabled",
        SKIPUSED: "skipUsed"
    },
    GAMESTATE: {
        START: "START",
        PLAYING: "PLAYING",
        WIN: "WIN",
        LOSE: "LOSE",
        LOADNEXTLEVEL: "LOAD"
    },
    TAGS: {
        ARCADE: "ARCADE_TAG"
    },
    SCENES: {
        LOAD: "LOAD",
        PROGRESSIVE_LOAD: "PROGRESSIVE_LOAD",
        SOUNDTRACK: "SOUNDTRACK",
        MENU: "MENU",
        BIRTH: "BIRTH",
        TALK: "TALK",
        SCHOOL: "SCHOOL",
        PUBERTY: "PUBERTY",
        FINDHER: "FINDHER",
        BEERPONG: "BEERPONG",
        COFFEE: "COFFEE",
        MARRIAGE: "MARRIAGE",
        KIDS: "KIDS",
        MIDLIFE: "MIDLIFE",
        GRANDCHILDREN: "GRANDCHILDREN",
        PILLS: "PILLS",
        DIE: "DIE",
        CREDITS: "CREDITS",
        //Arcade minigames
        ARCADE: "ARCADE_SCREEN",
        ARCADE_MINIGAME_LOADING: "ARCADE_MINIGAME_LOADING",
        INSTRUMENT: "INSTRUMENT",
        GRID_FILL: "GRID_FILL",
        DISTRACTION: "DISTRACTION",
        BURGER: "BURGER"
    },
    STORAGE_KEYS: {
        PROGRESS: "game_progress"
    },
    AUDIO: {
        SOUNDTRACK: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "soundtrack.mp3",
        SOUNDTRACK_SHORT: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "soundtrackShort.mp3",
        GRAB: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "paperGrab.mp3",
        POP: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "pop.mp3",
        TALK: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "talking.mp3",
        CRY: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "babyCry.mp3",
        BOUNCE: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "bounce.mp3",
        DIESONG: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "funeralsong.mp3",
        LIGHTNING: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "lightningStrike.mp3",
        NOOO: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "noooo.mp3",
        INSTRUMENT_1: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "instrument/1.mp3",
        INSTRUMENT_2: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "instrument/2.mp3",
        INSTRUMENT_3: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "instrument/3.mp3",
        INSTRUMENT_4: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "instrument/4.mp3",
        INSTRUMENT_5: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "instrument/5.mp3",
        INSTRUMENT_6: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "instrument/6.mp3",
        INSTRUMENT_7: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "instrument/7.mp3",
        //ARCADE
        FLASH: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "arcade/flash.mp3",
        HELLO: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "arcade/hello.mp3",
        INSTRUMENT_FAIL: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "arcade/instrument-fail.mp3",
        LOSE: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "arcade/lose.mp3",
        PING_1: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "arcade/ping-1.mp3",
        PING_2: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "arcade/ping-2.mp3",
        TRASH: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "arcade/trash.mp3",
        TV_OFF: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "arcade/tv-turn-off.mp3",
        TV_ON: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "arcade/tv-turn-on.mp3",
        VIBRATE: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "arcade/vibrate.mp3",
        WIN: $15b72a9ad2952278$export$842dc6aa1981869f.AUDIO + "arcade/win.mp3"
    },
    GENERIC: {
        TUTORIAL_HAND: $15b72a9ad2952278$export$842dc6aa1981869f.GENERIC + "tutorialHand.png"
    },
    BUTTONS: {
        TRYAGAIN: $15b72a9ad2952278$export$842dc6aa1981869f.BUTTONS + "try_again.png",
        SKIP: $15b72a9ad2952278$export$842dc6aa1981869f.BUTTONS + "skip.png",
        SPINNER: $15b72a9ad2952278$export$842dc6aa1981869f.BUTTONS + "spinner.png",
        ORANGE: $15b72a9ad2952278$export$842dc6aa1981869f.BUTTONS + "orange.png",
        PURPLE: $15b72a9ad2952278$export$842dc6aa1981869f.BUTTONS + "purple.png",
        RED: $15b72a9ad2952278$export$842dc6aa1981869f.BUTTONS + "red.png",
        BACK: $15b72a9ad2952278$export$842dc6aa1981869f.BUTTONS + "back.png",
        SOUND_ON: $15b72a9ad2952278$export$842dc6aa1981869f.BUTTONS + "sound-on.png",
        SOUND_OFF: $15b72a9ad2952278$export$842dc6aa1981869f.BUTTONS + "sound-off.png"
    },
    FONT: {
        ATLAS: $15b72a9ad2952278$export$842dc6aa1981869f.FONTS + "blogger.png",
        XML: $15b72a9ad2952278$export$842dc6aa1981869f.FONTS + "blogger.xml"
    },
    //Old animations from unity. Check if you can maybe replace them with tweens (save around 100kb, probably not worth it)
    ANIMATIONS: {
        SCHOOLEND: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "schoolEnd.json",
        PUBERTYEND: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "pubertyEnd.json",
        COFFEEEND: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "coffeeEnd.json",
        FINDHEREND: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "findherEnd.json",
        MARRIAGEFROWN: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "marriageFrown.json",
        MARRIAGEWIN: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "marriageWin.json",
        DADHEAD: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "daddyHead.json",
        KIDSSHOOTBABY: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "kidsShootBaby.json",
        MIDLIFELEFTFOOT: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "midlifeLeftFoot.json",
        MIDLIFERIGHTFOOT: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "midlifeRightFoot.json",
        MIDLIFEWIN: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "midlifeWin.json",
        GRANDPAMOVE: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "grandpaMove.json",
        GRANDPALEFTHAND: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "grandpaLeftHand.json",
        GRANDPARIGHTHAND: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "grandpaRightHand.json",
        KIDTORSO: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "kidTorso.json",
        KIDLEFTLEG: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "kidLeftLeg.json",
        KIDRIGHTLEG: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "kidRightLeg.json",
        KIDDIEFIRE: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "dieFire.json",
        KIDDIEELECTRIC: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "dieElectric.json",
        PILLSEND: $15b72a9ad2952278$export$842dc6aa1981869f.ANIMATIONS + "pillsEnd.json"
    },
    PHYSICS: {
        PILLS: $15b72a9ad2952278$export$842dc6aa1981869f.PHYSICS + "PillsShapes.json",
        BEERPONG: $15b72a9ad2952278$export$842dc6aa1981869f.PHYSICS + "beerpongShapes.json"
    },
    MENU: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.MENU + "background.png",
        CLOUDS: $15b72a9ad2952278$export$842dc6aa1981869f.MENU + "clouds.png",
        NATURE: $15b72a9ad2952278$export$842dc6aa1981869f.MENU + "nature.png",
        TITLE_TEXT: $15b72a9ad2952278$export$842dc6aa1981869f.MENU + "title_text.png",
        CHARACTER: $15b72a9ad2952278$export$842dc6aa1981869f.MENU + "character.png"
    },
    HOME_BUTTON: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.HOME_BUTTON + "bg.png",
        CHECK: $15b72a9ad2952278$export$842dc6aa1981869f.HOME_BUTTON + "check.png",
        CHECK_HIGHLIGHT: $15b72a9ad2952278$export$842dc6aa1981869f.HOME_BUTTON + "check_highlight.png",
        X: $15b72a9ad2952278$export$842dc6aa1981869f.HOME_BUTTON + "x.png",
        X_HIGHLIGHT: $15b72a9ad2952278$export$842dc6aa1981869f.HOME_BUTTON + "x_highlight.png",
        HIGHLIGHT: $15b72a9ad2952278$export$842dc6aa1981869f.HOME_BUTTON + "highlight.png",
        NORMAL: $15b72a9ad2952278$export$842dc6aa1981869f.HOME_BUTTON + "normal.png"
    },
    BIRTH: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.BIRTH + "background.png",
        BABY: $15b72a9ad2952278$export$842dc6aa1981869f.BIRTH + "baby.png",
        CLICKER: $15b72a9ad2952278$export$842dc6aa1981869f.BIRTH + "clicker.png",
        MAMICA1: $15b72a9ad2952278$export$842dc6aa1981869f.BIRTH + "mamica-1.png",
        MAMICA2: $15b72a9ad2952278$export$842dc6aa1981869f.BIRTH + "mamica-2.png",
        MAMICA3: $15b72a9ad2952278$export$842dc6aa1981869f.BIRTH + "mamica-3.png",
        MAMICA4: $15b72a9ad2952278$export$842dc6aa1981869f.BIRTH + "mamica-4.png",
        MAMICA5: $15b72a9ad2952278$export$842dc6aa1981869f.BIRTH + "mamica-5.png",
        PUSH: $15b72a9ad2952278$export$842dc6aa1981869f.BIRTH + "push.png",
        STROLLER: $15b72a9ad2952278$export$842dc6aa1981869f.BIRTH + "stroler.png",
        SWING: $15b72a9ad2952278$export$842dc6aa1981869f.BIRTH + "swing.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.ENDSCREEN + "birth.png"
    },
    TALK: {
        STARTBACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.TALK + "startBackground.png",
        ENDSTRETCH: $15b72a9ad2952278$export$842dc6aa1981869f.TALK + "end-stretch.png",
        ENDBACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.TALK + "end.png",
        NOTE_1: $15b72a9ad2952278$export$842dc6aa1981869f.TALK + "note-1.png",
        NOTE_2: $15b72a9ad2952278$export$842dc6aa1981869f.TALK + "note-2.png",
        NOTE_3: $15b72a9ad2952278$export$842dc6aa1981869f.TALK + "note-3.png",
        NOTE_4: $15b72a9ad2952278$export$842dc6aa1981869f.TALK + "note-4.png",
        STRETCHBACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.TALK + "stretch.png",
        TAP: $15b72a9ad2952278$export$842dc6aa1981869f.TALK + "tap.png",
        SMILE: $15b72a9ad2952278$export$842dc6aa1981869f.TALK + "smile.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.ENDSCREEN + "talk.png"
    },
    SCHOOL: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.SCHOOL + "background.png",
        BOY: $15b72a9ad2952278$export$842dc6aa1981869f.SCHOOL + "boy.png",
        NOTE_3: $15b72a9ad2952278$export$842dc6aa1981869f.SCHOOL + "3.png",
        NOTE_4: $15b72a9ad2952278$export$842dc6aa1981869f.SCHOOL + "4.png",
        NOTE_17: $15b72a9ad2952278$export$842dc6aa1981869f.SCHOOL + "17.png",
        NOTE_20: $15b72a9ad2952278$export$842dc6aa1981869f.SCHOOL + "20.png",
        NOTE_27: $15b72a9ad2952278$export$842dc6aa1981869f.SCHOOL + "27.png",
        NOTE_H2NO: $15b72a9ad2952278$export$842dc6aa1981869f.SCHOOL + "h2no.png",
        NOTE_YES: $15b72a9ad2952278$export$842dc6aa1981869f.SCHOOL + "yes.png",
        WINIMAGE: $15b72a9ad2952278$export$842dc6aa1981869f.SCHOOL + "a-plus.png",
        LOSEIMAGE: $15b72a9ad2952278$export$842dc6aa1981869f.SCHOOL + "f-minus.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.ENDSCREEN + "school.png"
    },
    PUBERTY: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.PUBERTY + "background-and-boy.png",
        BRACES: $15b72a9ad2952278$export$842dc6aa1981869f.PUBERTY + "braces.png",
        PARTICLE: $15b72a9ad2952278$export$842dc6aa1981869f.PUBERTY + "drop.png",
        PIMPLE: $15b72a9ad2952278$export$842dc6aa1981869f.PUBERTY + "little-pimple.png",
        POP_TEXT: $15b72a9ad2952278$export$842dc6aa1981869f.PUBERTY + "pop.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.ENDSCREEN + "puberty.png"
    },
    FINDHER: {
        FOREGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "findher.png",
        WHITEBACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "white.png",
        SWIPETEXT: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "swipe.png",
        LIKE_OVERLAY: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "LIKE.png",
        NOPE_OVERLAY: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "NOPE.png",
        CUTIE_1: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "cutie-1.png",
        CUTIE_2: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "cutie-2.png",
        CUTIE_3: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "cutie-3.png",
        NOTCUTE_1: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "not-so-cute-1.png",
        NOTCUTE_2: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "not-so-cute-2.png",
        ZOIDBERG: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "zoidberg.png",
        WINIMAGE: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "its-a-match.png",
        WRONG_1: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "tindher-wrong.png",
        WRONG_2: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "wrong-2-tindher.png",
        WRONG_3: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "tindher-wrong-3.png",
        WRONG_4: $15b72a9ad2952278$export$842dc6aa1981869f.FINDHER + "tindher-wrong-4.png"
    },
    BEERPONG: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.BEERPONG + "background.png",
        DUNKTEXT: $15b72a9ad2952278$export$842dc6aa1981869f.BEERPONG + "dunk-it.png",
        CUP_FRONT: $15b72a9ad2952278$export$842dc6aa1981869f.BEERPONG + "FRONT.png",
        CUP_BACK: $15b72a9ad2952278$export$842dc6aa1981869f.BEERPONG + "BACK.png",
        BALL: $15b72a9ad2952278$export$842dc6aa1981869f.BEERPONG + "ball.png",
        BLACK_CIRCLE: $15b72a9ad2952278$export$842dc6aa1981869f.BEERPONG + "blackCircle.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.ENDSCREEN + "beerpong.png"
    },
    COFFEE: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "background.png",
        MAKECOFFEETEXT: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "make-coffee.png",
        CUP_CHEESE: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "cheese-cup.png",
        NORMAL_CHEESE: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "cheese-normal.png",
        CUP_COFFEE: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "coffee-cup.png",
        NORMAL_COFFEE: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "coffee.png",
        CUP_EGG: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "egg-cup.png",
        NORMAL_EGG: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "egg.png",
        CUP_MILK: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "milk-cup.png",
        NORMAL_MILK: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "milk.png",
        CUP_PEPPER: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "pepper-cup.png",
        NORMAL_PEPPER: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "pepper.png",
        CUP_SALT: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "salt-cup.png",
        NORMAL_SALT: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "salt.png",
        CUP_SCREW: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "screw-cup.png",
        NORMAL_SCREW: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "screw.png",
        CUP_SUGAR: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "sugar-cup.png",
        NORMAL_SUGAR: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "sugar.png",
        CUP_TOMATO: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "tomato-cup.png",
        NORMAL_TOMATO: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "tomato.png",
        WINIMAGE: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "coffee-right-01.png",
        LOSEIMAGE: $15b72a9ad2952278$export$842dc6aa1981869f.COFFEE + "coffee-wrong-boss.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.ENDSCREEN + "coffee.png"
    },
    MARRIAGE: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "background.png",
        BACKGROUND_OVERLAY: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "suit-up-2.png",
        HANDS: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "hands.png",
        PANTS_1: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "pants-1.png",
        PANTS_2: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "pants-2.png",
        PANTS_3: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "pants-3.png",
        PANTS_4: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "pants-4.png",
        PANTS_5: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "pants-5.png",
        SHIRT_1: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "shirt-1-no-sleve.png",
        SHIRT_2: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "shirt-2.png",
        SHIRT_3: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "shirt-3.png",
        SHIRT_4: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "shirt-4.png",
        SHIRT_5: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "shirt-5.png",
        SHOES_1: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "shoes-1.png",
        SHOES_2: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "shoes-2.png",
        SHOES_3: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "shoes-3.png",
        SLEEVE: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "sleve.png",
        WINIMAGE: $15b72a9ad2952278$export$842dc6aa1981869f.MARRIAGE + "married.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.ENDSCREEN + "marriage.png"
    },
    KIDS: {
        BABY_2: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "baby-2.png",
        BABY_3: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "baby-3.png",
        BABY_4: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "baby-4.png",
        MAMICA1: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "birth.png",
        MAMICA2: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "birth-2.png",
        MAMICA3: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "birth-3.png",
        MAMICA4: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "birth-4.png",
        MAMICA5: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "birth-5.png",
        DADBOD: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "body.png",
        DADHEAD: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "head.png",
        TEXT_1: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "TEXT-1.png",
        TEXT_2: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "TEXT-2.png",
        TEXT_3: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "TEXT-3.png",
        TEXT_4: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "TEXT-4.png",
        TEXT_5: $15b72a9ad2952278$export$842dc6aa1981869f.KIDS + "TEXT-5.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.ENDSCREEN + "kids.png"
    },
    MIDLIFE: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "background.png",
        ENDLESSBACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "endless.png",
        PICKTEXT: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "pick-drop.png",
        BODY: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "body.png",
        FEET: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "feet-one.png",
        HEAD: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "head.png",
        LIST: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "list.png",
        BEER: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "beer.png",
        CANDY: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "candy.png",
        CAR: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "car.png",
        CD: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "cd.png",
        PANTIES: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "panties.png",
        TICKET: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "ticket.png",
        WEIGHTS: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "weights.png",
        WINIMAGE: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "midlife-happy.png",
        ENDEVERYTHING: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "endEverything.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.MIDLIFE + "end.png"
    },
    GRANDCHILDREN: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.GRANDCHILDREN + "background.png",
        DRAGTEXT: $15b72a9ad2952278$export$842dc6aa1981869f.GRANDCHILDREN + "drag-drop-2.png",
        //FEET: ASSETSPATH.GRANDCHILDREN + "feet-one.png",
        HANDS_LEFT: $15b72a9ad2952278$export$842dc6aa1981869f.GRANDCHILDREN + "hands-left.png",
        HANDS_RIGHT: $15b72a9ad2952278$export$842dc6aa1981869f.GRANDCHILDREN + "hands-right.png",
        GRANDPA: $15b72a9ad2952278$export$842dc6aa1981869f.GRANDCHILDREN + "grandpa.png",
        KID1: $15b72a9ad2952278$export$842dc6aa1981869f.GRANDCHILDREN + "kid-1.png",
        KID2: $15b72a9ad2952278$export$842dc6aa1981869f.GRANDCHILDREN + "kid-2.png",
        KID3: $15b72a9ad2952278$export$842dc6aa1981869f.GRANDCHILDREN + "kid-3.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.ENDSCREEN + "grandchildren.png"
    },
    PILLS: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.PILLS + "background.png",
        BOX1: $15b72a9ad2952278$export$842dc6aa1981869f.PILLS + "box.png",
        BOX2: $15b72a9ad2952278$export$842dc6aa1981869f.PILLS + "box-2.png",
        BOX3: $15b72a9ad2952278$export$842dc6aa1981869f.PILLS + "box-3.png",
        BIGBOX: $15b72a9ad2952278$export$842dc6aa1981869f.PILLS + "big-box.png",
        PILL1: $15b72a9ad2952278$export$842dc6aa1981869f.PILLS + "pill-1.png",
        PILL2: $15b72a9ad2952278$export$842dc6aa1981869f.PILLS + "pill-2.png",
        PILL3: $15b72a9ad2952278$export$842dc6aa1981869f.PILLS + "pill-3.png",
        GRANDPA: $15b72a9ad2952278$export$842dc6aa1981869f.PILLS + "grandpa.png",
        SORTTEXT: $15b72a9ad2952278$export$842dc6aa1981869f.PILLS + "sort.png",
        TABLE: $15b72a9ad2952278$export$842dc6aa1981869f.PILLS + "table.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.ENDSCREEN + "pills.png"
    },
    DIE: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.DIE + "Death.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.DIE + "end.png"
    },
    CREDITS: {
        END: $15b72a9ad2952278$export$842dc6aa1981869f.ENDSCREEN + "credits.png"
    },
    //Arcade minigames
    ARCADE_SCREEN: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "background.png",
        DARK_LAYER: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "dark.png",
        HOME_BUTTON: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "home.png",
        NEW: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "new.png",
        BURGER: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "burger.png",
        BURGER_SELECTED: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "burger_selected.png",
        INSTRUMENT: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "instrument.png",
        INSTRUMENT_SELECTED: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "instrument_selected.png",
        GRIDFILL: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "gridfill.png",
        GRIDFILL_SELECTED: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "gridfill_selected.png",
        DISTRACTION: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "distraction.png",
        DISTRACTION_SELECTED: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "distraction_selected.png",
        MAIN_GAME: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "main_game.png",
        MAIN_GAME_SELECTED: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "main_game_selected.png",
        NEW_LEVELS: $15b72a9ad2952278$export$842dc6aa1981869f.ARCADE_SCREEN + "new_levels.png"
    },
    INSTRUMENT: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "bg.png",
        CHARACTER_BODY: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "char.png",
        CHARACTER_HEAD: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "char-head.png",
        HAND_LEFT: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "handLeft.png",
        HAND_RIGHT_TOP: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "handRightTop.png",
        HAND_RIGHT_BOTTOM: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "handRightBottom.png",
        TABLE: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "table.png",
        HEART: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "heart_full.png",
        HEART_EMPTY: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "heart_empty.png",
        BAR_WHITE_1: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "white/1.png",
        BAR_WHITE_2: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "white/2.png",
        BAR_WHITE_3: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "white/3.png",
        BAR_WHITE_4: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "white/4.png",
        BAR_WHITE_5: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "white/5.png",
        BAR_WHITE_6: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "white/6.png",
        BAR_WHITE_7: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "white/7.png",
        BAR_DARK_1: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "dark/1.png",
        BAR_DARK_2: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "dark/2.png",
        BAR_DARK_3: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "dark/3.png",
        BAR_DARK_4: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "dark/4.png",
        BAR_DARK_5: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "dark/5.png",
        BAR_DARK_6: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "dark/6.png",
        BAR_DARK_7: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "dark/7.png",
        //ENDSCREEN
        END: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "end/end.png",
        BACK: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "end/back.png",
        BACK_2: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "end/back_2.png",
        CONTINUE: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "end/continue.png",
        TRY_AGAIN: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "end/try_again.png",
        TRY_AGAIN_2: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "end/try_again_2.png",
        NEW_BEST: $15b72a9ad2952278$export$842dc6aa1981869f.INSTRUMENT + "end/new-best.png"
    },
    GRID_FILL: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "background.png",
        HANDS: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "hands.png",
        CAMERA: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "camera.png",
        SCREEN: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "screen.png",
        BLOCK_BLUE: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "blue.png",
        BLOCK_GREEN: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "green.png",
        BLOCK_ORANGE: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "orange.png",
        BLOCK_PURPLE: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "purple.png",
        BLOCK_RED: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "red.png",
        BLOCK_YELLOW: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "yellow.png",
        BLOCK_GREY: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "grey.png",
        //end screen
        END: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "end_screen/end.png",
        BACK: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "end_screen/back.png",
        CONTINUE: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "end_screen/continue.png",
        NEW_BEST: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "end_screen/new_best.png",
        TRY_AGAIN: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "end_screen/try_again.png",
        TRY_AGAIN_2: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "end_screen/try_again_2.png",
        ARCADE: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "end_screen/arcade.png",
        //Countdown
        COUNTDOWN_1: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "countdown/slider1.png",
        COUNTDOWN_2: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "countdown/slider2.png",
        COUNTDOWN_3: $15b72a9ad2952278$export$842dc6aa1981869f.GRID_FILL + "countdown/slider3.png"
    },
    DISTRACTION: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "background.png",
        WINDOW_BACK: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "window_back.png",
        WINDOW_FRONT: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "window_front.png",
        CHARACTER: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "character.png",
        ARM: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "arm.png",
        HAND: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "hand.png",
        CLOUD: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "cloud.png",
        //PHONE
        PHONE: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "phone/phone.png",
        PHONE_BUZZ_1: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "phone/phone_buzz_1.png",
        PHONE_BUZZ_2: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "phone/phone_buzz_2.png",
        PHONE_MESSAGE_1: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "phone/phone_message_1.png",
        PHONE_MESSAGE_2: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "phone/phone_message_2.png",
        PHONE_MESSAGE_3: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "phone/phone_message_3.png",
        PHONE_SHADOW: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "phone/phone_shadow.png",
        TV_TEXT_0: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "tv/0.png",
        TV_TEXT_1: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "tv/1.png",
        TV_TEXT_2: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "tv/2.png",
        TV_TEXT_3: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "tv/3.png",
        TV_TEXT_4: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "tv/4.png",
        TV_PADDLE: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "tv/rectangle.png",
        TV_BALL: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "tv/tv-ball.png",
        TV_SCREEN_DARK: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "tv/dark_screen.png",
        TV_SCREEN_LIGHT: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "tv/light-screen.png",
        WINDOW_HAND: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "window/waving-hand.png",
        WINDOW_CHARACTER: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "window/window_character.png",
        BALL_1: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "ball/ball_1.png",
        BALL_2: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "ball/ball_2.png",
        BALL_3: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "ball/ball_3.png",
        BALL_4: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "ball/ball_4.png",
        BALL_5: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "ball/ball_5.png",
        BALL_6: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "ball/ball_6.png",
        //END
        END: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "end/end.png",
        BACK: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "end/back.png",
        BACK_2: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "end/back_2.png",
        CONTINUE: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "end/continue.png",
        TRY_AGAIN: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "end/try_again.png",
        TRY_AGAIN_2: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "end/try_again_2.png",
        NEW_BEST: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "end/new-best.png",
        //Countdown
        COUNTDOWN_1: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "countdown/slider1.png",
        COUNTDOWN_2: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "countdown/slider2.png",
        COUNTDOWN_3: $15b72a9ad2952278$export$842dc6aa1981869f.DISTRACTION + "countdown/slider3.png"
    },
    BURGER: {
        BACKGROUND: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "background.png",
        ROPE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "rope.png",
        BOARD: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "board.png",
        HAND: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "hand.png",
        PLATE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "plate.png",
        PLATE_OUTLINE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "plate_outline.png",
        TRASH: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "trash.png",
        TRASH_OUTLINE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "trash_outline.png",
        TRASH_TOP: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "trash_top.png",
        TIMER: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "timer_bg.png",
        TIMER_CIRCLE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "circle_white.png",
        PAPER: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "paper/paper.png",
        //INGREDIENTS
        I_BUN_BOTTOM: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/bun_bottom.png",
        I_BUN_TOP: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/bun_top.png",
        I_CHEESE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/cheese.png",
        I_EGGS: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/eggs.png",
        I_LETTUCE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/lettuce.png",
        I_PATTY: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/patty.png",
        I_TOMATO: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/tomato.png",
        //INGREDIENTSHADOWS
        I_S_BUN_BOTTOM: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/shadow/bun_bottom.png",
        I_S_BUN_TOP: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/shadow/bun_top.png",
        I_S_CHEESE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/shadow/cheese.png",
        I_S_EGGS: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/shadow/eggs.png",
        I_S_LETTUCE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/shadow/lettuce.png",
        I_S_PATTY: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/shadow/patty.png",
        I_S_TOMATO: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "ingredients/shadow/tomato.png",
        //PAPER SATURATED INGREDIENTS
        P_S_BUN_BOTTOM: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "paper/saturated/bun_bottom.png",
        P_S_BUN_TOP: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "paper/saturated/bun_top.png",
        P_S_CHEESE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "paper/saturated/cheese.png",
        P_S_EGGS: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "paper/saturated/egg.png",
        P_S_LETTUCE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "paper/saturated/salad.png",
        P_S_PATTY: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "paper/saturated/patty.png",
        P_S_TOMATO: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "paper/saturated/tomato.png",
        //END SCREEN
        ARCADE_BUTTON: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "end/arcade_button.png",
        BACK_TO_ARCADE: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "end/back_to_arcade.png",
        BURGERS_TEXT: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "end/burgers_text.png",
        CONTINUE_BUTTON: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "end/continue_button.png",
        END: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "end/end_screen.png",
        TRY_AGAIN_BUTTON: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "end/try_again_button.png",
        TRY_AGAIN_BUTTON_2: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "end/try_again_button_2.png",
        NEW_BEST: $15b72a9ad2952278$export$842dc6aa1981869f.BURGER + "end/new_best.png"
    }
};



class $853b94ecf165ba5a$export$9e165481be275d2d {
    static Debug(...args) {
        this.Log(args);
    }
    static Log(args, logLevel = (0, $ca2834f16a956c4f$export$5c5cddbd5caf0d99).Dev) {
        if ((0, $ca2834f16a956c4f$export$29cd7b75162a9425).BuildLevel > logLevel) return;
        console.log(...args);
    }
}



const $a04efaba6a5d950c$export$30b7662faa307ee = {
    AdblockEnabled: "Ads:Adblock:Enabled",
    AdblockDisabled: "Ads:Adblock:Disabled",
    LocalStorageEnabled: "General:LocalStorage:Enabled",
    LocalStorageDisabled: "General:LocalStorage:Disableds",
    ConfigsLoadOnTime: "Configs:Load:OnTime",
    ConfigsLoadDelayed: "Configs:Load:Delayed",
    ConfigsLoadTimeout: "Configs:Load:Timeout",
    AdsRewardedCompleted: "Ads:Rewarded:Completed",
    AdsRewardedFailed: "Ads:Rewarded:Failed"
};
class $a04efaba6a5d950c$export$ca681bfeb2cf0fca extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager){
        super(pluginManager);
    }
    initialize() {
        if (this.analyticsDisabled()) {
            (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("Analytics are disabled.");
            return;
        }
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("Initializing analytics");
        //gameanalytics.GameAnalytics.configureBuild(Config.GameVersion);
        let gK = "d8108fb16b8816bf3093b5cc1acf879d";
        let sK = "0cee8e77f0f4680b57fe3f6d0c7f02d0971e2f54";
        if ((0, $ca2834f16a956c4f$export$29cd7b75162a9425).BuildLevel < (0, $ca2834f16a956c4f$export$5c5cddbd5caf0d99).Prod) {
            gK = "e0f396d2a7f8a780badff51a1c87a727"; //Dev keys
            sK = "34e3568130a4f2cf265c4ab84a1e6ef96ca63532";
        }
    //gameanalytics.GameAnalytics.initialize(gK, sK);
    // gameanalytics.GameAnalytics.setEnabledVerboseLog(true);
    }
    setAdblockStatus(adblockEnabled) {
        this.addDesignEvent(adblockEnabled ? $a04efaba6a5d950c$export$30b7662faa307ee.AdblockEnabled : $a04efaba6a5d950c$export$30b7662faa307ee.AdblockDisabled);
    }
    setLocalStorageSupported(localStorageSupported) {
        this.addDesignEvent(localStorageSupported ? $a04efaba6a5d950c$export$30b7662faa307ee.LocalStorageEnabled : $a04efaba6a5d950c$export$30b7662faa307ee.LocalStorageDisabled);
    }
    addRewardedAdFinishedEvent(completedSuccessfully) {
        this.addDesignEvent(completedSuccessfully ? $a04efaba6a5d950c$export$30b7662faa307ee.AdsRewardedCompleted : $a04efaba6a5d950c$export$30b7662faa307ee.AdsRewardedFailed);
    }
    addGameStartEvent(sceneName) {
    //this.addProgressionEvent(gameanalytics.EGAProgressionStatus.Start, sceneName);
    }
    addGameWinEvent(sceneName) {
    //this.addProgressionEvent(gameanalytics.EGAProgressionStatus.Complete, sceneName);
    }
    addGameLoseEvent(sceneName) {
    // this.addProgressionEvent(gameanalytics.EGAProgressionStatus.Fail, sceneName);
    }
    addFinalScoreEvent(sceneName, score) {
        this.addDesignEventWithValue(sceneName + ":FinalScore", Math.round(score));
    }
    addProgressionEvent(event, sceneName) {
        if (this.analyticsDisabled()) return;
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("Adding gameanalytics progression event: " + event + ", scene name: " + sceneName);
    //gameanalytics.GameAnalytics.addProgressionEvent(event, sceneName);
    }
    addDesignEvent(designEvent) {
        if (this.analyticsDisabled()) return;
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("Adding gameanalytics design event: " + designEvent);
    //gameanalytics.GameAnalytics.addDesignEvent(designEvent);
    }
    addDesignEventWithValue(designEvent, eventValue) {
        if (this.analyticsDisabled()) return;
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("Adding gameanalytics design event: " + designEvent + " with value: " + eventValue);
    //gameanalytics.GameAnalytics.addDesignEvent(designEvent, eventValue);
    }
    analyticsDisabled() {
        return !(0, $ca2834f16a956c4f$export$29cd7b75162a9425).AnalyticsEnabled;
    }
}



class $1bb8838b0c7bd3a3$export$50427b92ba00a41 extends Phaser.Scene {
    constructor(){
        super({
            key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.LOAD,
            active: true,
            pack: {
                files: [
                    {
                        type: "image",
                        key: "loadBG",
                        url: "./assets/00load/LTGBackground.png"
                    },
                    {
                        type: "image",
                        key: "loadLogo",
                        url: "./assets/00load/LTGLogo.png"
                    }
                ]
            }
        });
        this.gameLaunched = false;
    }
    init() {
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("CAUTION: DEV BUILD ENABLED!");
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("Local storage supported: " + this.storagePlugin.isLocalStorageSupported());
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("Audio enabled: " + this.audioPlugin.isAudioEnabled());
        this.registry.set((0, $15b72a9ad2952278$export$fadd21211b40c08a).REGISTRY.ADBLOCKENABLED, false);
        PokiSDK.init().then(()=>{
            // successfully initialized
            (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("PokiSDK initialized");
        }).catch(()=>{
            this.registry.set((0, $15b72a9ad2952278$export$fadd21211b40c08a).REGISTRY.ADBLOCKENABLED, true);
            // initialized but the user has an adblock
            (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("PokiSDK initialization fail: Adblock enabled");
        });
        if ((0, $ca2834f16a956c4f$export$29cd7b75162a9425).BuildLevel < (0, $ca2834f16a956c4f$export$5c5cddbd5caf0d99).Prod) PokiSDK.setDebug(true);
        var _0x4e87 = [
            "LnBva2kuY29t",
            "bG9jYWxob3N0",
            "139KObtWR",
            "6505XySddN",
            "1187125jopCbV",
            "913662FnvCIe",
            "740825sNyBkZ",
            "459327dmigPF",
            "335606FqHNeg",
            "770186hYUBAW",
            "some",
            "top",
            "aHR0cHM6Ly9wb2tpLmNvbS9zaXRlbG9jaw==",
            "location",
            "length",
            "href"
        ];
        var _0x3b7c = function(_0x286367, _0x417686) {
            _0x286367 = _0x286367 - 0x154;
            var _0x4e87dc = _0x4e87[_0x286367];
            return _0x4e87dc;
        };
        (function(_0x5930ec, _0x5bbb0f) {
            var _0x5734eb = _0x3b7c;
            while(true)try {
                var _0x35a8d1 = parseInt(_0x5734eb(0x15d)) + parseInt(_0x5734eb(0x15c)) + -parseInt(_0x5734eb(0x15e)) + parseInt(_0x5734eb(0x159)) * parseInt(_0x5734eb(0x158)) + -parseInt(_0x5734eb(0x15a)) + -parseInt(_0x5734eb(0x15f)) + parseInt(_0x5734eb(0x15b));
                if (_0x35a8d1 === _0x5bbb0f) break;
                else _0x5930ec["push"](_0x5930ec["shift"]());
            } catch (_0x1fa599) {
                _0x5930ec["push"](_0x5930ec["shift"]());
            }
        })(_0x4e87, 0xb1064), !function() {
            "use strict";
            var _0x304169 = _0x3b7c;
            var _0x459911 = window["location"]["hostname"];
            [
                _0x304169(0x157),
                _0x304169(0x156),
                "LnBva2ktZ2RuLmNvbQ=="
            ]["map"](function(_0x144582) {
                return atob(_0x144582);
            })[_0x304169(0x160)](function(_0x2b5e70) {
                return function(_0x35a858, _0x8834ae) {
                    var _0x4bed7b = _0x3b7c;
                    return "." === _0x8834ae["charAt"](0x0) ? -1 !== _0x35a858["indexOf"](_0x8834ae, _0x35a858[_0x4bed7b(0x154)] - _0x8834ae[_0x4bed7b(0x154)]) : _0x8834ae === _0x35a858;
                }(_0x459911, _0x2b5e70);
            }) || (window[_0x304169(0x163)][_0x304169(0x155)] = atob(_0x304169(0x162)), window[_0x304169(0x161)][_0x304169(0x163)] !== window[_0x304169(0x163)] && (window[_0x304169(0x161)][_0x304169(0x163)] = window[_0x304169(0x163)]));
        }();
        this.initPlugins();
    }
    initPlugins() {
        this.analyticsPlugin.initialize();
        this.remoteConf.initialize();
    }
    //@ts-ignore
    //Loads all images for given scene (parameter: CONST.SCENENAME)
    loadSceneImages(scene) {
        for(let prop in scene)this.load.image(scene[prop], scene[prop]);
    }
    loadStartSceneImages() {
        this.loadSceneImages((0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS);
        this.loadSceneImages((0, $15b72a9ad2952278$export$fadd21211b40c08a).GENERIC);
        this.loadSceneImages((0, $15b72a9ad2952278$export$fadd21211b40c08a).HOME_BUTTON);
        this.loadSceneImages((0, $15b72a9ad2952278$export$fadd21211b40c08a).MENU);
        this.loadSceneImages((0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN);
    }
    loadFonts() {
        this.load.bitmapFont((0, $15b72a9ad2952278$export$fadd21211b40c08a).FONT.ATLAS, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FONT.ATLAS, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FONT.XML);
    }
    loadStartAudio() {
        this.load.audio((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.SOUNDTRACK_SHORT, (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.SOUNDTRACK_SHORT);
    }
    preload() {
        this.add.image(0, -32, "loadBG").setOrigin(0, 0);
        this.add.image(426.5, 180, "loadLogo").setScale(0.7);
        this.loadStartSceneImages();
        this.loadFonts();
        this.loadStartAudio();
        //create loading bar
        let loadingBar = this.add.graphics({
            fillStyle: {
                color: 0x48aec7 //white
            }
        }).setDepth(1);
        this.add.graphics().fillStyle(0xffffff, 0.5).fillRect(150, this.game.renderer.height / 2 + 90, this.game.renderer.width - 300, 50);
        PokiSDK.gameLoadingStart();
        this.load.on("progress", (percent)=>{
            PokiSDK.gameLoadingProgress({
                percentageDone: percent
            });
            loadingBar.fillRect(150, this.game.renderer.height / 2 + 90, (this.game.renderer.width - 300) * percent, 50);
        });
        this.load.on("complete", ()=>{
            PokiSDK.gameLoadingFinished();
        });
        this.hidePreloadScreen();
    }
    create() {
        const adblockEnabled = this.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).REGISTRY.ADBLOCKENABLED);
        this.analyticsPlugin.setAdblockStatus(adblockEnabled);
        this.analyticsPlugin.setLocalStorageSupported(this.storagePlugin.isLocalStorageSupported());
        this.scene.launch((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.SOUNDTRACK);
        this.scene.launch((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PROGRESSIVE_LOAD);
        if (this.remoteConf.configsAvailable()) {
            this.LaunchGame();
            this.analyticsPlugin.addDesignEvent((0, $a04efaba6a5d950c$export$30b7662faa307ee).ConfigsLoadOnTime);
        } else {
            //create calback for launch
            this.remoteConf.setConfigsCallback(()=>{
                if (!this.gameLaunched) this.analyticsPlugin.addDesignEvent((0, $a04efaba6a5d950c$export$30b7662faa307ee).ConfigsLoadDelayed);
                this.LaunchGame();
            });
            setTimeout(()=>{
                if (!this.gameLaunched) this.analyticsPlugin.addDesignEvent((0, $a04efaba6a5d950c$export$30b7662faa307ee).ConfigsLoadTimeout);
                this.LaunchGame(true);
            }, 2000);
        }
    }
    LaunchGame(configTimeout = false) {
        if (this.gameLaunched) return;
        //    this.scene.start(CONST.SCENES.DISTRACTION);
        //    this.scene.start(CONST.SCENES.BURGER);
        //    this.scene.start(CONST.SCENES.GRID_FILL);
        //    this.scene.start(CONST.SCENES.INSTRUMENT);
        this.scene.start((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU);
        this.gameLaunched = true;
    }
    hidePreloadScreen() {
        var preload = document.getElementById("preloadDiv");
        preload.style.display = "none";
        var canvas = document.getElementsByTagName("canvas")[0];
        canvas.style.zIndex = 1;
    }
}


//The whole UI is a container

const $042f44b00310c39a$var$animConfig = {
    openOnStart: false,
    duration: 300,
    easeIn: "Quad.easeOut",
    easeOut: "Quad.easeIn",
    closedPosition: {
        x: 426.5,
        y: -240
    },
    openPosition: {
        x: 426.5,
        y: 257
    }
};
const $042f44b00310c39a$var$buttonConfig = {
    grid: {
        center: {
            x: 0,
            y: 23
        },
        yOffset: 72,
        xOffset: 215
    },
    newOffset: {
        x: 85,
        y: -59
    },
    highscoreOffset: {
        x: -66,
        y: 55,
        fontSize: 25
    },
    minigames: [
        {
            scene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.INSTRUMENT,
            defaultImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.INSTRUMENT,
            selectedImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.INSTRUMENT_SELECTED,
            isMinigame: true,
            isArcade: true,
            position: 3,
            rcPosition: 0
        },
        {
            scene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BURGER,
            defaultImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.BURGER,
            selectedImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.BURGER_SELECTED,
            isMinigame: true,
            isArcade: true,
            position: 0,
            rcPosition: 1
        },
        {
            scene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.DISTRACTION,
            defaultImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.DISTRACTION,
            selectedImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.DISTRACTION_SELECTED,
            isMinigame: true,
            isArcade: true,
            position: 1,
            rcPosition: 2
        },
        {
            scene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.GRID_FILL,
            defaultImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.GRIDFILL,
            selectedImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.GRIDFILL_SELECTED,
            isMinigame: true,
            isArcade: true,
            position: 2,
            rcPosition: 3
        },
        {
            scene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BIRTH,
            defaultImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.MAIN_GAME,
            selectedImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.MAIN_GAME_SELECTED,
            isMinigame: true,
            isArcade: false,
            position: 4
        },
        {
            scene: "",
            defaultImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.NEW_LEVELS,
            selectedImage: "",
            isMinigame: false,
            isArcade: false,
            position: 5
        }
    ]
};
class $042f44b00310c39a$export$56b76da1dcde88f8 {
    constructor(scene){
        this.hasNewGames = false;
        this.arcadeButtonPositions = "3012" //From remote config
        ;
        this.scene = scene;
        this.progressiveLoadScene = this.scene.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PROGRESSIVE_LOAD);
        this.darkBg = scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.DARK_LAYER).setOrigin(0, 0).setDepth(49).setAlpha(0);
        this.cont = scene.add.container(this.scene.game.renderer.width / 2, this.scene.game.renderer.height / 2 + 15).setDepth(50);
        this.getRemoteConfig();
        if ($042f44b00310c39a$var$animConfig.openOnStart) this.cont.setPosition($042f44b00310c39a$var$animConfig.openPosition.x, $042f44b00310c39a$var$animConfig.openPosition.y);
        else this.cont.setPosition($042f44b00310c39a$var$animConfig.closedPosition.x, $042f44b00310c39a$var$animConfig.closedPosition.y);
        this.buildUi();
    }
    getRemoteConfig() {
        this.arcadeButtonPositions = this.scene.remoteConf.getConfig("gO");
    }
    open() {
        this.prioritizeLoading();
        this.animate(true);
    }
    prioritizeLoading() {
        if (!this.progressiveLoadScene) return;
        this.progressiveLoadScene.prioritizeChunksWithTag((0, $15b72a9ad2952278$export$fadd21211b40c08a).TAGS.ARCADE);
    }
    close() {
        this.animate(false);
        this.scene.setButtonsInteractive(true);
    }
    animate(animateIn) {
        if (this.moveTween) this.moveTween.stop();
        this.moveTween = this.scene.tweens.add({
            targets: this.cont,
            x: animateIn ? $042f44b00310c39a$var$animConfig.openPosition.x : $042f44b00310c39a$var$animConfig.closedPosition.x,
            y: animateIn ? $042f44b00310c39a$var$animConfig.openPosition.y : $042f44b00310c39a$var$animConfig.closedPosition.y,
            duration: $042f44b00310c39a$var$animConfig.duration,
            ease: animateIn ? $042f44b00310c39a$var$animConfig.easeIn : $042f44b00310c39a$var$animConfig.easeOut
        });
        if (this.fadeTween) this.fadeTween.stop();
        this.fadeTween = this.scene.tweens.add({
            targets: this.darkBg,
            alpha: animateIn ? 1 : 0,
            duration: $042f44b00310c39a$var$animConfig.duration,
            ease: animateIn ? $042f44b00310c39a$var$animConfig.easeIn : $042f44b00310c39a$var$animConfig.easeOut
        });
    }
    buildUi() {
        let bg = this.scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.BACKGROUND);
        let homeButton = this.scene.add.image(-318, -175, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.HOME_BUTTON);
        homeButton.setInteractive({
            useHandCursor: true,
            pixelPerfect: true
        });
        homeButton.on("pointerup", ()=>{
            this.close();
        });
        this.cont.add([
            bg,
            homeButton
        ]);
        $042f44b00310c39a$var$buttonConfig.minigames.forEach((minigame)=>this.buildMinigameButton(minigame, this.cont));
    }
    buildMinigameButton(button, cont) {
        let bottonPosNumber = button.isArcade ? parseInt(this.arcadeButtonPositions[button.rcPosition]) : button.position;
        let buttonPos = this.getButtonPosition(bottonPosNumber);
        let defaultImage = this.scene.add.image(buttonPos.x, buttonPos.y, button.defaultImage);
        defaultImage.setInteractive({
            useHandCursor: true,
            pixelPerfect: true
        });
        cont.add(defaultImage);
        let newTag = this.scene.add.image(buttonPos.x + $042f44b00310c39a$var$buttonConfig.newOffset.x, buttonPos.y + $042f44b00310c39a$var$buttonConfig.newOffset.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ARCADE_SCREEN.NEW).setAngle(-5);
        if (button.isMinigame) {
            let selectedImage = this.scene.add.image(buttonPos.x, buttonPos.y, button.selectedImage).setAlpha(0);
            defaultImage.on("pointerover", ()=>{
                selectedImage.setAlpha(1);
                //Wiggle
                this.shakeTag(newTag, -5);
            });
            defaultImage.on("pointerout", ()=>{
                selectedImage.setAlpha(0);
            });
            cont.add(selectedImage);
            let highscore = this.getHighscore(button.scene);
            let highscoreText = this.scene.add.bitmapText(buttonPos.x + $042f44b00310c39a$var$buttonConfig.highscoreOffset.x, buttonPos.y + $042f44b00310c39a$var$buttonConfig.highscoreOffset.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FONT.ATLAS, highscore.toString(), $042f44b00310c39a$var$buttonConfig.highscoreOffset.fontSize / (highscore.toString().length > 5 ? highscore.toString().length / 5 : 1)).setOrigin(0.5).setCenterAlign();
            if (!button.isArcade) highscoreText.text = "";
            cont.add(highscoreText);
            defaultImage.on("pointerup", ()=>{
                this.handlePlayButtonClick(button.scene);
            });
        } else defaultImage.on("pointerup", ()=>{
            this.shakeTag(defaultImage, 0);
        });
        cont.add(newTag);
        if (!button.isArcade || this.hasBeenPlayed(button.scene)) newTag.setAlpha(0);
        else this.hasNewGames = true;
    }
    shakeTag(tag, defaultAngle) {
        tag.setAngle(defaultAngle);
        this.scene.tweens.add({
            targets: tag,
            angle: "+=5",
            duration: 500,
            ease: (t)=>{
                return this.wiggle(t, 1, 1);
            },
            onComplete: ()=>{
                tag.setAngle(defaultAngle);
            }
        });
    }
    getButtonPosition(position) {
        // 0 , 1 , 2
        // 3 , 4 , 5
        let y = $042f44b00310c39a$var$buttonConfig.grid.center.y + (position >= 3 ? $042f44b00310c39a$var$buttonConfig.grid.yOffset : -$042f44b00310c39a$var$buttonConfig.grid.yOffset);
        let x = $042f44b00310c39a$var$buttonConfig.grid.center.x + (position % 3 == 0 ? -$042f44b00310c39a$var$buttonConfig.grid.xOffset : position % 3 == 1 ? 0 : $042f44b00310c39a$var$buttonConfig.grid.xOffset);
        return {
            x: x,
            y: y
        };
    }
    handlePlayButtonClick(minigame) {
        if (this.progressiveLoadScene.isSceneLoaded(minigame)) this.scene.scene.start(minigame);
        else this.scene.scene.start((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.ARCADE_MINIGAME_LOADING, {
            next: minigame
        });
    }
    hasBeenPlayed(scene) {
        if (this.scene.storagePlugin.getItem(scene + "highscore")) return true;
        return false;
    }
    getHighscore(scene) {
        var highscore = this.scene.storagePlugin.getItem(scene + "highscore");
        if (highscore) return parseInt(highscore);
        else return 0;
    }
    wiggle(aProgress, aPeriod1, aPeriod2) {
        var current1 = aProgress * Math.PI * 2 * aPeriod1;
        var current2 = aProgress * (Math.PI * 2 * aPeriod2 + Math.PI / 2);
        return Math.sin(current1) * Math.cos(current2);
    }
    hasNewArcadeGames() {
        return this.hasNewGames;
    }
}



class $30cfeaa254875b8b$export$fe1abc4519a61930 extends Phaser.Scene {
    constructor(){
        super({
            key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU
        });
        this.cloudMovementSpeed = 25;
        this.isArcadeEnabled = true;
    }
    init() {
        this.registry.set((0, $15b72a9ad2952278$export$fadd21211b40c08a).REGISTRY.SKIPUSED, false);
    }
    preload() {}
    create() {
        this.getRemoteConfig();
        this.createClouds();
        this.createSoundButton();
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MENU.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(0, 480, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MENU.NATURE).setOrigin(0, 1).setDepth(2);
        this.add.image(335, 272, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MENU.CHARACTER).setDepth(3);
        this.add.image(577, 160, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MENU.TITLE_TEXT).setDepth(3);
        this.buttons = [];
        let playButton = new $30cfeaa254875b8b$var$MenuButton(this, 577, 287, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.RED, "PLAY", ()=>{
            this.scene.start((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BIRTH);
        });
        this.buttons.push(playButton);
        if (this.canContinueGame() && this.remoteConf.getConfig("hBe") === "true") {
            let continueButton = new $30cfeaa254875b8b$var$MenuButton(this, 577, 445, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.ORANGE, "CONTINUE", ()=>{
                this.scene.start(this.getProgressScene());
            }, 30);
            this.buttons.push(continueButton);
        }
        if (this.isArcadeEnabled) {
            this.arcadePopup = new (0, $042f44b00310c39a$export$56b76da1dcde88f8)(this);
            let arcadeButton = new $30cfeaa254875b8b$var$MenuButton(this, 577, 366, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.PURPLE, "ARCADE", ()=>{
                this.arcadePopup.open();
                this.setButtonsInteractive(false);
            }, 35);
            this.buttons.push(arcadeButton);
            // if (this.arcadePopup.hasNewArcadeGames()){
            //     //add new tag
            // let tag = this.add.image(68, -22, CONST.ARCADE_SCREEN.NEW).setDepth(5); //642, 341
            //     this.tweens.add({
            //         targets: tag,
            //         angle: "+=5",
            //         duration: 500,
            //         hold: 2500,
            //         repeat: -1,
            //         ease: (t: number) => {return this.wiggle(t, 1, 1)},
            //     });
            // arcadeButton.add(tag);
            // }
            this.openArcade();
        }
        let buttonPos = {
            startX: 577,
            startY: 287,
            changeY: 65
        };
        for(let i = 0; i < this.buttons.length; i++)this.buttons[i].setPosition(buttonPos.startX, buttonPos.startY + i * buttonPos.changeY);
    }
    canContinueGame() {
        //has progress key, and it does not equal credits
        let progress = this.storagePlugin.getItem((0, $15b72a9ad2952278$export$fadd21211b40c08a).STORAGE_KEYS.PROGRESS);
        return progress && progress != (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.DIE && progress != (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.CREDITS;
    }
    getProgressScene() {
        return this.storagePlugin.getItem((0, $15b72a9ad2952278$export$fadd21211b40c08a).STORAGE_KEYS.PROGRESS);
    }
    getRemoteConfig() {
        this.isArcadeEnabled = this.remoteConf.getConfig("aE") === "true";
    }
    wiggle(aProgress, aPeriod1, aPeriod2) {
        var current1 = aProgress * Math.PI * 2 * aPeriod1;
        var current2 = aProgress * (Math.PI * 2 * aPeriod2 + Math.PI / 2);
        return Math.sin(current1) * Math.cos(current2);
    }
    openArcade() {
        var shouldOpen = this.storagePlugin.getItem("openArcadePopup", "");
        if (shouldOpen && parseInt(shouldOpen) == 1) {
            this.arcadePopup.open();
            this.setButtonsInteractive(false);
            this.storagePlugin.setItem("openArcadePopup", "0");
        }
    }
    setButtonsInteractive(interactive) {
        this.buttons.forEach((button)=>{
            button.overrideInteractive(interactive);
        });
    }
    createClouds() {
        var cloudArr = [];
        for(var i = 0; i < 3; i++){
            var c = this.add.image(-this.game.renderer.width * (i - 1), 20, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MENU.CLOUDS).setOrigin(0, 0).setDepth(1);
            cloudArr.push(c);
        }
        this.clouds = this.add.group(cloudArr);
    }
    createSoundButton() {
        this.soundButton = this.add.image(30, this.renderer.height - 30, this.audioPlugin.isAudioEnabled() ? (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.SOUND_ON : (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.SOUND_OFF).setDepth(3).setInteractive({
            useHandCursor: true
        }).setScale(0.7);
        this.soundButton.on("pointerup", ()=>{
            let audioEnabled = this.audioPlugin.toggleAudioEnabled();
            this.soundButton.setTexture(audioEnabled ? (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.SOUND_ON : (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.SOUND_OFF);
        });
    }
    update(time, delta) {
        this.updateClouds();
    }
    updateClouds() {
        if (!this.clouds) return;
        this.clouds.getChildren().forEach((child)=>{
            //move child
            //@ts-ignore
            child.x += this.cloudMovementSpeed * this.game.loop.delta / 1000.0;
            //teleport if out of bounds
            //@ts-ignore
            if (child.x >= this.game.renderer.width) //@ts-ignore
            child.x -= 2 * this.game.renderer.width;
        });
    }
}
class $30cfeaa254875b8b$var$MenuButton extends Phaser.GameObjects.Container {
    constructor(scene, x, y, bgTexture, buttonText, onClick, fontSize = 40){
        super(scene, x, y);
        //create bg, create text
        this.bgImage = this.scene.add.image(0, 0, bgTexture);
        let text = this.scene.add.bitmapText(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FONT.ATLAS, buttonText, fontSize).setOrigin(0.5, 0.4);
        this.add([
            this.bgImage,
            text
        ]);
        scene.add.existing(this);
        this.setDepth(3);
        this.bgImage.on("pointerup", ()=>{
            onClick();
        });
        this.bgImage.on("pointerover", ()=>{
            this.animateButton(true);
        });
        this.bgImage.on("pointerout", ()=>{
            this.animateButton(false);
        });
        this.overrideInteractive(true);
    }
    animateButton(animIn) {
        if (this.buttonTween) this.buttonTween.stop();
        this.buttonTween = this.scene.tweens.add({
            targets: this,
            scaleX: animIn ? 1.05 : 1,
            scaleY: animIn ? 1.05 : 1,
            ease: "Quad.easeInOut",
            duration: 75,
            repeat: 0,
            yoyo: false
        });
    }
    overrideInteractive(interactive) {
        if (interactive) this.bgImage.setInteractive({
            useHandCursor: true,
            pixelPerfect: true
        });
        else this.bgImage.disableInteractive();
    }
}



class $7e3af3e6538b9494$export$ec537e24d5ef2139 extends Phaser.Scene {
    constructor(){
        super({
            key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.SOUNDTRACK
        });
    }
    create() {
        this.music = this.sound.add((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.SOUNDTRACK_SHORT, {
            loop: true,
            mute: false
        });
        this.music.play();
        this.registry.set((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.SOUNDTRACK, this);
    }
    pauseMusic(pause) {
        if (pause) this.music.pause();
        else this.music.resume();
    }
    //Called when actual soundtrack is loaded
    switchMusic() {
        var newMusic = this.sound.add((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.SOUNDTRACK, {
            loop: true,
            mute: false,
            seek: this.music.seek
        });
        newMusic.play();
        if (this.music.isPaused) newMusic.pause();
        newMusic.setSeek(this.music.seek);
        this.music.stop();
        this.music = newMusic;
    }
}




class $10435e2275358e18$export$ae09207a2c1c4714 {
    constructor(image, animationJson, animFPS = 60){
        this.animTimer = 0;
        this.isAnimating = false;
        this.loop = false;
        this.xOffset = 0;
        this.yOffset = 0;
        this.angleOffset = 0;
        this.scaleMultiplierX = 1;
        this.scaleMultiplierY = 1;
        this.xOverride = 0;
        this.yOverride = 0;
        this.image = image;
        this.animationJson = animationJson;
        this.animFPS = animFPS;
        this.animTimer = 0;
        this.isAnimating = false;
        this.duration = 1000 * animationJson.frames.length / animFPS;
        this.image.animation = this;
    }
    setLoop(loop) {
        this.loop = loop;
        return this;
    }
    setOffset(x, y) {
        this.xOffset = x;
        this.yOffset = y;
        return this;
    }
    setAngleOffset(angle) {
        this.angleOffset = angle;
        return this;
    }
    setScaleMultiplier(scaleMultiplierX, scaleMultiplierY = 0) {
        this.scaleMultiplierX = scaleMultiplierX;
        this.scaleMultiplierY = scaleMultiplierY === 0 ? scaleMultiplierX : scaleMultiplierY;
        return this;
    }
    setDepth(depth) {
        this.image.setDepth(depth);
        return this;
    }
    setScrollFactor(x, y) {
        this.image.setScrollFactor(x, y);
        return this;
    }
    setDraggable(input) {
        this.image.setInteractive({
            useHandCursor: true
        });
        input.setDraggable(this.image);
        return this;
    }
    setPositionOverride(x, y, overrideY = true) {
        this.xOverride = x;
        if (overrideY) this.yOverride = y;
        return this;
    }
    GetPositionOverride() {
        return {
            x: this.xOverride,
            y: this.yOverride
        };
    }
    GetOffset() {
        return {
            x: this.xOffset,
            y: this.yOffset
        };
    }
    update(delta) {
        if (this.isAnimating) {
            this.positionImageOnAnimation(this.animTimer);
            this.updateTimer(delta);
        }
    }
    updateTimer(delta) {
        this.animTimer += delta;
        if (this.animTimer >= this.duration) {
            if (this.loop) this.animTimer = 0;
            else this.isAnimating = false;
        }
    }
    start() {
        this.isAnimating = true;
        return this;
    }
    pause() {
        this.isAnimating = false;
        return this;
    }
    stop() {
        this.animTimer = 0;
        this.isAnimating = false;
        return this;
    }
    setAnimation(animationJson) {
        this.animationJson = animationJson;
        this.animTimer = 0;
        this.duration = 1000 * animationJson.frames.length / this.animFPS;
        return this;
    }
    positionImageOnAnimation(timer) {
        //Get frame
        var frameIndex = Math.floor(timer * (this.animFPS / 1000));
        if (frameIndex >= this.animationJson.frames.length) frameIndex = this.animationJson.frames.length - 1;
        var frame = this.animationJson.frames[frameIndex];
        //position image to frame
        this.image.setPosition(frame.x + this.xOffset + this.xOverride, frame.y + this.yOffset + this.yOverride).setScale(parseFloat(frame.scaleX) * this.scaleMultiplierX, parseFloat(frame.scaleY) * this.scaleMultiplierY).setAngle(parseFloat(frame.angle) + this.angleOffset);
    }
}



class $ecb7686a60e0dea3$export$2e2bcd8739ae039 extends Phaser.GameObjects.Container {
    constructor(scene, x, y){
        super(scene, x, y);
        this.opened = false;
        this.pointerOverButton = false;
        this.mainButton = this.createMainButton();
        this.innerContainer = this.createInnerContainer();
        this.updateDisplay();
        this.add([
            this.innerContainer,
            this.mainButton
        ]);
        scene.add.existing(this);
        this.setScale(0.75);
        this.setScrollFactor(0);
    }
    createMainButton() {
        let button = this.scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).HOME_BUTTON.NORMAL).setInteractive({
            useHandCursor: true,
            pixelPerfect: true,
            alphaTolerance: 1
        }).setScrollFactor(0);
        button.on("pointerup", ()=>{
            this.handleMainButtonClick();
        });
        button.on("pointerover", ()=>{
            this.pointerOverButton = true;
            this.updateDisplay();
        });
        button.on("pointerout", ()=>{
            this.pointerOverButton = false;
            this.updateDisplay();
        });
        return button;
    }
    handleMainButtonClick() {
        this.opened = !this.opened;
        this.updateDisplay();
    }
    createInnerContainer() {
        let bg = this.scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).HOME_BUTTON.BACKGROUND).setScrollFactor(0);
        let check_button = this.scene.add.image(-14.2, -4.4, (0, $15b72a9ad2952278$export$fadd21211b40c08a).HOME_BUTTON.CHECK).setScrollFactor(0);
        let check_highlight = this.createInnerButton(-11, -4.4, (0, $15b72a9ad2952278$export$fadd21211b40c08a).HOME_BUTTON.CHECK_HIGHLIGHT, ()=>{
            this.loadMenuScene();
        }).setScrollFactor(0);
        let x_button = this.scene.add.image(51, -3.7, (0, $15b72a9ad2952278$export$fadd21211b40c08a).HOME_BUTTON.X).setScrollFactor(0);
        let x_highlight = this.createInnerButton(51, -3.7, (0, $15b72a9ad2952278$export$fadd21211b40c08a).HOME_BUTTON.X_HIGHLIGHT, ()=>{
            this.handleMainButtonClick();
        }).setScrollFactor(0);
        let innerContainer = this.scene.add.container(92, 0).setScrollFactor(0);
        innerContainer.add([
            bg,
            check_button,
            check_highlight,
            x_button,
            x_highlight
        ]);
        return innerContainer;
    }
    createInnerButton(x, y, texture, onClick) {
        let button = this.scene.add.image(x, y, texture).setAlpha(0.01).setInteractive({
            useHandCursor: true,
            pixelPerfect: true,
            alphaTolerance: 0
        });
        button.on("pointerup", ()=>{
            onClick();
        });
        button.on("pointerover", ()=>{
            button.alpha = 1;
        });
        button.on("pointerout", ()=>{
            button.alpha = 0.01; //hack to keep interactivity on "invisible" image. Should be 0 though.
        });
        return button;
    }
    updateDisplay() {
        this.mainButton.setTexture(this.opened || this.pointerOverButton ? (0, $15b72a9ad2952278$export$fadd21211b40c08a).HOME_BUTTON.HIGHLIGHT : (0, $15b72a9ad2952278$export$fadd21211b40c08a).HOME_BUTTON.NORMAL);
        this.innerContainer.setVisible(this.opened);
    }
    addExitEvent(onExit) {
        this.onExit = onExit;
    }
    loadMenuScene() {
        if (this.onExit) this.onExit();
        this.scene.scene.start((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU);
    }
}




class $7bc149abaca018eb$export$a95ae84b8ab23d68 extends Phaser.Scene {
    constructor(options){
        super({
            key: options.sceneName
        });
        this.rewardedBreakRequested = false;
        this.sceneName = options.sceneName;
        this.nextScene = options.nextScene;
        this.duration = options.duration;
        this.showCountdown = typeof options.showCountdown === "undefined" ? true : options.showCountdown;
        this.showHomeButton = typeof options.showHomeButton === "undefined" ? true : options.showHomeButton;
        this.startScreenColor = options.startScreenColor;
        this.startText = options.startText;
        this.startTextYOrigin = typeof options.startTextYOrigin === "undefined" ? 0.25 : options.startTextYOrigin;
        this.startTextColor = options.startTextColor;
        this.failImage = !!options.endScreen ? options.endScreen : "";
        this.showSkipButton = typeof options.showSkipButton === "undefined" ? true : options.showSkipButton;
        this.timeToStart = typeof options.timeToStart === "undefined" ? 1000 : options.timeToStart; //options.timeToStart;
        this.buttonPositions = options.endButtons;
        this.waitingToLoad = false;
        this.isArcadeMinigame = typeof options.isArcadeMinigame === "undefined" ? false : options.isArcadeMinigame;
    }
    init() {
        this.animations = [];
        this.progressiveLoadScene = this.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PROGRESSIVE_LOAD);
        this.rewardedBreakRequested = false;
        this._init();
    }
    preload() {
        this._preload();
    }
    create() {
        this.saveProgress();
        this.createStartUI();
        this.createGameplayUI();
        this.createLoseUI();
        this.createLoadUI();
        this.changeGameState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.START);
        //This should trigger only on first minigame, other minigames should be loaded before creating them (see GAMESTATE.LOADNEXTLEVEL)
        var loaded = this.areAllAssetsLoaded();
        if (loaded) this._create();
        else this.waitingToLoad = true;
        if ((0, $ca2834f16a956c4f$export$29cd7b75162a9425).BuildLevel < (0, $ca2834f16a956c4f$export$5c5cddbd5caf0d99).Prod) this.skipKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.P);
        this.audioPlugin.beforeCommercialBreak();
        PokiSDK.commercialBreak().then(()=>{
            //console.log('End of commercial break');
            this.audioPlugin.afterCommercialBreak();
            //For first minigame only
            if (loaded) this.createStartTimer();
            else {
                this.createWaitingUI();
                this.waitingToLoad = true;
            }
        });
        if ((0, $ca2834f16a956c4f$export$29cd7b75162a9425).BuildLevel < (0, $ca2834f16a956c4f$export$5c5cddbd5caf0d99).Prod) this.debugText = this.add.text(0, 0, "0", {
            fontFamily: "bloggerSans",
            fontSize: 10,
            color: "#ffffff",
            align: "left"
        });
    }
    saveProgress() {
        if (this.isArcadeMinigame) return; //Don't save arcade games to progress!
        this.storagePlugin.setItem((0, $15b72a9ad2952278$export$fadd21211b40c08a).STORAGE_KEYS.PROGRESS, this.sceneName);
    }
    //For first minigame only
    createWaitingUI() {
        var spinner = this.add.image(this.game.renderer.width / 2, this.game.renderer.height - 50, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.SPINNER).setDepth(1002).setTint(this.startTextColor).setVisible(true);
        this.tweens.add({
            targets: spinner,
            angle: "+=360",
            duration: 1000,
            ease: "Linear",
            repeat: -1
        });
    }
    createStartUI() {
        var startBackground = this.add.graphics({
            fillStyle: {
                color: this.startScreenColor
            }
        }).fillRect(0, 0, this.game.renderer.width, this.game.renderer.height).setDepth(1000).setVisible(false);
        /* var startText = this.add
                .text(this.game.renderer.width / 2,
                        this.game.renderer.height/2,
                        this.startText,
                        { fontSize: "120px", color: this.startTextColor})
                .setOrigin(0.5)
                .setDepth(1001)
                .setVisible(false);
        */ var startText = this.add.bitmapText(this.game.renderer.width / 2, this.game.renderer.height / 2, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FONT.ATLAS, this.startText, 150).setOrigin(0.5, this.startTextYOrigin).setDepth(1001).setVisible(false).setTint(this.startTextColor).setCenterAlign();
        this.startUI = this.add.group([
            startBackground,
            startText
        ], {
            active: false
        });
        this.startUI.getChildren().forEach((child)=>{
            child.setScrollFactor(0);
        });
    }
    createGameplayUI() {
        //Generate progressBar
        this.progressBar = this.add.graphics({
            fillStyle: {
                color: 0x151515,
                alpha: this.showCountdown ? 0.7 : 0
            }
        }).fillRect(0, 0, this.game.renderer.width, 14).setDepth(100).setVisible(false);
        this.progressBarBackground = this.add.graphics({
            fillStyle: {
                color: 0x292929,
                alpha: this.showCountdown ? 0.30 : 0
            }
        }).fillRect(0, 0, this.game.renderer.width, 14).setDepth(99).setVisible(false);
        this.gameplayUI = this.add.group([
            this.progressBar,
            this.progressBarBackground
        ], {
            active: false
        });
        this.gameplayUI.getChildren().forEach((child)=>{
            child.setScrollFactor(0);
        });
    }
    createLoseUI() {
        var elements = [];
        if (this.failImage != "") {
            let loseImage = this.add.image(0, 0, this.failImage).setOrigin(0, 0).setDepth(1002).setVisible(false);
            elements.push(loseImage);
        }
        if (this.showHomeButton && this.remoteConf.getConfig("hBe") === "true") {
            let homeButton = new (0, $ecb7686a60e0dea3$export$2e2bcd8739ae039)(this, 40, 40).setDepth(1005).setVisible(false).setScrollFactor(0, 0, true);
            elements.push(homeButton);
        }
        if (!this.showSkipButton || this.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).REGISTRY.ADBLOCKENABLED)) {
            let normalNoSkipButton = this.addButton(this.buttonPositions.normalNoSkip.x, this.buttonPositions.normalNoSkip.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.TRYAGAIN, this.buttonPositions.normalNoSkip.scale, ()=>{
                this.restartGame();
            });
            elements.push(normalNoSkipButton);
        } else {
            let normalWithSkipButton = this.addButton(this.buttonPositions.normalWithSkip.x, this.buttonPositions.normalWithSkip.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.TRYAGAIN, this.buttonPositions.normalWithSkip.scale, ()=>{
                this.restartGame();
            });
            elements.push(normalWithSkipButton);
            let skipButton = this.addButton(this.buttonPositions.skip.x, this.buttonPositions.skip.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.SKIP, this.buttonPositions.skip.scale, ()=>{
                this.skipLevel();
            });
            elements.push(skipButton);
        }
        this.getCustomLoseUIElements().forEach((el)=>{
            el.setVisible(false).setDepth(el.depth + 1003);
            elements.push(el);
        });
        this.loseUI = this.add.group(elements, {
            active: false
        });
        this.loseUI.getChildren().forEach((child)=>{
            child.setScrollFactor(0);
        });
    }
    getCustomLoseUIElements() {
        return [];
    }
    createLoadUI() {
        var ns = this.scene.get(this.nextScene);
        var loadBackground = this.add.graphics({
            fillStyle: {
                color: ns.startScreenColor
            }
        }).fillRect(0, 0, this.game.renderer.width, this.game.renderer.height).setDepth(1000).setVisible(false);
        var loadText = this.add.bitmapText(this.game.renderer.width / 2, this.game.renderer.height / 2, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FONT.ATLAS, ns.startText, 150).setOrigin(0.5, ns.startTextYOrigin).setDepth(1001).setVisible(false).setTint(ns.startTextColor).setCenterAlign();
        var spinner = this.add.image(this.game.renderer.width / 2, this.game.renderer.height - 50, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.SPINNER).setDepth(1002).setTint(ns.startTextColor).setVisible(false);
        this.tweens.add({
            targets: spinner,
            angle: "+=360",
            duration: 1000,
            ease: "Linear",
            repeat: -1
        });
        this.loadUI = this.add.group([
            loadBackground,
            loadText,
            spinner
        ], {
            active: false
        });
        this.loadUI.getChildren().forEach((child)=>{
            child.setScrollFactor(0);
        });
    }
    addButton(x, y, key, scale, onClick) {
        let normalNoSkipButton = this.add.image(x, y, key).setScale(scale, scale).setVisible(false).setDepth(1003).setInteractive({
            useHandCursor: true
        });
        normalNoSkipButton.on("pointerdown", onClick, this);
        return normalNoSkipButton;
    }
    changeGameState(newState) {
        var isNewStateValid = true;
        if (newState === this.currentState) isNewStateValid = false;
        //Handle state enter and check if new state is valid
        switch(newState){
            case (0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.START:
                this.setChildrenVisible(this.startUI, true);
                break;
            case (0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING:
                PokiSDK.gameplayStart();
                this.setChildrenVisible(this.gameplayUI, true);
                break;
            case (0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.LOSE:
                break;
            case (0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.WIN:
                break;
            case (0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.LOADNEXTLEVEL:
                this.setChildrenVisible(this.loadUI, true);
                break;
            default:
                //console.log("Can't switch to invalid state: " + newState)
                isNewStateValid = false;
                break;
        }
        if (!isNewStateValid) return;
        //Handle state exit
        switch(this.currentState){
            case (0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.START:
                this.setChildrenVisible(this.startUI, false);
                break;
            case (0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING:
                PokiSDK.gameplayStop();
                this.setChildrenVisible(this.gameplayUI, false);
                break;
            case (0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.LOSE:
                this.setChildrenVisible(this.loseUI, false);
                break;
            case (0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.WIN:
                break;
        }
        this.currentState = newState;
    //console.log("Minigame state changed to: " + this.currentState);
    }
    showLoseUI(show) {
        this.setChildrenVisible(this.loseUI, show);
    }
    setChildrenVisible(group, visible) {
        //@ts-ignore
        group.getChildren().forEach((child)=>{
            child.setVisible(visible);
        });
    }
    update(time, delta) {
        if ((0, $ca2834f16a956c4f$export$29cd7b75162a9425).BuildLevel < (0, $ca2834f16a956c4f$export$5c5cddbd5caf0d99).Prod) {
            if (Phaser.Input.Keyboard.JustDown(this.skipKey)) {
                (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("Skip level pressed");
                this.clearTimers();
                this.winGame();
            }
            this.debugText.setText(JSON.stringify({
                "this.matter.world.engine.timing": this.matter.world.engine.timing,
                "this.game.loop": Phaser.Utils.Objects.Pick(this.game.loop, [
                    "delta"
                ]),
                "FPS": 1000 / this.game.loop.delta
            }, null, 2));
        }
        //For first minigame only
        if (this.waitingToLoad) {
            if (this.areAllAssetsLoaded()) {
                this.waitingToLoad = false;
                this.restartGame();
            }
            return;
        }
        if (this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) this.updateGameplayTimer();
        if (this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.LOADNEXTLEVEL)) {
            if (this.areAllAssetsLoaded(this.nextScene)) this.loadNextScene();
        }
        this._update(time, delta);
        this.updateAnimations(delta);
    }
    updateGameplayTimer() {
        if (!this.gameplayTimer) return;
        //update progress bar
        this.progressBar.setX(-this.game.renderer.width * this.gameplayTimer.getProgress()).setVisible(true);
    }
    updateAnimations(delta) {
        this.animations.forEach((anim)=>{
            anim.update(delta);
        });
    }
    createStartTimer() {
        this.startTimer = this.time.addEvent({
            delay: this.timeToStart,
            callback: this.startGame,
            callbackScope: this
        });
    }
    startGame() {
        this.changeGameState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING);
        this.onGameStarted();
        this.clearTimers();
        this.gameplayTimer = this.time.addEvent({
            delay: this.duration,
            callback: this.triggerTimeout,
            callbackScope: this
        });
        this.analyticsPlugin.addGameStartEvent(this.sceneName);
    }
    onGameStarted() {}
    triggerTimeout() {
        this.clearTimers();
        this._timeout();
    }
    clearTimers() {
        if (this.startTimer) {
            this.startTimer.paused = true;
            this.startTimer.remove();
        }
        if (this.gameplayTimer) {
            this.gameplayTimer.paused = true;
            this.gameplayTimer.remove();
        }
        if (this.winGameTimer) {
            this.winGameTimer.paused = true;
            this.winGameTimer.remove();
        }
    }
    //winGame, load next level after delay
    winGame(animationDelay = 0) {
        this.changeGameState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.WIN);
        this.clearTimers();
        this.winGameTimer = this.time.addEvent({
            delay: animationDelay,
            callback: this.handleWinGame,
            callbackScope: this
        });
        this.analyticsPlugin.addGameWinEvent(this.sceneName);
    }
    //Win animation ended
    handleWinGame() {
        PokiSDK.happyTime(0.5);
        this._afterWin();
        this.loadNextScene();
    }
    loadNextScene() {
        if (this.areAllAssetsLoaded(this.nextScene)) {
            this.scene.stop(this.sceneName);
            this.scene.start(this.nextScene);
        } else this.changeGameState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.LOADNEXTLEVEL);
    }
    loseGame(animationDelay = 0) {
        this.changeGameState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.LOSE);
        this.clearTimers();
        this.winGameTimer = this.time.addEvent({
            delay: animationDelay,
            callback: this.handleLoseGame,
            callbackScope: this
        });
        this.analyticsPlugin.addGameLoseEvent(this.sceneName);
    }
    //Lose animation ended
    handleLoseGame() {
        this.showLoseUI(true);
        this._afterLoss();
    }
    restartGame(arcadeVideoCompleted = false) {
        if (!arcadeVideoCompleted && this.rewardedBreakRequested) return;
        this.scene.stop(this.sceneName);
        this.scene.start(this.sceneName);
    }
    skipLevel() {
        if (this.rewardedBreakRequested) return;
        this.rewardedBreakRequested = true;
        this.audioPlugin.beforeCommercialBreak();
        PokiSDK.rewardedBreak().then((adCompleted)=>{
            this.audioPlugin.afterCommercialBreak();
            //skip level if ad completed!
            if (adCompleted) {
                this.analyticsPlugin.addRewardedAdFinishedEvent(true);
                this.loadNextScene();
                this.registry.set((0, $15b72a9ad2952278$export$fadd21211b40c08a).REGISTRY.SKIPUSED, true);
            } else {
                this.rewardedBreakRequested = false;
                // console.log("Ad failed!")
                this.analyticsPlugin.addRewardedAdFinishedEvent(false);
            }
        });
    }
    arcadeContinueLevel(levelData) {
        if (this.rewardedBreakRequested) return;
        this.rewardedBreakRequested = true;
        this.audioPlugin.beforeCommercialBreak();
        PokiSDK.rewardedBreak().then((adCompleted)=>{
            this.audioPlugin.afterCommercialBreak();
            //skip level if ad completed!
            if (adCompleted) {
                this.analyticsPlugin.addRewardedAdFinishedEvent(true);
                this.storagePlugin.setItem(this.sceneName + "restart", JSON.stringify(levelData));
                this.restartGame(true);
            } else {
                this.rewardedBreakRequested = false;
                console.log("Ad failed!");
                this.analyticsPlugin.addRewardedAdFinishedEvent(false);
            }
        });
    }
    isCurrentState(state) {
        return this.currentState === state;
    }
    changeGameplayTimerDuration(change) {
        if (!this.gameplayTimer) return;
        this.gameplayTimer.elapsed -= change;
    }
    addAnimation(imageKey, jsonKey, fps = 60) {
        let image = this.add.image(0, 0, imageKey).setScale(0, 0);
        let json = this.cache.json.get(jsonKey);
        var animation = new (0, $10435e2275358e18$export$ae09207a2c1c4714)(image, json, fps);
        this.animations.push(animation);
        return animation;
    }
    getUnityY(phaserY) {
        return 4.5 - phaserY * 9 / 480;
    }
    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    getDetune() {
        return this.getRandomInt(-200, 200);
    }
    areAllAssetsLoaded(scene = this.sceneName) {
        return this.progressiveLoadScene.isSceneLoaded(scene);
    }
    setHighscore(score) {
        this.storagePlugin.setItem(this.getHighscoreKey(), score.toString());
    }
    getHighscore() {
        var highscore = this.storagePlugin.getItem(this.getHighscoreKey(), "");
        if (highscore) return parseInt(highscore);
        else return -1;
    }
    getHighscoreKey() {
        return this.sceneName + "highscore";
    }
    sendFinalScoreAnalyticsEvent(score) {
        this.analyticsPlugin.addFinalScoreEvent(this.sceneName, score);
    // console.log("final score event " + this.sceneName + ":FinalScore " + score);
    }
    setDebugDraggable(image) {
        image.setInteractive({
            useHandCursor: true,
            draggable: true
        });
        image.on("drag", (pointer, dragX, dragY)=>{
            image.setPosition(dragX, dragY);
        });
        image.on("dragend", (pointer, dragX, dragY, dropped)=>{
            (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("Image position: {x: " + image.x + ", y: " + image.y + "}");
        });
    }
}


class $ffdb1caf6db2742b$export$d42c6d2da3053304 extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BIRTH,
            duration: 7500,
            startScreenColor: 0xC1FFDB,
            startText: "GET BORN!",
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.END,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.TALK,
            endButtons: {
                normalNoSkip: {
                    x: 426.5,
                    y: 411,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 283,
                    y: 411,
                    scale: 1.30
                },
                skip: {
                    x: 570,
                    y: 411,
                    scale: 1.30
                }
            }
        });
        this.mamice = [];
        //values
        this.clickableWidth = 100;
        this.missTimePunishment = 250;
        this.clickerSwingTime = 825 //in ms
        ;
        this.swingStartX = 277;
        this.swingEndX = 807;
        this.babyPositions = [
            {
                rot: 80,
                x: 242,
                y: 257
            },
            {
                rot: 90,
                x: 262,
                y: 263
            },
            {
                rot: 89,
                x: 275,
                y: 263
            },
            {
                rot: 87,
                x: 289,
                y: 265
            },
            {
                rot: 87,
                x: 301,
                y: 263
            }
        ];
    }
    _init() {
        this.clickerMovingRight = true;
        this.swingTimer = 0;
        this.hits = 0;
        this.mamice = [];
    }
    _preload() {}
    _create() {
        let background = this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.BACKGROUND).setOrigin(0, 0);
        background.setInteractive();
        background.on("pointerdown", ()=>{
            this.handleClick();
        });
        this.baby = this.add.image(301, 266, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.BABY).setAngle(87.5).setScale(0.67, 0.67);
        this.add.image(145, 433, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.PUSH);
        this.add.image(717, 262, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.STROLLER).setDepth(100);
        this.swing = this.add.image(542, 429, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.SWING);
        this.clicker = this.add.image(542, 429, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.CLICKER);
        this.createMamice(226, 299);
        this.setMamicaState(this.hits);
        this.winAudio = this.sound.add((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.CRY, {
            loop: false
        });
    }
    createMamice(x, y) {
        var mamicePaths = [
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.MAMICA1,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.MAMICA2,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.MAMICA3,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.MAMICA4,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.MAMICA5
        ];
        mamicePaths.forEach((path)=>{
            this.mamice.push(this.add.image(x, y, path).setVisible(false).setDepth(150));
        });
    }
    setMamicaState(index) {
        if (index >= this.mamice.length) {
            this.triggerWin();
            return;
        }
        for(var i = 0; i < this.mamice.length; i++)this.mamice[i].setVisible(i === index);
        //console.log("setting mamica state" + index);
        this.baby.setPosition(this.babyPositions[index].x, this.babyPositions[index].y).setAngle(this.babyPositions[index].rot);
    }
    _update(time, delta) {
        if (this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) this.moveClicker(delta);
        else if (this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.WIN)) {
            if (!this.babyFollow) return;
            this.babyFollow.update(delta);
        }
    }
    moveClicker(delta) {
        if (this.clickerMovingRight) {
            this.swingTimer += delta / this.clickerSwingTime;
            if (this.swingTimer >= 1) {
                this.clickerMovingRight = !this.clickerMovingRight;
                this.swingTimer = 1;
            }
        } else {
            this.swingTimer -= delta / this.clickerSwingTime;
            if (this.swingTimer <= 0) {
                this.clickerMovingRight = !this.clickerMovingRight;
                this.swingTimer = 0;
            }
        }
        this.clicker.x = Phaser.Math.Interpolation.SmoothStep(this.swingTimer, this.swingStartX, this.swingEndX);
    }
    handleClick() {
        if (this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) {
            //console.log("clicked within limits " + this.isClickerWithinLimits());
            if (this.isClickerWithinLimits()) {
                this.hits++;
                this.setMamicaState(this.hits);
            } else {
                this.changeGameplayTimerDuration(-this.missTimePunishment);
                this.cameras.main.flash(200, 255, 64, 43);
            }
        }
    }
    isClickerWithinLimits() {
        return Phaser.Math.Difference(this.clicker.x, this.swing.x) < this.clickableWidth;
    }
    _timeout() {
        this.loseGame();
    }
    _afterLoss() {}
    _afterWin() {
        this.winAudio.stop();
    }
    triggerWin() {
        this.winGame(1500);
        this.winAnim();
        this.winAudio.play();
    }
    winAnim() {
        var path = new Phaser.Curves.Path(310, 256).splineTo([
            527,
            129,
            733,
            246
        ]);
        this.babyFollow = this.add.follower(path, 0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.BABY).setAngle(87.5).setScale(0.67, 0.67);
        this.babyFollow.startFollow({
            positionOnPath: true,
            duration: 1000,
            rotateToPath: false,
            from: 0,
            to: 1
        });
        this.babyFollow.lifeTimer = 0;
        this.babyFollow.update = function(delta) {
            this.lifeTimer += delta;
            if (this.lifeTimer > 1000) return;
            this.setAngle(this.angle + 360 * delta / 1000);
        //console.log("baby update");
        };
        this.baby.setVisible(false);
    }
}




class $9334cc922d718eb2$export$c5fb64a6647e1351 extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.SCHOOL,
            duration: 8750,
            startScreenColor: 0xFDC379,
            startText: "STUDY!",
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.END,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PUBERTY,
            endButtons: {
                normalNoSkip: {
                    x: 426.5,
                    y: 386,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 283,
                    y: 386,
                    scale: 1.30
                },
                skip: {
                    x: 570,
                    y: 386,
                    scale: 1.30
                }
            }
        });
        //values
        this.noteValues = [
            {
                x: 505,
                y: 189,
                path: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.NOTE_3
            },
            {
                x: 594,
                y: 195,
                path: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.NOTE_4
            },
            {
                x: 605,
                y: 355,
                path: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.NOTE_17
            },
            {
                x: 693,
                y: 289,
                path: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.NOTE_20
            },
            {
                x: 703,
                y: 369,
                path: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.NOTE_27
            },
            {
                x: 540,
                y: 285,
                path: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.NOTE_H2NO
            },
            {
                x: 695,
                y: 206,
                path: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.NOTE_YES
            }
        ];
        this.endPoints = [
            {
                x: 265,
                y: 276,
                note: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.NOTE_3
            },
            {
                x: 316,
                y: 183,
                note: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.NOTE_17
            },
            {
                x: 305,
                y: 343,
                note: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.NOTE_20
            }
        ];
        this.maxEndDistance = 54 //in pixels
        ;
        this.animFPS = 60;
        //logic vars
        this.animTimer = 0;
        this.notes = [];
        this.isAnimating = false;
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.notes = [];
        this.animTimer = 0;
        this.isAnimating = false;
    }
    _preload() {}
    _create() {
        this.add.image(456, 240, (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.BACKGROUND);
        this.boyImage = this.add.image(425, 394, (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.BOY).setDepth(100);
        this.createNotes();
        this.endAnimation = this.cache.json.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.SCHOOLEND);
    }
    createNotes() {
        this.noteValues.forEach((noteValue)=>{
            this.notes.push(this.add.image(noteValue.x, noteValue.y, noteValue.path).setDepth(50).setInteractive(this.input.makePixelPerfect(50)));
        });
        //Create notes draggable
        this.notes.forEach((note)=>{
            this.input.setDraggable(note);
        });
        this.input.on("dragstart", function(pointer, gameObject) {
            this.children.bringToTop(gameObject);
            this.children.bringToTop(this.boyImage);
            this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
                detune: this.getDetune()
            });
        }, this);
        this.input.on("drag", function(pointer, gameObject, dragX, dragY) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });
        this.input.on("dragend", function(pointer, gameObject, dropped) {
            this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
                detune: this.getDetune()
            });
        }, this);
    }
    _update(time, delta) {
        if (this.isAnimating) {
            this.animTimer += delta;
            this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimation);
        }
    }
    _timeout() {
        this.checkForWin();
    }
    checkForWin() {
        var isSolved = true;
        this.endPoints.forEach((endPoint)=>{
            for(var i = 0; i < this.notes.length; i++){
                var currentNote = this.notes[i];
                if (currentNote.texture.key === endPoint.note) {
                    var distance = Phaser.Math.Distance.Between(currentNote.x, currentNote.y, endPoint.x, endPoint.y);
                    if (distance > this.maxEndDistance) isSolved = false;
                }
            }
        });
        if (isSolved) this.triggerWin();
        else this.triggerLoss();
    }
    _afterLoss() {
        this.notes.forEach((note)=>{
            note.setVisible(false);
        });
        this.boyImage.setVisible(false);
        if (!this.endImage) return;
        this.endImage.setVisible(false);
    }
    _afterWin() {
        if (!this.endImage) return;
        this.endImage.setVisible(false);
    }
    triggerLoss() {
        this.loseGame(1500);
        this.endGameAnim(false);
    }
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.winGame(1500);
        this.endGameAnim(true);
        this.children.bringToTop(this.endImage);
    }
    endGameAnim(win) {
        var imageKey = win ? (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.WINIMAGE : (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL.LOSEIMAGE;
        this.endImage = this.add.image(0, 0, imageKey).setScale(0, 0).setDepth(900);
        this.animTimer = 0;
        this.isAnimating = true;
    }
    positionImageOnAnimation(timer, image, animation, xOffset = 0, yOffset = 0, angleOffset = 0, scaleMultiplier = 1) {
        //Get frame
        var frameIndex = Math.floor(timer * (this.animFPS / 1000));
        if (frameIndex >= animation.frames.length) frameIndex = animation.frames.length - 1;
        var frame = animation.frames[frameIndex];
        //position image to frame
        image.setPosition(frame.x + xOffset, frame.y + yOffset).setScale(parseFloat(frame.scaleX) * scaleMultiplier, parseFloat(frame.scaleY) * scaleMultiplier).setAngle(parseFloat(frame.angle) + angleOffset);
    }
}




class $55a4f57c2002ed7f$export$c5ecf9bedad0bf2e extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PUBERTY,
            duration: 15000,
            startScreenColor: 0xF4C1FF,
            startText: "PUBERTY!",
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PUBERTY.END,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.FINDHER,
            endButtons: {
                normalNoSkip: {
                    x: 426.5,
                    y: 411,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 283,
                    y: 411,
                    scale: 1.30
                },
                skip: {
                    x: 570,
                    y: 411,
                    scale: 1.30
                }
            }
        });
        this.animationAngle = 0;
        //values
        this.startSpawnRateDelay = 250 //Add delay to spawn rate at the beginning to make it a little bit easier
        ;
        this.timeToMaxSpawnRate = 4000;
        this.spawnRate = {
            min: 330,
            max: 700
        };
        this.pimpleSize = {
            start: 0.2,
            end: 1
        };
        this.pimpleTimeToSplash = 2500;
        this.pimpleTimeToDestroy = 300;
        this.animFPS = 60;
        this.spawnAreas = [
            {
                x1: 325,
                x2: 515,
                y1: 200,
                y2: 415
            },
            {
                x1: 290,
                x2: 325,
                y1: 200,
                y2: 390
            },
            {
                x1: 250,
                x2: 290,
                y1: 220,
                y2: 330
            },
            {
                x1: 515,
                x2: 560,
                y1: 260,
                y2: 390
            },
            {
                x1: 560,
                x2: 600,
                y1: 220,
                y2: 350
            },
            {
                x1: 330,
                x2: 380,
                y1: 160,
                y2: 200
            }
        ];
        //logic vars
        this.spawnTimer = 0;
        this.pimples = [];
        this.spawnRateTimer = 0;
        this.animTimer = 0;
        this.isAnimating = false;
        var spawnAreaSum = 0;
        this.spawnAreas.forEach((spawnArea)=>{
            spawnAreaSum += (spawnArea.x2 - spawnArea.x1) * (spawnArea.y2 - spawnArea.y1);
            spawnArea.areaSum = spawnAreaSum;
        });
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.spawnTimer = 0;
        this.spawnRateTimer = 0;
        this.pimples = [];
        this.animTimer = 0;
        this.isAnimating = false;
    }
    _preload() {}
    _create() {
        this.input.topOnly = false;
        this.add.image(442, 380, (0, $15b72a9ad2952278$export$fadd21211b40c08a).PUBERTY.BACKGROUND).setScale(1.252, 1.252).setDepth(0);
        this.add.image(135, 424, (0, $15b72a9ad2952278$export$fadd21211b40c08a).PUBERTY.POP_TEXT).setDepth(1);
        this.createParticles();
        this.endAnimation = this.cache.json.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.PUBERTYEND);
    //spawn area vizualization
    /*this.spawnAreas.forEach((spawnArea) => {
            this.add.graphics({fillStyle: {color: 0x0000ff, alpha: 0.4}})
                    .fillRect(spawnArea.x1, spawnArea.y1, spawnArea.x2-spawnArea.x1, spawnArea.y2-spawnArea.y1);
        })*/ }
    createParticles() {
        var particles = this.add.particles((0, $15b72a9ad2952278$export$fadd21211b40c08a).PUBERTY.PARTICLE).setDepth(9);
        var popParticleConfig = {
            active: true,
            visible: true,
            on: false,
            frequency: -1,
            gravityY: 1000,
            timeScale: 1,
            blendMode: 0,
            accelerationY: -200,
            lifespan: 500,
            scale: {
                start: 1,
                end: 0,
                ease: "Quad.easeOut"
            },
            speed: {
                min: -530,
                max: 530,
                ease: "Linear"
            }
        };
        var failParticleConfig = {
            active: true,
            visible: true,
            on: false,
            radial: true,
            frequency: 50,
            maxParticles: 200,
            gravityY: 1000,
            timeScale: 1,
            blendMode: 0,
            accelerationY: -100,
            quantity: 2,
            lifespan: 2000,
            scale: {
                start: 1,
                end: 0,
                ease: "Quad.easeOut"
            },
            speed: {
                min: -530,
                max: 530,
                ease: "Linear"
            }
        };
        this.popParticles = particles.createEmitter(popParticleConfig);
        this.failParticles = particles.createEmitter(failParticleConfig);
    }
    _update(time, delta) {
        if (this.isAnimating) {
            this.animTimer += delta;
            this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimation, 0, 250, this.animationAngle, 1.1);
        }
        if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
        this.spawnTimer -= delta;
        if (this.spawnTimer <= 0) {
            this.spawnTimer = this.calculateNewTimer();
            this.spawnPimple();
        }
        if (this.spawnRateTimer < 1) this.spawnRateTimer += delta / this.timeToMaxSpawnRate;
        this.pimples.forEach((pimple)=>{
            pimple.update(delta);
        });
    }
    calculateNewTimer() {
        return (1 - this.spawnRateTimer) * this.startSpawnRateDelay + this.spawnRate.min + Math.random() * (this.spawnRate.max - this.spawnRate.min);
    }
    spawnPimple() {
        var spawnPos = this.calculateNewSpawnPosition();
        //("spawning pimple " + spawnPos.x + " " + spawnPos.y);
        var pimple = this.add.image(spawnPos.x, spawnPos.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).PUBERTY.PIMPLE).setDepth(10).setInteractive({
            useHandCursor: true
        }).setScale(this.pimpleSize.start, this.pimpleSize.start);
        pimple.on("pointerdown", ()=>{
            pimple.destroy();
        });
        pimple.lifeTime = 0;
        pimple.deathTime = 0;
        pimple.deathSize = 1;
        pimple.isAlive = true;
        pimple.failed = false;
        pimple.update = (delta)=>{
            if (pimple.isAlive) {
                //Increase pimple size if alive
                pimple.lifeTime += delta;
                if (pimple.lifeTime > this.pimpleTimeToSplash) {
                    pimple.failed = true;
                    pimple.destroy();
                    return;
                }
                var newScale = this.pimpleSize.start + pimple.lifeTime / this.pimpleTimeToSplash * (this.pimpleSize.end - this.pimpleSize.start);
                pimple.setScale(newScale, newScale);
            } else {
                //Pop pimple if dead!
                pimple.deathTime += delta;
                if (pimple.deathTime > this.pimpleTimeToDestroy) {
                    pimple.setVisible(false);
                    return;
                }
                var newScale = pimple.deathSize - pimple.deathTime / this.pimpleTimeToDestroy * pimple.deathSize;
                pimple.setScale(newScale, newScale);
            }
        };
        pimple.destroy = ()=>{
            if (!pimple.isAlive) return;
            pimple.isAlive = false;
            pimple.setInteractive(false);
            pimple.deathSize = pimple.scaleX;
            if (pimple.failed) {
                pimple.setVisible(false);
                this.triggerLoss();
                this.failParticles.setPosition(pimple.x, pimple.y).start();
            } else {
                this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.POP, {
                    detune: this.getDetune()
                });
                this.popParticles.explode(30, pimple.x, pimple.y);
            }
        };
        this.pimples.push(pimple);
    }
    calculateNewSpawnPosition() {
        var spawnAreaSum = this.spawnAreas[this.spawnAreas.length - 1].areaSum;
        var randomArea = Math.floor(Math.random() * spawnAreaSum);
        for(var i = 0; i < this.spawnAreas.length; i++){
            if (this.spawnAreas[i].areaSum >= randomArea) return {
                x: this.randomIntFromInterval(this.spawnAreas[i].x1, this.spawnAreas[i].x2),
                y: this.randomIntFromInterval(this.spawnAreas[i].y1, this.spawnAreas[i].y2)
            };
        }
    }
    randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    _timeout() {
        this.triggerWin();
    }
    _afterLoss() {}
    _afterWin() {}
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.winGame(2300);
        this.animationAngle = 0;
        this.endGameAnim();
    }
    triggerLoss() {
        this.loseGame(1500);
        this.animationAngle = 180;
        this.endGameAnim();
    }
    endGameAnim() {
        this.endImage = this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).PUBERTY.BRACES).setScale(0, 0).setDepth(5);
        this.animTimer = 0;
        this.isAnimating = true;
    }
    positionImageOnAnimation(timer, image, animation, xOffset = 0, yOffset = 0, angleOffset = 0, scaleMultiplier = 1) {
        //Get frame
        var frameIndex = Math.floor(timer * (this.animFPS / 1000));
        if (frameIndex >= animation.frames.length) frameIndex = animation.frames.length - 1;
        var frame = animation.frames[frameIndex];
        //position image to frame
        image.setPosition(frame.x + xOffset, frame.y + yOffset).setScale(parseFloat(frame.scaleX) * scaleMultiplier, parseFloat(frame.scaleY) * scaleMultiplier).setAngle(parseFloat(frame.angle) + angleOffset);
    }
}




class $33500910613e6aaf$export$4a2ac4fa72bb5140 extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.TALK,
            duration: 17000,
            startScreenColor: 0xC1FFFF,
            startText: "TALK!",
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.END,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.SCHOOL,
            endButtons: {
                normalNoSkip: {
                    x: 505,
                    y: 411,
                    scale: 1.25
                },
                normalWithSkip: {
                    x: 362,
                    y: 411,
                    scale: 1.25
                },
                skip: {
                    x: 649,
                    y: 411,
                    scale: 1.25
                }
            }
        });
        //values
        this.timeToReachMaxSpeed = 7000;
        this.maxSpeed = 426.5;
        this.noteScrollOffset = 70;
        this.maxAllowedNoteMisses = 1;
        this.notePositions = [
            {
                x: 490,
                y: 281,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_4
            },
            {
                x: 638,
                y: 124,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_3
            },
            {
                x: 799,
                y: 285,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_2
            },
            {
                x: 968,
                y: 127,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_1
            },
            {
                x: 1274,
                y: 265,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_4
            },
            {
                x: 1137,
                y: 190,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_2
            },
            {
                x: 1660,
                y: 117,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_3
            },
            {
                x: 1777,
                y: 256,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_2
            },
            {
                x: 1914,
                y: 189,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_4
            },
            {
                x: 2135,
                y: 112,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_3
            },
            {
                x: 2318,
                y: 283,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_1
            },
            {
                x: 2463,
                y: 148,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_2
            },
            {
                x: 2608,
                y: 283,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_3
            },
            {
                x: 2901,
                y: 143,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_4
            },
            {
                x: 3099,
                y: 265,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_3
            },
            {
                x: 3326,
                y: 139,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_1
            },
            {
                x: 3563,
                y: 281,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_4
            },
            {
                x: 3751,
                y: 287,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_3
            },
            {
                x: 3929,
                y: 284,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_1
            },
            {
                x: 4181,
                y: 209,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_4
            },
            {
                x: 4426,
                y: 130,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_3
            },
            {
                x: 4657,
                y: 215,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_2
            },
            {
                x: 4851,
                y: 293,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_1
            },
            {
                x: 5024,
                y: 187,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_3
            },
            {
                x: 5254,
                y: 284,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_3
            },
            {
                x: 5425,
                y: 91,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_2
            },
            {
                x: 5609,
                y: 95,
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_1
            }
        ];
        //logic vars
        this.timer = 0;
        this.speed = 0;
        this.notes = [];
        this.reachedEnd = false;
        this.missedNoteCount = 0;
        this.onGameStarted = ()=>{
            this.audio.play();
        };
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.timer = 0;
        this.speed = 0;
        this.missedNoteCount = 0;
        this.notes = [];
        this.reachedEnd = false;
    }
    _preload() {}
    _create() {
        this.cameras.main.setBounds(0, 0, 8000, 480);
        this.add.image(6664, 240, (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.ENDSTRETCH).setScale(578, 1);
        this.add.image(3449, 240, (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.STRETCHBACKGROUND).setScale(33.148, 1);
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.STARTBACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(252, 89, (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.TAP);
        this.add.image(5763, 240, (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.ENDBACKGROUND);
        this.add.image(6091, 305, (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.SMILE).setScale(0.15, 0.15).setAngle(9.6);
        this.createNotes();
        this.audio = this.sound.add((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.TALK, {
            loop: false
        });
    }
    createNotes() {
        this.notePositions.forEach((notePos)=>{
            var note = this.add.image(notePos.x, notePos.y, notePos.key).setScale(0.86, 0.86).setInteractive().setDepth(10);
            note.isAlive = true;
            note.on("pointerdown", ()=>{
                this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.POP, {
                    detune: this.getDetune(),
                    volume: 0.5
                });
                note.kill();
            });
            note.kill = ()=>{
                note.playDeathAnimation();
                note.isAlive = false;
            };
            note.update = (delta)=>{
                if (note.isAlive) note.checkBounds();
            };
            note.checkBounds = ()=>{
                if (note.x < this.cameras.main.scrollX - this.noteScrollOffset) {
                    //Note has been missed 
                    if (this.missedNoteCount < this.maxAllowedNoteMisses) {
                        this.missedNoteCount++;
                        note.kill();
                    } else this.triggerLoss();
                }
            };
            note.playDeathAnimation = ()=>{
                //Rotation
                this.tweens.timeline({
                    tweens: [
                        {
                            targets: note,
                            angle: "-=14",
                            duration: 116,
                            ease: "Sine.easeInOut"
                        },
                        {
                            targets: note,
                            angle: "+=180",
                            duration: 300,
                            ease: "Sine.easeIn"
                        }
                    ]
                });
                //Scale:
                this.tweens.timeline({
                    tweens: [
                        {
                            targets: note,
                            scaleX: "*=1.5",
                            scaleY: "*=1.5",
                            duration: 116,
                            ease: "Sine.easeInOut"
                        },
                        {
                            targets: note,
                            scaleX: 0,
                            scaleY: 0,
                            duration: 300,
                            ease: "Sine.easeIn"
                        }
                    ]
                });
            };
            this.notes.push(note);
        });
    }
    _update(time, delta) {
        if (this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.START)) return;
        this.moveCamera(delta);
        if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
        this.notes.forEach((note)=>{
            note.update(delta);
        });
    }
    moveCamera(delta) {
        if (this.reachedEnd) return;
        this.timer += delta / this.timeToReachMaxSpeed;
        this.speed = Phaser.Math.Interpolation.SmoothStep(this.timer, 0, this.maxSpeed);
        this.cameras.main.scrollX = this.cameras.main.scrollX + this.speed * delta / 1000;
    }
    _timeout() {
        this.triggerWin();
    }
    _afterLoss() {}
    _afterWin() {
        this.audio.pause();
    }
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.reachedEnd = true;
        this.winGame(1000);
    }
    triggerLoss() {
        this.audio.pause();
        this.loseGame(0);
    }
}




class $d621c1ba691ee78d$export$c0554d6699482cc0 extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.COFFEE,
            duration: 6000,
            startScreenColor: 0xFF9090,
            startText: "INTERN!",
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.END,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MARRIAGE,
            endButtons: {
                normalNoSkip: {
                    x: 439,
                    y: 368,
                    scale: 1.25
                },
                normalWithSkip: {
                    x: 300,
                    y: 368,
                    scale: 1.25
                },
                skip: {
                    x: 589,
                    y: 368,
                    scale: 1.25
                }
            }
        });
        //values
        this.ingredientConfig = [
            {
                cupImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.CUP_COFFEE,
                normalImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_COFFEE,
                startX: 99,
                startY: 108,
                correct: true
            },
            {
                cupImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.CUP_EGG,
                normalImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_EGG,
                startX: 525,
                startY: 68,
                correct: false
            },
            {
                cupImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.CUP_MILK,
                normalImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_MILK,
                startX: 780,
                startY: 386,
                correct: true
            },
            {
                cupImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.CUP_PEPPER,
                normalImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_PEPPER,
                startX: 201,
                startY: 191,
                correct: false
            },
            {
                cupImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.CUP_SALT,
                normalImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_SALT,
                startX: 650,
                startY: 167,
                correct: false
            },
            {
                cupImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.CUP_SCREW,
                normalImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_SCREW,
                startX: 174,
                startY: 380,
                correct: false
            },
            {
                cupImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.CUP_SUGAR,
                normalImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_SUGAR,
                startX: 771,
                startY: 91,
                correct: true
            },
            {
                cupImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.CUP_TOMATO,
                normalImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_TOMATO,
                startX: 52,
                startY: 279,
                correct: false
            },
            {
                cupImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.CUP_CHEESE,
                normalImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_CHEESE,
                startX: 644,
                startY: 322,
                correct: false
            }
        ];
        this.cupPosition = {
            x: 426.5,
            y: 240
        };
        this.maxCupDistance = 85.33;
        this.animFPS = 60;
        //logic vars
        this.ingredients = [];
        this.cupIngredientDepth = 10;
        this.correctCounter = 0;
        this.wrongCounter = 0;
        this.animTimer = 0;
        this.isAnimating = false;
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.ingredients = [];
        this.cupIngredientDepth = 10;
        this.correctCounter = 0;
        this.wrongCounter = 0;
        this.animTimer = 0;
        this.isAnimating = false;
    }
    _preload() {}
    _create() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(426.5, 431, (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.MAKECOFFEETEXT).setDepth(1);
        this.spawnIngredients();
        this.endAnimation = this.cache.json.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.COFFEEEND);
    }
    spawnIngredients() {
        this.ingredientConfig.forEach((config)=>{
            var cupIngredient = this.add.image(this.cupPosition.x, this.cupPosition.y, config.cupImage).setVisible(false);
            var normalIngredient = this.add.image(config.startX, config.startY, config.normalImage).setDepth(50).setInteractive(this.input.makePixelPerfect());
            this.input.setDraggable(normalIngredient);
            this.ingredients.push({
                key: config.normalImage,
                normal: normalIngredient,
                cup: cupIngredient,
                correct: config.correct,
                putInCup: (ingredient, depth)=>{
                    ingredient.normal.setActive(false).setVisible(false);
                    ingredient.cup.setVisible(true).setDepth(depth);
                    if (ingredient.correct) this.correctCounter++;
                    else this.wrongCounter++;
                //console.log("puting in cup!!");
                }
            });
        });
        this.input.on("dragstart", function(pointer, gameObject) {
            if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
            this.children.bringToTop(gameObject);
            this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
                detune: this.getDetune()
            });
        }, this);
        this.input.on("drag", function(pointer, gameObject, dragX, dragY) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });
        this.input.on("dragend", function(pointer, gameObject, dropped) {
            if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
            this.PutInCup(gameObject);
            this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
                detune: this.getDetune()
            });
        }, this);
    }
    PutInCup(gameObject) {
        var distanceToCup = Phaser.Math.Distance.Between(gameObject.x, gameObject.y, this.cupPosition.x, this.cupPosition.y);
        //console.log("Distance to cup: " + distanceToCup);
        if (distanceToCup > this.maxCupDistance) return;
        this.ingredients.forEach((ingredient)=>{
            if (ingredient.key === gameObject.texture.key) {
                this.cupIngredientDepth += 1;
                ingredient.putInCup(ingredient, this.cupIngredientDepth);
                return;
            }
        });
    }
    _update(time, delta) {
        if (this.isAnimating) {
            this.animTimer += delta;
            this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimation);
        }
    }
    _timeout() {
        this.checkForWin();
    }
    checkForWin() {
        if (this.correctCounter == 3 && this.wrongCounter == 0) this.triggerWin();
        else this.triggerLoss();
    }
    _afterLoss() {
        this.hideIngredients();
    }
    _afterWin() {
        this.hideIngredients();
    }
    hideIngredients() {
        this.ingredients.forEach((ingredient)=>{
            ingredient.normal.setVisible(false);
            ingredient.cup.setVisible(false);
        });
    }
    triggerWin() {
        this.winGame(1500);
        this.endGameAnim(true);
    }
    triggerLoss() {
        this.loseGame(1500);
        this.endGameAnim(false);
    }
    endGameAnim(win) {
        var imageKey = win ? (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.WINIMAGE : (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.LOSEIMAGE;
        this.endImage = this.add.image(0, 0, imageKey).setScale(0, 0).setDepth(900);
        this.animTimer = 0;
        this.isAnimating = true;
    }
    positionImageOnAnimation(timer, image, animation, xOffset = 0, yOffset = 0, angleOffset = 0, scaleMultiplier = 1) {
        //Get frame
        var frameIndex = Math.floor(timer * (this.animFPS / 1000));
        if (frameIndex >= animation.frames.length) frameIndex = animation.frames.length - 1;
        var frame = animation.frames[frameIndex];
        //position image to frame
        image.setPosition(frame.x + xOffset, frame.y + yOffset).setScale(parseFloat(frame.scaleX) * scaleMultiplier, parseFloat(frame.scaleY) * scaleMultiplier).setAngle(parseFloat(frame.angle) + angleOffset);
    }
}




class $f71eb2c7da145579$export$83762f717266aaef extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.FINDHER,
            duration: 20000,
            startScreenColor: 0xE6FB9D,
            startText: "DATE!",
            startTextColor: 0x323232,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BEERPONG,
            endButtons: {
                normalNoSkip: {
                    x: 426.5,
                    y: 416,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 319,
                    y: 418,
                    scale: 1.0
                },
                skip: {
                    x: 534,
                    y: 418,
                    scale: 1.0
                }
            }
        });
        //Images
        //values
        this.maxCardXDifference = 213;
        this.maxCardRotation = 20;
        this.cardReturnTime = 250;
        this.cardsConfig = [
            {
                cardImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.CUTIE_2,
                mustLike: true,
                failImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.WRONG_1,
                isFinal: true
            },
            {
                cardImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.ZOIDBERG,
                mustLike: true,
                failImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.WRONG_4,
                isFinal: false
            },
            {
                cardImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.CUTIE_3,
                mustLike: true,
                failImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.WRONG_1,
                isFinal: false
            },
            {
                cardImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.NOTCUTE_2,
                mustLike: false,
                failImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.WRONG_3,
                isFinal: false
            },
            {
                cardImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.NOTCUTE_1,
                mustLike: false,
                failImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.WRONG_2,
                isFinal: false
            },
            {
                cardImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.CUTIE_1,
                mustLike: true,
                failImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.WRONG_1,
                isFinal: false
            }
        ];
        this.animFPS = 45;
        //logic vars
        this.cards = [];
        this.currentCard = 0;
        this.animTimer = 0;
        this.isAnimating = false;
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.cards = [];
        this.animTimer = 0;
        this.isAnimating = false;
        this.currentCard = 0;
    }
    _preload() {}
    _create() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.FOREGROUND).setOrigin(0, 0).setDepth(90);
        this.add.image(426.5, 240, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.WHITEBACKGROUND);
        let likeButton = this.add.image(489, 416, (0, $15b72a9ad2952278$export$fadd21211b40c08a).PUBERTY.PIMPLE).setScale(1.1, 1.1).setDepth(80).setInteractive({
            useHandCursor: true
        });
        likeButton.on("pointerdown", ()=>{
            if (this.currentCard < 0) return;
            this.cards[this.currentCard].timer = 3 * this.cardReturnTime;
            this.cards[this.currentCard].fullTimer = this.cards[this.currentCard].timer;
            this.likeCard(true, this.cards[this.currentCard]);
        }, this);
        let dislikeButton = this.add.image(370, 416, (0, $15b72a9ad2952278$export$fadd21211b40c08a).PUBERTY.PIMPLE).setScale(1.1, 1.1).setDepth(80).setInteractive({
            useHandCursor: true
        });
        dislikeButton.on("pointerdown", ()=>{
            if (this.currentCard < 0) return;
            this.cards[this.currentCard].timer = 3 * this.cardReturnTime;
            this.cards[this.currentCard].fullTimer = this.cards[this.currentCard].timer;
            this.likeCard(false, this.cards[this.currentCard]);
        }, this);
        this.createCards();
        this.endAnimation = this.cache.json.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.FINDHEREND);
    }
    likeCard(liked, card) {
        card.tempPosition = {
            x: card.x,
            y: card.y
        };
        card.liked = liked;
        card.isActive = false;
        if (liked) {
            if (!card.config.mustLike) this.triggerLose(card.config.failImage);
            else if (card.config.isFinal) this.triggerWin();
        } else if (card.config.mustLike) this.triggerLose(card.config.failImage);
        this.currentCard--;
    }
    createCards() {
        this.cardsConfig.forEach((cardConfig)=>{
            var card = this.add.image(426.5, 220, cardConfig.cardImage).setInteractive({
                useHandCursor: true
            });
            card.likeImage = this.add.image(282.5 - card.x, 127.5 - card.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.LIKE_OVERLAY).setAngle(-25).setScale(0.75);
            card.nopeImage = this.add.image(562.4 - card.x, 133.3 - card.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.NOPE_OVERLAY).setAngle(25).setScale(0.75);
            card.content = this.add.container(card.x, card.y, [
                card.likeImage,
                card.nopeImage
            ]);
            card.config = cardConfig;
            card.rotationMultiplier = this.maxCardRotation / this.maxCardXDifference;
            card.tempPosition = {
                x: card.x,
                y: card.y
            };
            card.timer = 0;
            card.fullTimer = 250;
            card.isDragging = false;
            card.isActive = true;
            card.liked = false;
            this.cards.push(card);
            this.input.setDraggable(card);
            card.update = (delta, card)=>{
                var xOffset = -(card.x - 426.5);
                //Set angle
                card.setAngle(xOffset * card.rotationMultiplier);
                card.content.setAngle(card.angle);
                //set overlay transparency
                card.likeImage.setAlpha(-xOffset / 186);
                card.nopeImage.setAlpha(+xOffset / 186);
                if (!card.isDragging && card.timer >= 0) {
                    card.timer -= delta;
                    if (card.isActive) {
                        card.x = Phaser.Math.Interpolation.SmoothStep(card.timer / card.fullTimer, 426.5, card.tempPosition.x);
                        card.y = Phaser.Math.Interpolation.SmoothStep(card.timer / card.fullTimer, 220, card.tempPosition.y);
                    } else card.x = Phaser.Math.Interpolation.SmoothStep(card.timer / card.fullTimer, card.liked ? 959 : -106, card.tempPosition.x);
                    card.content.x = card.x;
                    card.content.y = card.y;
                }
            };
        });
        this.input.on("dragstart", function(pointer, gameObject) {
            if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
            if (!gameObject.isActive) return;
            gameObject.isDragging = true;
            gameObject.timer = this.cardReturnTime;
            gameObject.fullTimer = gameObject.timer;
        }, this);
        this.input.on("drag", function(pointer, gameObject, dragX, dragY) {
            if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
            if (!gameObject.isActive) return;
            gameObject.x = dragX;
            gameObject.y = dragY;
            gameObject.content.x = dragX;
            gameObject.content.y = dragY;
        }, this);
        this.input.on("dragend", function(pointer, gameObject, dropped) {
            if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
            if (!gameObject.isActive) return;
            gameObject.isDragging = false;
            gameObject.tempPosition = {
                x: gameObject.x,
                y: gameObject.y
            };
            if (gameObject.x > 586) this.likeCard(true, gameObject);
            else if (gameObject.x < 266) this.likeCard(false, gameObject);
        }, this);
        this.currentCard = this.cards.length - 1;
    }
    _update(time, delta) {
        if (this.isAnimating) {
            this.animTimer += delta;
            this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimation);
        }
        // if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
        this.cards.forEach((c)=>{
            c.update(delta, c);
        });
    }
    _timeout() {
        this.triggerLose((0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.WRONG_1);
    }
    _afterLoss() {}
    _afterWin() {}
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.winGame(2000);
        this.endGameAnim();
    }
    triggerLose(failImage) {
        this.add.image(0, 0, failImage).setOrigin(0, 0).setDepth(1000);
        this.loseGame();
    }
    endGameAnim() {
        this.endImage = this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER.WINIMAGE).setScale(0, 0).setDepth(900);
        this.animTimer = 0;
        this.isAnimating = true;
    }
    positionImageOnAnimation(timer, image, animation, xOffset = 0, yOffset = 0, angleOffset = 0, scaleMultiplier = 1) {
        //Get frame
        var frameIndex = Math.floor(timer * (this.animFPS / 1000));
        if (frameIndex >= animation.frames.length) frameIndex = animation.frames.length - 1;
        var frame = animation.frames[frameIndex];
        //position image to frame
        image.setPosition(frame.x + xOffset, frame.y + yOffset).setScale(parseFloat(frame.scaleX) * scaleMultiplier, parseFloat(frame.scaleY) * scaleMultiplier).setAngle(parseFloat(frame.angle) + angleOffset);
    }
}




class $2fa2f6cfba7e42f9$export$7b93822fe073925a extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MARRIAGE,
            duration: 15000,
            startScreenColor: 0xEF91F0,
            startText: "GET\nMARRIED!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.END,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.KIDS,
            endButtons: {
                normalNoSkip: {
                    x: 426.5,
                    y: 411,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 283,
                    y: 411,
                    scale: 1.30
                },
                skip: {
                    x: 570,
                    y: 411,
                    scale: 1.30
                }
            }
        });
        //values
        this.clothesConfigs = [
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.SHIRT_1,
                startPos: {
                    x: 121,
                    y: 119
                },
                dressedPos: {
                    x: 427.5,
                    y: 283
                },
                type: 0,
                isRequired: true,
                scale: 1.0,
                depth: 11
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.SHIRT_2,
                startPos: {
                    x: 121,
                    y: 338
                },
                dressedPos: {
                    x: 427.5,
                    y: 283
                },
                type: 0,
                isRequired: false,
                scale: 1.0,
                depth: 14
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.SHIRT_3,
                startPos: {
                    x: 121,
                    y: 223.5
                },
                dressedPos: {
                    x: 427.5,
                    y: 283
                },
                type: 0,
                isRequired: false,
                scale: 1.0,
                depth: 12
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.SHIRT_4,
                startPos: {
                    x: 121,
                    y: 392
                },
                dressedPos: {
                    x: 427.5,
                    y: 266
                },
                type: 0,
                isRequired: false,
                scale: 1.0,
                depth: 15
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.SHIRT_5,
                startPos: {
                    x: 121,
                    y: 298
                },
                dressedPos: {
                    x: 427.5,
                    y: 283
                },
                type: 0,
                isRequired: false,
                scale: 1.2,
                depth: 13
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.PANTS_1,
                startPos: {
                    x: 749,
                    y: 107
                },
                dressedPos: {
                    x: 426.5,
                    y: 398
                },
                type: 1,
                isRequired: true,
                scale: 1.0,
                depth: 11
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.PANTS_2,
                startPos: {
                    x: 749,
                    y: 195
                },
                dressedPos: {
                    x: 425.5,
                    y: 378
                },
                type: 1,
                isRequired: false,
                scale: 1.0,
                depth: 14
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.PANTS_3,
                startPos: {
                    x: 749,
                    y: 129
                },
                dressedPos: {
                    x: 426,
                    y: 383.5
                },
                type: 1,
                isRequired: false,
                scale: 1.0,
                depth: 12
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.PANTS_4,
                startPos: {
                    x: 749,
                    y: 298
                },
                dressedPos: {
                    x: 425.5,
                    y: 393
                },
                type: 1,
                isRequired: false,
                scale: 1.0,
                depth: 15
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.PANTS_5,
                startPos: {
                    x: 749,
                    y: 162
                },
                dressedPos: {
                    x: 426.5,
                    y: 386
                },
                type: 1,
                isRequired: false,
                scale: 1.0,
                depth: 13
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.SHOES_1,
                startPos: {
                    x: 681,
                    y: 406
                },
                dressedPos: {
                    x: 423,
                    y: 450
                },
                type: 2,
                isRequired: false,
                scale: 1.0,
                depth: 11
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.SHOES_2,
                startPos: {
                    x: 590,
                    y: 406
                },
                dressedPos: {
                    x: 423,
                    y: 450
                },
                type: 2,
                isRequired: true,
                scale: 1.0,
                depth: 11
            },
            {
                imageName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.SHOES_3,
                startPos: {
                    x: 766,
                    y: 406
                },
                dressedPos: {
                    x: 423,
                    y: 450
                },
                type: 2,
                isRequired: false,
                scale: 1.0,
                depth: 11
            }
        ];
        this.dressedPositions = [
            {
                type: 0,
                x: 426.5,
                y: 288
            },
            {
                type: 1,
                x: 426.5,
                y: 392
            },
            {
                type: 2,
                x: 426.5,
                y: 452
            }
        ];
        this.maxDropDistance = 80;
        this.animFPS = 60;
        //logic vars
        this.clothes = [];
        this.animTimer = 0;
        this.isAnimating = false;
        this.isWinAnimation = false;
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.clothes = [];
        this.dressedClothes = Array.apply(null, Array(3)).map(function() {});
        this.animTimer = 0;
        this.isAnimating = false;
        this.isWinAnimation = false;
    }
    _preload() {}
    _create() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(563.5, 92.8, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.BACKGROUND_OVERLAY).setDepth(1);
        this.add.image(424, 297, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.HANDS).setDepth(20);
        this.createClothes();
        this.endAnimationWin = this.cache.json.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.MARRIAGEWIN);
        this.endAnimationLose = this.cache.json.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.MARRIAGEFROWN);
    }
    createClothes() {
        //{imageName: CONST.MARRIAGE.SHIRT_1, startPos: {x: 100, y: 100}, dressedPos: {x: 100, y: 100}, type: 0, isRequired: false},
        this.clothesConfigs.forEach((clothesConfig)=>{
            //Spawn clothes at startPos
            let cloth = this.add.image(clothesConfig.startPos.x, clothesConfig.startPos.y, clothesConfig.imageName).setInteractive({
                useHandCursor: true
            }).setScale(clothesConfig.scale, clothesConfig.scale).setDepth(clothesConfig.depth);
            cloth.config = clothesConfig;
            cloth.isDressed = false;
            cloth.setDressed = (dressed)=>{
                cloth.isDressed = dressed;
                if (cloth.isDressed) {
                    //Move to dressed position
                    cloth.x = cloth.config.dressedPos.x;
                    cloth.y = cloth.config.dressedPos.y;
                    cloth.setDepth(9);
                } else {
                    //Move to start position
                    cloth.x = cloth.config.startPos.x;
                    cloth.y = cloth.config.startPos.y;
                    cloth.setDepth(cloth.config.depth);
                }
            };
            cloth.dress = ()=>{
                cloth.setDressed(true);
                if (this.dressedClothes[cloth.config.type]) //console.log("undressing current clothes");
                this.dressedClothes[cloth.config.type].setDressed(false);
                this.dressedClothes[cloth.config.type] = cloth;
            };
            this.input.setDraggable(cloth);
        });
        this.input.on("dragstart", function(pointer, gameObject) {
            if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
            if (gameObject.isDressed) return;
            this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
                detune: this.getDetune()
            });
        }, this);
        this.input.on("drag", function(pointer, gameObject, dragX, dragY) {
            if (gameObject.isDressed) return;
            gameObject.x = dragX;
            gameObject.y = dragY;
        });
        this.input.on("dragend", function(pointer, gameObject, dropped) {
            if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
            if (gameObject.isDressed) return;
            this.tryDress(gameObject);
        }, this);
    }
    tryDress(gameObject) {
        this.dressedPositions.forEach((pos)=>{
            if (pos.type == gameObject.config.type) {
                if (Phaser.Math.Distance.Between(pos.x, pos.y, gameObject.x, gameObject.y) <= this.maxDropDistance) {
                    gameObject.dress();
                    this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.BOUNCE, {
                        detune: this.getDetune()
                    });
                    if (this.checkForWin()) this.triggerWin();
                } else this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
                    detune: this.getDetune()
                });
            }
        });
    }
    _update(time, delta) {
        if (this.isAnimating) {
            this.animTimer += delta;
            if (this.isWinAnimation) this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimationWin);
            else this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimationLose, 0, -100);
        }
    }
    _timeout() {
        if (this.checkForWin()) this.triggerWin();
        else this.triggerLoss();
    }
    checkForWin() {
        for(var i = 0; i < this.dressedClothes.length; i++){
            if (this.dressedClothes[i] == null || !this.dressedClothes[i].config.isRequired) return false;
        }
        return true;
    }
    _afterLoss() {}
    _afterWin() {}
    triggerLoss() {
        this.loseGame(1000);
        this.endGameAnim(false);
    }
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.winGame(1500);
        this.endGameAnim(true);
    }
    endGameAnim(win) {
        this.isWinAnimation = win;
        var imageKey = win ? (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE.WINIMAGE : (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.SMILE;
        this.endImage = this.add.image(0, 0, imageKey).setScale(0, 0).setDepth(900);
        this.animTimer = 0;
        this.isAnimating = true;
    }
    positionImageOnAnimation(timer, image, animation, xOffset = 0, yOffset = 0, angleOffset = 0, scaleMultiplier = 1) {
        //Get frame
        var frameIndex = Math.floor(timer * (this.animFPS / 1000));
        if (frameIndex >= animation.frames.length) frameIndex = animation.frames.length - 1;
        var frame = animation.frames[frameIndex];
        //position image to frame
        image.setPosition(frame.x + xOffset, frame.y + yOffset).setScale(parseFloat(frame.scaleX) * scaleMultiplier, parseFloat(frame.scaleY) * scaleMultiplier).setAngle(parseFloat(frame.angle) + angleOffset);
    }
}




class $62561b551dfdb023$export$ccdc95a7053a49a5 extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.KIDS,
            duration: 20000,
            startScreenColor: 0xC1FFDB,
            startText: "GET\nKIDS!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.END,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MIDLIFE,
            endButtons: {
                normalNoSkip: {
                    x: 426.5,
                    y: 394,
                    scale: 1.25
                },
                normalWithSkip: {
                    x: 283,
                    y: 394,
                    scale: 1.25
                },
                skip: {
                    x: 570,
                    y: 394,
                    scale: 1.25
                }
            }
        });
        //Images
        this.mamice = [];
        //values
        this.clickableWidth = 100;
        this.missTimePunishment = 500;
        this.clickerSwingTime = 1500 //in ms
        ;
        this.swingStartX = 277;
        this.swingEndX = 807;
        this.babies = [
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.BABY,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.BABY_2,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.BABY_3,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.BABY_4,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.BABY_3
        ];
        this.textNames = [
            {
                name: (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.TEXT_1,
                x: 630
            },
            {
                name: (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.TEXT_2,
                x: 682
            },
            {
                name: (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.TEXT_3,
                x: 625
            },
            {
                name: (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.TEXT_4,
                x: 464
            },
            {
                name: (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.TEXT_5,
                x: 697
            }
        ];
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.clickerMovingRight = true;
        this.swingTimer = 0;
        this.hits = 0;
        this.mamice = [];
        this.texts = [];
    }
    _preload() {}
    _create() {
        let background = this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.BACKGROUND).setOrigin(0, 0);
        background.setInteractive();
        background.on("pointerdown", ()=>{
            this.handleClick();
        });
        this.add.image(145, 433, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.PUSH);
        this.add.image(717, 262, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.STROLLER).setDepth(100);
        this.swing = this.add.image(542, 429, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.SWING);
        this.clicker = this.add.image(542, 429, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH.CLICKER);
        this.add.image(156, 272.5, (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.DADBOD).setDepth(110).setScale(1, 1.437);
        this.addAnimation((0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.DADHEAD, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.DADHEAD, 60).setDepth(111).setLoop(true).setOffset(0, -185).start();
        this.createMamice(226, 299);
        this.setMamicaState(this.hits);
        this.createTexts();
        this.audio = this.sound.add((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.CRY, {
            loop: false
        });
    }
    createMamice(x, y) {
        var mamicePaths = [
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.MAMICA1,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.MAMICA2,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.MAMICA3,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.MAMICA4,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS.MAMICA5
        ];
        mamicePaths.forEach((path)=>{
            this.mamice.push(this.add.image(x, y, path).setVisible(false).setDepth(150));
        });
    }
    createTexts() {
        this.textNames.forEach((textName)=>{
            var text = this.add.image(textName.x, 58, textName.name).setDepth(20).setVisible(false);
            this.texts.push(text);
        });
    }
    handleClick() {
        if (this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) {
            if (this.isClickerWithinLimits()) {
                this.hits++;
                this.playBabyAnimation(this.hits);
                this.showText(this.hits);
                this.setMamicaState(this.hits);
                this.playAudio();
            } else {
                this.changeGameplayTimerDuration(-this.missTimePunishment);
                this.cameras.main.flash(200, 255, 64, 43);
            }
        }
    }
    playBabyAnimation(hits) {
        if (hits <= this.babies.length) this.addAnimation(this.babies[hits - 1], (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDSSHOOTBABY, 60).setScaleMultiplier(0.65).setDepth(90).setLoop(false).start();
    }
    playAudio() {
        this.audio.play();
    }
    showText(hits) {
        if (hits <= this.texts.length) {
            this.texts.forEach((text)=>{
                text.setVisible(false);
            });
            this.texts[hits - 1].setVisible(true);
        }
    }
    isClickerWithinLimits() {
        return Phaser.Math.Difference(this.clicker.x, this.swing.x) < this.clickableWidth;
    }
    setMamicaState(index) {
        if (index >= this.mamice.length) {
            this.triggerWin();
            return;
        }
        for(var i = 0; i < this.mamice.length; i++)this.mamice[i].setVisible(i === index);
    }
    _update(time, delta) {
        if (this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) this.moveClicker(delta);
    }
    moveClicker(delta) {
        if (this.clickerMovingRight) {
            this.swingTimer += delta / this.clickerSwingTime;
            if (this.swingTimer >= 1) {
                this.clickerMovingRight = !this.clickerMovingRight;
                this.swingTimer = 1;
            }
        } else {
            this.swingTimer -= delta / this.clickerSwingTime;
            if (this.swingTimer <= 0) {
                this.clickerMovingRight = !this.clickerMovingRight;
                this.swingTimer = 0;
            }
        }
        this.clicker.x = Phaser.Math.Interpolation.SmoothStep(this.swingTimer, this.swingStartX, this.swingEndX);
    }
    _timeout() {
        this.triggerLoss();
    }
    _afterLoss() {
        this.audio.stop();
    }
    _afterWin() {
        this.audio.stop();
    }
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.winGame(1500);
    }
    triggerLoss() {
        this.loseGame();
    }
}




class $c5a171bd85d76b9f$export$7a21c539aa1c4c75 extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    //Images
    //values
    //logic vars
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.CREDITS,
            duration: 5000,
            startScreenColor: 0xC1FFDB,
            startText: "",
            startTextColor: 0x323232,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU,
            timeToStart: 0,
            endButtons: {
                normalNoSkip: {
                    x: 426.5,
                    y: 386,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 283,
                    y: 386,
                    scale: 1.30
                },
                skip: {
                    x: 570,
                    y: 386,
                    scale: 1.30
                }
            }
        });
    }
    _init() {
    //Reset all class variables that change during scene here (including arrays that initialize in create!)
    }
    _preload() {}
    _create() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).CREDITS.END).setOrigin(0, 0);
    }
    _update(time, delta) {}
    _timeout() {
        this.winGame();
    }
    _afterLoss() {}
    _afterWin() {}
}




class $c23539df4af788c4$export$9a600b9240d23e2b extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    //values
    //logic vars
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.DIE,
            duration: 10000,
            startScreenColor: 0x000000,
            startText: "DIE!",
            startTextColor: 0x525252,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.CREDITS,
            timeToStart: 6000,
            endButtons: {
                normalNoSkip: {
                    x: 426.5,
                    y: 386,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 283,
                    y: 386,
                    scale: 1.30
                },
                skip: {
                    x: 570,
                    y: 386,
                    scale: 1.30
                }
            }
        });
    }
    _init() {
    //Reset all class variables that change during scene here (including arrays that initialize in create!)
    }
    _preload() {}
    _create() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DIE.BACKGROUND).setOrigin(0, 0);
        this.dieSong = this.sound.add((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.DIESONG, {
            loop: false
        });
        this.thunder = this.sound.add((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.LIGHTNING, {
            loop: false
        });
        this.dieSong.play();
        this.thunder.play();
        this.pauseMusic(true);
    }
    pauseMusic(pause) {
        this.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.SOUNDTRACK).pauseMusic(pause);
    }
    _update(time, delta) {}
    _timeout() {
        this.triggerWin();
    }
    _afterLoss() {}
    _afterWin() {
        this.dieSong.stop();
        this.thunder.stop();
        this.pauseMusic(false);
    }
    triggerWin() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DIE.END).setOrigin(0, 0).setDepth(10);
        this.winGame(12000);
    }
}




class $3d0adf22ccdc05d5$export$3d56d16ec65b7a75 extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PILLS,
            duration: 30000,
            startScreenColor: 0xC1E3FF,
            startText: "STAY\nHEALTHY!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.END,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.DIE,
            endButtons: {
                normalNoSkip: {
                    x: 466,
                    y: 410,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 322,
                    y: 410,
                    scale: 1.30
                },
                skip: {
                    x: 610,
                    y: 410,
                    scale: 1.30
                }
            }
        });
        //values
        this.springForceMultiplier = 1;
        this.pillsConfig = [
            {
                x: 545,
                y: 249,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL2
            },
            {
                x: 638,
                y: 214,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL1
            },
            {
                x: 669,
                y: 257,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL3
            },
            {
                x: 759,
                y: 310,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL2
            },
            {
                x: 707,
                y: 174,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL2
            },
            {
                x: 559,
                y: 199,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL3
            },
            {
                x: 773,
                y: 221,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL3
            },
            {
                x: 573,
                y: 316,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL1
            },
            {
                x: 745,
                y: 264,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL1
            }
        ];
        this.boxesConfig = [
            {
                x: 410,
                y: 335,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.BOX1,
                requiredPill: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL3,
                maxPillDistance: 55
            },
            {
                x: 246,
                y: 335,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.BOX2,
                requiredPill: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL2,
                maxPillDistance: 55
            },
            {
                x: 89,
                y: 335,
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.BOX3,
                requiredPill: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.PILL1,
                maxPillDistance: 55
            }
        ];
        //logic vars
        this.pills = [];
        this.boxes = [];
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.pills = [];
        this.boxes = [];
    }
    _preload() {}
    _create() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(426.5, 447.46, (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.SORTTEXT).setDepth(8).setScale(0.87, 0.87);
        this.grandpa = this.add.image(426.5, 240, (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.GRANDPA).setDepth(1);
        this.initPhysics();
        this.spawnBoxes();
        this.spawnPills();
    }
    initPhysics() {
        this.physicsShapes = this.cache.json.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).PHYSICS.PILLS);
        this.matter.world.setBounds(0, 0, this.game.renderer.width, this.game.renderer.height);
        let tableImg = this.add.image(this.game.renderer.width / 2, this.game.renderer.height / 2, (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.TABLE).setDepth(2);
        this.matter.add.rectangle(this.game.renderer.width / 2, 440, this.game.renderer.width, 100, {
            isStatic: true
        });
    }
    spawnPills() {
        var canDrag = this.matter.world.nextGroup(false);
        this.matter.add.mouseSpring({
            length: 0,
            stiffness: 0.003,
            angularStiffness: 0,
            collisionFilter: {
                group: canDrag
            }
        });
        this.pillsConfig.forEach((config)=>{
            var pill = this.matter.add.image(config.x, config.y, config.image, null, {
                chamfer: {
                    radius: 32
                }
            }).setScale(0.44, 0.44).setDepth(10).setInteractive().setCollisionGroup(canDrag);
            pill.isDragging = false;
            this.pills.push(pill);
        });
    }
    spawnBoxes() {
        var bigBox = this.matter.add.image(665, 335, (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS.BIGBOX, null, {
            shape: this.physicsShapes.bigbox
        }).setDepth(9);
        this.boxesConfig.forEach((config)=>{
            var box = this.matter.add.image(config.x, config.y, config.image, null, {
                shape: this.physicsShapes.box
            }).setDepth(9);
            box.maxPillDistance = config.maxPillDistance;
            box.requiredPill = config.requiredPill;
            /*var distanxe = config.maxPillDistance;
            this.add.graphics({fillStyle: {color: 0x0000ff, alpha: 0.4}})
                .lineBetween(greenBox.x, greenBox.y, greenBox.x + distanxe, greenBox.y + distanxe);
                this.add.graphics({fillStyle: {color: 0x0000ff, alpha: 0.4}})
                .lineBetween(greenBox.x, greenBox.y, greenBox.x - distanxe, greenBox.y - distanxe);*/ box.isPillInside = (pill)=>{
                var rotated = this.rotateAroundPoint({
                    x: pill.x,
                    y: pill.y
                }, {
                    x: box.x,
                    y: box.y
                }, box.angle);
                return Math.abs(rotated.x - box.x) < box.maxPillDistance && Math.abs(rotated.y - box.y) < box.maxPillDistance;
            };
            this.boxes.push(box);
        });
    }
    rotateAroundPoint(vecToRotate, point, rotation) {
        var cos = Math.cos(rotation);
        var sin = Math.sin(rotation);
        vecToRotate.x -= point.x;
        vecToRotate.y -= point.y;
        var xNew = vecToRotate.x * cos - vecToRotate.y * sin;
        var yNew = vecToRotate.x * sin + vecToRotate.y * cos;
        vecToRotate.x = xNew + point.x;
        vecToRotate.y = yNew + point.y;
        return vecToRotate;
    }
    _update(time, delta) {
        if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
        var gx = this.grandpa.x;
        this.grandpa.x = Phaser.Math.Interpolation.SmoothStep(0.1, this.grandpa.x, this.input.activePointer.x);
        this.checkPills();
    }
    checkPills() {
        var solved = true;
        for (let box of this.boxes)for (let pill of this.pills){
            if (box.requiredPill === pill.texture.key && !box.isPillInside(pill)) return;
        }
        //if we get here -> all pills are sorted!
        this.triggerWin();
    }
    _timeout() {
        this.loseGame();
    }
    _afterLoss() {}
    _afterWin() {}
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.addAnimation((0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.SMILE, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.PILLSEND, 60).setOffset(this.grandpa.x - this.game.renderer.width / 2, 0).setDepth(2).setLoop(false).start();
        this.winGame(1000);
    }
}




class $e5a649cd055144f1$export$d81351cf6cbef71d extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MIDLIFE,
            duration: 15000,
            startScreenColor: 0xC1FFFF,
            startText: "MIDLIFE\nCRISIS!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.GRANDCHILDREN,
            endButtons: {
                normalNoSkip: {
                    x: 430,
                    y: 361,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 322,
                    y: 361,
                    scale: 1.0
                },
                skip: {
                    x: 537,
                    y: 361,
                    scale: 1.0
                }
            }
        });
        //Images
        //values
        //private moveSpeed = 0;//100;
        this.timeToReachMaxSpeed = 5000;
        this.maxSpeed = 326.5;
        this.objectConfig = [
            {
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.BEER,
                x: 530,
                y: 140,
                required: false,
                scale: 1
            },
            {
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.CAR,
                x: 869,
                y: 149,
                required: true,
                scale: 1.48
            },
            {
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.CANDY,
                x: 1244,
                y: 115,
                required: false,
                scale: 1.5
            },
            {
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_CHEESE,
                x: 1562,
                y: 120,
                required: false,
                scale: 1
            },
            {
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_COFFEE,
                x: 1859,
                y: 100,
                required: false,
                scale: 1
            },
            {
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_MILK,
                x: 2200,
                y: 100,
                required: false,
                scale: 1
            },
            {
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.WEIGHTS,
                x: 2598,
                y: 106,
                required: true,
                scale: 1.65
            },
            {
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.PANTIES,
                x: 3045,
                y: 106,
                required: false,
                scale: 1.65
            },
            {
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE.NORMAL_PEPPER,
                x: 3465,
                y: 122,
                required: false,
                scale: 1.65
            },
            {
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.TICKET,
                x: 3927,
                y: 117,
                required: true,
                scale: 1.36
            }
        ];
        this.cartPos = {
            x: 165,
            y: 310
        };
        this.maxDistance = {
            x: 165,
            y: 50
        };
        //logic vars
        this.timer = 0;
        this.speed = 0;
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.objects = [];
        this.timer = 0;
        this.speed = 0;
    }
    _preload() {}
    _create() {
        this.add.image(9779, 262, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.ENDLESSBACKGROUND).setDepth(9).setScale(45, 1);
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.BACKGROUND).setOrigin(0, 0).setDepth(10);
        this.add.image(745, 413, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.LIST).setDepth(11).setScrollFactor(0);
        this.spawnJack();
        this.initPhysics();
        this.spawnObjects();
    }
    initPhysics() {
        this.matter.world.setBounds(0, 0, 10000, this.game.renderer.height);
        this.collisionShelf = this.matter.world.nextCategory();
        this.collisionOther = this.matter.world.nextCategory();
        this.collisionNone = this.matter.world.nextCategory();
        this.matter.add.rectangle(5000, 222, 9300, 15, {
            isStatic: true,
            collisionFilter: {
                category: this.collisionShelf
            }
        });
    }
    spawnObjects() {
        var canDrag = this.matter.world.nextGroup(false);
        this.matter.add.mouseSpring({
            length: 0,
            stiffness: 1,
            angularStiffness: 0,
            collisionFilter: {
                group: canDrag
            }
        });
        this.objectConfig.forEach((config)=>{
            var obj = this.matter.add.image(config.x, config.y, config.image, null, {}).setDepth(17).setScale(config.scale, config.scale).setInteractive({
                useHandCursor: true
            }).setCollisionGroup(canDrag);
            obj.inCart = false;
            obj.relativeJackPos;
            obj.required = config.required;
            obj.config = config;
            obj.setCollisionCategory(this.collisionOther);
            obj.setCollidesWith([
                this.collisionOther,
                this.collisionShelf,
                0x0001
            ]);
            obj.putInCart = ()=>{
                obj.inCart = true;
                obj.setCollisionGroup(this.collisionNone);
                obj.setCollidesWith([]);
                obj.setStatic(true);
                obj.relativeJackPos = {
                    x: obj.x - this.jack.x,
                    y: obj.y - this.jack.y
                };
            };
            obj.update = ()=>{
                if (obj.inCart) obj.setPosition(this.jack.x + obj.relativeJackPos.x, this.jack.y + obj.relativeJackPos.y);
            };
            this.objects.push(obj);
        });
        this.matter.world.on("dragstart", function(body, part) {
            //Copy of setCollidesWith because WTF IS WRONG WITH YOU PHASER
            var flags = 0;
            var categories = [
                this.collisionOther,
                0x0001
            ];
            for(var i = 0; i < categories.length; i++)flags |= categories[i];
            body.collisionFilter.mask = flags;
        }, this);
        this.matter.world.on("dragend", function(body, part) {
            this.objects.forEach((obj)=>{
                if (obj.body === body) {
                    if (Math.abs(obj.x - this.jack.x - this.cartPos.x) < this.maxDistance.x && Math.abs(obj.y - this.cartPos.y) < this.maxDistance.y) obj.putInCart();
                }
            });
        }, this);
    }
    spawnJack() {
        var jack = this.add.image(333, 333, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.BODY).setDepth(20);
        var rightLeg = this.addAnimation((0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.FEET, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.MIDLIFERIGHTFOOT, 60).setLoop(true).setDepth(18).setScaleMultiplier(2.7, 9.6).setOffset(12, 0).setScrollFactor(0, 0).start();
        var leftLeg = this.addAnimation((0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.FEET, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.MIDLIFELEFTFOOT, 60).setLoop(true).setDepth(18).setScaleMultiplier(2.26, 9.5).setOffset(12, 0).setScrollFactor(0, 0).start();
        this.add.image(156, 161, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.HEAD).setDepth(22).setScrollFactor(0, 0);
        jack.update = (delta, jack)=>{
            if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
            jack.x += this.speed * delta / 1000;
        };
        this.cameras.main.startFollow(jack, false, 1, 0, jack.x - this.cameras.main.x - this.game.renderer.width / 2, jack.y - this.cameras.main.y - this.game.renderer.height / 2);
        this.jack = jack;
    }
    _update(time, delta) {
        this.calculateSpeed(delta);
        this.jack.update(delta, this.jack);
        this.objects.forEach((obj)=>obj.update());
    }
    calculateSpeed(delta) {
        if (this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.START)) return;
        this.timer += delta / this.timeToReachMaxSpeed;
        this.speed = Phaser.Math.Interpolation.SmoothStep(this.timer, 0, this.maxSpeed);
    }
    _timeout() {
        this.checkForWin();
    }
    checkForWin() {
        var allInCart = true;
        var validCart = true;
        var emptyCart = true;
        for (let obj of this.objects)if (obj.inCart) {
            emptyCart = false;
            if (!obj.required) validCart = false;
        } else {
            if (obj.required) validCart = false;
            allInCart = false;
        }
        if (validCart && !emptyCart) this.triggerWin();
        else this.triggerLoss(allInCart);
    }
    _afterLoss() {}
    _afterWin() {}
    triggerLoss(allInCart) {
        this.add.image(this.jack.x - 333, 0, allInCart ? (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.ENDEVERYTHING : (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.END).setOrigin(0, 0).setDepth(999);
        this.loseGame();
    }
    triggerWin() {
        this.addAnimation((0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.WINIMAGE, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.MIDLIFEWIN, 60).setOffset(this.jack.x - 333, 0).setLoop(false).setDepth(999).start();
        this.winGame(1500);
    }
}




class $1601d6b360480467$export$cfa3c5ea0599add0 extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.GRANDCHILDREN,
            duration: 13000,
            startScreenColor: 0xC5C5C5,
            startText: "GRAND\nCHILDREN!",
            startTextYOrigin: 0.35,
            startTextColor: 0x111111,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRANDCHILDREN.END,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PILLS,
            endButtons: {
                normalNoSkip: {
                    x: 426.5,
                    y: 75,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 283,
                    y: 75,
                    scale: 1.30
                },
                skip: {
                    x: 570,
                    y: 75,
                    scale: 1.30
                }
            }
        });
        //values
        this.moveSpeed = 100;
        this.deathDistance = 10;
        this.scaleMultiplier = 0.0115;
        this.legScaleMultiplier = 2.175;
        this.afterDragPause = 300 //Pause kid movement after dragging it
        ;
        this.kidConfig = [
            {
                spawnPos: {
                    x: 594,
                    y: 258
                },
                targetPos: {
                    x: 219,
                    y: 208
                },
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRANDCHILDREN.KID1,
                legOffset: {
                    x: 4,
                    y: 8
                },
                electric: true
            },
            {
                spawnPos: {
                    x: 246,
                    y: 278
                },
                targetPos: {
                    x: 747,
                    y: 303
                },
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRANDCHILDREN.KID2,
                legOffset: {
                    x: 4,
                    y: 8
                },
                electric: false
            },
            {
                spawnPos: {
                    x: 766,
                    y: 389
                },
                targetPos: {
                    x: 182,
                    y: 352
                },
                image: (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRANDCHILDREN.KID3,
                legOffset: {
                    x: 4,
                    y: 16
                },
                electric: false
            }
        ];
        this.walls = [
            {
                k: 1,
                n: -440
            },
            {
                k: 0,
                n: 200
            },
            {
                k: -1,
                n: 434
            }
        ];
        //logic vars
        this.kids = [];
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.kids = [];
    }
    _preload() {}
    _create() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRANDCHILDREN.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(358, 73, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRANDCHILDREN.DRAGTEXT).setScale(0.78, 0.78).setDepth(1);
        this.addGrandpa();
        this.spawnKids();
        this.audio = this.sound.add((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.NOOO, {
            loop: false
        });
    }
    addGrandpa() {
        this.addAnimation((0, $15b72a9ad2952278$export$fadd21211b40c08a).GRANDCHILDREN.GRANDPA, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.GRANDPAMOVE, 60).setDepth(10).setLoop(true).start();
        this.addAnimation((0, $15b72a9ad2952278$export$fadd21211b40c08a).GRANDCHILDREN.HANDS_LEFT, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.GRANDPALEFTHAND, 60).setDepth(11).setLoop(true).start();
        this.addAnimation((0, $15b72a9ad2952278$export$fadd21211b40c08a).GRANDCHILDREN.HANDS_RIGHT, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.GRANDPARIGHTHAND, 60).setDepth(11).setLoop(true).start();
    }
    spawnKids() {
        this.kidConfig.forEach((config)=>{
            var kid = this.createKidAnim(config.image, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDTORSO, config.spawnPos, {
                x: 0,
                y: 0
            }, 12).setDraggable(this.input);
            kid.rightLeg = this.createKidAnim((0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.FEET, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDRIGHTLEG, config.spawnPos, config.legOffset, 11).setScaleMultiplier(1, 2.175);
            kid.leftLeg = this.createKidAnim((0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE.FEET, (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDLEFTLEG, config.spawnPos, config.legOffset, 11).setScaleMultiplier(1, 2.175);
            kid.leftLegOffset = kid.leftLeg.GetOffset();
            kid.rightLegOffset = kid.rightLeg.GetOffset();
            kid.config = config;
            kid.isAlive = true;
            kid.isDragging = false;
            kid.timeSinceLastDrag = this.afterDragPause;
            kid.getMoveVector = (distance)=>{
                var vec = {
                    x: kid.config.targetPos.x - kid.GetPositionOverride().x,
                    y: kid.config.targetPos.y - kid.GetPositionOverride().y
                };
                var mag = Math.sqrt(vec.x * vec.x + vec.y * vec.y);
                return {
                    x: distance * vec.x / mag,
                    y: distance * vec.y / mag,
                    mag: mag
                };
            };
            kid.setPos = (x, y)=>{
                var maxY = this.getMaxYWalls(x, y);
                kid.setPositionOverride(x, maxY);
                kid.rightLeg.setPositionOverride(x, maxY);
                kid.leftLeg.setPositionOverride(x, maxY);
            };
            kid.checkForDeath = (distance)=>{
                if (distance < this.deathDistance) kid.kill();
            };
            kid.kill = ()=>{
                kid.isAlive = false;
                this.triggerLose();
                kid.setLoop(kid.config.electric).setAnimation(this.cache.json.get(kid.config.electric ? (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDDIEELECTRIC : (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDDIEFIRE));
            };
            kid.onUpdate = (delta)=>{
                if (kid.isAlive) {
                    let currentMoveSpeed = Phaser.Math.Interpolation.SmoothStep(kid.timeSinceLastDrag / this.afterDragPause, 0, this.moveSpeed);
                    var moveVector = kid.getMoveVector(currentMoveSpeed * delta / 1000);
                    if (!kid.isDragging) {
                        kid.timeSinceLastDrag += delta;
                        kid.setPos(kid.GetPositionOverride().x + moveVector.x, kid.GetPositionOverride().y + moveVector.y);
                    }
                    kid.checkForDeath(moveVector.mag);
                }
                kid.updateScale();
            };
            kid.updateScale = ()=>{
                var scMul = this.scaleMultiplier * Math.pow(Math.abs(this.getUnityY(kid.GetPositionOverride().y) - 10), 2);
                kid.setScaleMultiplier(scMul);
                kid.leftLeg.setScaleMultiplier(scMul, scMul * this.legScaleMultiplier);
                kid.rightLeg.setScaleMultiplier(scMul, scMul * this.legScaleMultiplier);
                //adjust leg offset so it is visible when scale changes
                kid.leftLeg.setOffset(kid.leftLegOffset.x, kid.leftLegOffset.y - 50 * (1 - scMul));
                kid.rightLeg.setOffset(kid.rightLegOffset.x, kid.rightLegOffset.y - 50 * (1 - scMul));
                //adjust depth
                var newDepth = kid.GetPositionOverride().y;
                kid.setDepth(newDepth);
                kid.leftLeg.setDepth(newDepth - 1);
                kid.rightLeg.setDepth(newDepth - 1);
            };
            this.kids.push(kid);
        });
        this.input.on("drag", function(pointer, gameObject, dragX, dragY) {
            gameObject.animation.setPos(dragX, dragY);
        }, this);
        this.input.on("dragstart", function(pointer, gameObject) {
            gameObject.animation.isDragging = true;
        }, this);
        this.input.on("dragend", function(pointer, gameObject, dropped) {
            gameObject.animation.isDragging = false;
            gameObject.animation.timeSinceLastDrag = 0;
        }, this);
    }
    createKidAnim(image, animJson, spawnPos, offset, depth) {
        return this.addAnimation(image, animJson, 60).setDepth(depth).setLoop(true).setOffset(-594 + offset.x, -258 + offset.y).setPositionOverride(spawnPos.x, spawnPos.y).start();
    }
    //Find max position within walls
    getMaxYWalls(x, y) {
        var yMax = y;
        for (let wall of this.walls){
            var wallY = wall.k * x + wall.n;
            if (wallY > yMax) yMax = wallY;
        }
        return yMax;
    }
    _update(time, delta) {
        if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
        this.kids.forEach((kid)=>kid.onUpdate(delta));
    }
    _timeout() {
        this.triggerWin();
    }
    _afterLoss() {}
    _afterWin() {}
    triggerLose() {
        this.audio.play();
        this.loseGame(1000);
    }
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.winGame(1000);
    }
}





const $ce75fde1e385681e$var$MAX_PROJECTION_POINTS = 30;
const $ce75fde1e385681e$var$PROJECTION_LINE_LENGTH = 700;
const $ce75fde1e385681e$var$SKIP_UPDATE_NUM = 3;
const $ce75fde1e385681e$var$POINT_SCALE = 0.5;
class $ce75fde1e385681e$export$2e2bcd8739ae039 {
    constructor(scene, ballX, ballY, ballScale, ballMass, speed, gravityScale, minYPosition){
        this.speed = speed;
        this.startPos = {
            x: ballX,
            y: ballY
        };
        this.gravityScale = gravityScale;
        this.minY = minYPosition;
        this.projectionPointsGroup = scene.add.group({
            classType: Phaser.GameObjects.Image,
            key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BEERPONG.BLACK_CIRCLE,
            repeat: $ce75fde1e385681e$var$MAX_PROJECTION_POINTS,
            alpha: 0.3,
            active: false,
            visible: false
        });
        this.hiddenBall = scene.matter.add.image(ballX, ballY, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BEERPONG.BALL, null).setFrictionAir(0).setCircle().setScale(ballScale, ballScale).setMass(ballMass);
        this.hiddenBall.setVisible(false);
        this.hiddenBall.setStatic(true);
        this.hideHiddenBall(); // Needs to be done here because it interacts with constraint
    }
    updateProjectionPoints(pointerX, pointerY) {
        this.projectionPointsGroup.children.each((point)=>{
            point.setVisible(false);
            point.setActive(false);
        });
        this.hiddenBall.x = this.startPos.x;
        this.hiddenBall.y = this.startPos.y;
        this.hiddenBall.setVisible(false);
        this.hiddenBall.setStatic(false);
        const previousPos = {
            x: this.hiddenBall.x,
            y: this.hiddenBall.y
        };
        this.hiddenBall.body.force.y = 0;
        this.hiddenBall.body.force.x = 0;
        this.hiddenBall.setVelocity((pointerX - this.startPos.x) * this.speed, (pointerY - this.startPos.y) * this.speed);
        const projectionLineData = [];
        let projectionLineLength = 0;
        let updateCounter = 0;
        do {
            updateCounter += 1;
            this.hiddenBall.body.force.y += this.hiddenBall.body.mass * this.gravityScale * 0.001; // gravityScale;
            // Run matterjs engine's update on our body
            Phaser.Physics.Matter.Matter.Body.update(this.hiddenBall.body, 16.666666666666668, 1, 1);
            this.hiddenBall.body.force.x = 0;
            this.hiddenBall.body.force.y = 0;
            this.hiddenBall.body.torque = 0;
            if (updateCounter >= $ce75fde1e385681e$var$SKIP_UPDATE_NUM) {
                const ballUpdateDistance = Phaser.Math.Distance.Between(previousPos.x, previousPos.y, this.hiddenBall.x, this.hiddenBall.y);
                if (this.hiddenBall.y < this.minY) projectionLineData.push({
                    x: this.hiddenBall.x,
                    y: this.hiddenBall.y
                });
                previousPos.x = this.hiddenBall.x;
                previousPos.y = this.hiddenBall.y;
                projectionLineLength += ballUpdateDistance;
                updateCounter = 0;
            }
        }while (projectionLineLength < $ce75fde1e385681e$var$PROJECTION_LINE_LENGTH);
        this.hideHiddenBall();
        for(let index = 0; index < projectionLineData.length; index += 1){
            const point = projectionLineData[index];
            const projectionPoint = this.projectionPointsGroup.getFirstDead();
            if (projectionPoint) {
                projectionPoint.setScale($ce75fde1e385681e$var$POINT_SCALE);
                projectionPoint.x = point.x;
                projectionPoint.y = point.y;
                projectionPoint.setVisible(true);
                projectionPoint.setActive(true);
            }
        }
    }
    hideHiddenBall() {
        // HACK: Move the object further away, to use it later (cannot find away to temporarily remove)
        this.hiddenBall.x = 9999;
        this.hiddenBall.y = 9999;
    }
}


class $0ad3efc9ab2217f0$export$55db55b27d5d4dcf extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BEERPONG,
            duration: 10000,
            startScreenColor: 0xFDFF62,
            startText: "SPORTS!",
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BEERPONG.END,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.COFFEE,
            endButtons: {
                normalNoSkip: {
                    x: 426.5,
                    y: 75,
                    scale: 1.25
                },
                normalWithSkip: {
                    x: 272,
                    y: 75,
                    scale: 1.25
                },
                skip: {
                    x: 540,
                    y: 75,
                    scale: 1.25
                }
            }
        });
        //Images
        //values
        this.speed = 0.15;
        this.ballMass = 100;
        this.cupMass = 800;
        this.ballScale = 0.75;
        this.gravityScale = 1.81;
        this.ballStartPos = {
            x: 236,
            y: 211
        };
        this.maxBallCupDistance = 22;
        this.cupsConfig = [
            {
                x: 752,
                y: 307,
                scale: 0.75
            },
            {
                x: 606,
                y: 307,
                scale: 0.75
            },
            {
                x: 680,
                y: 307,
                scale: 0.75
            }
        ];
        this.aimingConfig = {
            from: {
                x: 284,
                y: 127
            },
            to: {
                x: 327,
                y: 114
            },
            duration: 1500
        };
        this.cupBackYOffset = 50;
        this.cupBackXOffset = 3;
        this.cups = [];
        this.allCupsFilled = false;
        this.endTimer = null;
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.balls = [];
        this.projectionLine = null;
        this.cups = [];
        this.allCupsFilled = false;
        this.endTimer = null;
        this.aimingImage = null;
    }
    _preload() {}
    _create() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BEERPONG.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(520, 410, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BEERPONG.DUNKTEXT).setDepth(1);
        this.initPhysics();
        this.input.on("pointerdown", (pointer)=>{
            //console.log("pointer down x " + pointer.x + " y " + pointer.y);
            this.throwBall();
        });
        this.initAiming();
        this.createCups();
    }
    initAiming() {
        this.aimingImage = this.add.image(this.aimingConfig.from.x, this.aimingConfig.from.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK.NOTE_1).setDepth(100).setScale(0.5).setVisible(false);
        this.tweens.add({
            targets: this.aimingImage,
            x: this.aimingConfig.to.x,
            y: this.aimingConfig.to.y,
            ease: "Sine.easeInOut",
            duration: this.aimingConfig.duration,
            repeat: -1,
            yoyo: true
        });
        this.projectionLine = new (0, $ce75fde1e385681e$export$2e2bcd8739ae039)(this, this.ballStartPos.x, this.ballStartPos.y, this.ballScale, this.ballMass, this.speed, this.gravityScale, 260);
    }
    createCups() {
        this.cupsConfig.forEach((config)=>{
            this.add.image(config.x - this.cupBackXOffset, config.y - this.cupBackYOffset, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BEERPONG.CUP_BACK).setDepth(3).setScale(config.scale);
            var cup = this.matter.add.image(config.x, config.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BEERPONG.CUP_FRONT, null, {
                shape: this.physicsShapes.FRONT
            }).setDepth(9).setStatic(true) //TODO: uncomment this to make cups movable
            .setFriction(0.7).setMass(this.cupMass).setScale(config.scale);
            cup.label = "cup" + config.x;
            this.cups.push(cup);
        });
    }
    initPhysics() {
        this.physicsShapes = this.cache.json.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).PHYSICS.BEERPONG);
        this.matter.add.rectangle(526, 337, 610, 25, {
            isStatic: true
        });
        this.matter.world.setGravity(0, this.gravityScale);
    }
    throwBall() {
        var ball = this.createBall();
        ball.isShot = false;
        ball.update = (delta)=>{
            if (!ball.isShot) {
                ball.isShot = true;
                var force = this.GetSpeedFrom({
                    x: ball.x,
                    y: ball.y
                }, {
                    x: this.aimingImage.x,
                    y: this.aimingImage.y
                });
                var multiplier = 0.62;
                ball.setStatic(false);
                //ball.applyForce(new Phaser.Math.Vector2(multiplier*force.x, multiplier*force.y));
                ball.setVelocity(force.x, force.y);
            }
        };
        this.balls.push(ball);
    }
    createBall() {
        return this.matter.add.image(this.ballStartPos.x, this.ballStartPos.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BEERPONG.BALL, null, //{chamfer: {radius: 20}}
        {
            label: "ball",
            isStatic: true
        }).setFrictionAir(0).setDepth(5).setCircle().setBounce(0.7).setFriction(0.4).setScale(this.ballScale, this.ballScale).setMass(this.ballMass).setStatic(true);
    }
    GetSpeedFrom(from, to) {
        return {
            x: (to.x - from.x) * this.speed,
            y: (to.y - from.y) * this.speed
        };
    }
    _update(time, delta) {
        this.balls.forEach((ball)=>{
            ball.update(delta);
        });
        this.projectionLine.updateProjectionPoints(this.aimingImage.x, this.aimingImage.y);
        this.checkForWin();
    }
    checkForWin() {
        if (!this.isCurrentState((0, $15b72a9ad2952278$export$fadd21211b40c08a).GAMESTATE.PLAYING)) return;
        this.updateCups();
        if (this.endTimer == null && this.allCupsFilled) this.endTimer = this.time.delayedCall(1000, ()=>{
            this.tryTriggerWin();
        }, null, this);
    //console.log("Cup1: " + this.cups[0].filled + " cup2: " + this.cups[1].filled + " cup3: " + this.cups[2].filled);
    }
    tryTriggerWin() {
        this.updateCups();
        if (this.allCupsFilled) this.triggerWin();
    }
    updateCups() {
        this.cups.forEach((cup)=>{
            cup.filled = false;
            for (let ball of this.balls)if (Phaser.Math.Distance.Between(ball.x, ball.y, cup.x, cup.y) < this.maxBallCupDistance) {
                cup.filled = true;
                break;
            }
        });
        this.allCupsFilled = true;
        for (var cup of this.cups)if (!cup.filled) {
            this.allCupsFilled = false;
            break;
        }
    }
    _timeout() {
        if (this.endTimer != null) this.endTimer.destroy();
        this.updateCups();
        if (this.allCupsFilled) this.winGame(0);
        else this.loseGame();
    }
    _afterLoss() {}
    _afterWin() {}
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.winGame(0);
    }
}



var $de6f59592cbbbb2f$var$LoadType;
(function(LoadType) {
    LoadType[LoadType["JSON"] = 1] = "JSON";
    LoadType[LoadType["IMAGE"] = 2] = "IMAGE";
    LoadType[LoadType["AUDIO"] = 3] = "AUDIO";
})($de6f59592cbbbb2f$var$LoadType || ($de6f59592cbbbb2f$var$LoadType = {}));
class $de6f59592cbbbb2f$export$2e2bcd8739ae039 {
    constructor(loadScene, options){
        this.loadScene = loadScene;
        this.requiredFor = typeof options.requiredFor === "undefined" ? [] : options.requiredFor;
        this.imagesKey = typeof options.imagesKey === "undefined" ? false : options.imagesKey;
        this.animations = typeof options.animations === "undefined" ? false : options.animations;
        this.physics = typeof options.physics === "undefined" ? false : options.physics;
        this.audio = typeof options.audio === "undefined" ? false : options.audio;
        this.loadedCallback = typeof options.loadedCallback === "undefined" ? false : options.loadedCallback;
        this.tag = typeof options.tag === "undefined" ? [] : options.tag;
        this.loaded = false;
        this.loading = false;
        this.remainingFiles = [];
    }
    Load() {
        this.loading = true;
        this.loadFiles(this.imagesKey, 2);
        this.loadFiles(this.animations, 1);
        this.loadFiles(this.physics, 1);
        this.loadFiles(this.audio, 3);
        this.checkIfLoaded();
    }
    isBlockingScene(sceneName) {
        //If chunk is not loaded and chunk is required for scene -> chunk is blocking scene 
        return !this.loaded && this.requiredFor.indexOf(sceneName) !== -1;
    }
    handleFileComplete(key) {
        //If completed file is part of this chunk -> remove it from list of remaining files
        var fileIndex = this.remainingFiles.indexOf(key);
        if (fileIndex === -1) return;
        this.remainingFiles.splice(fileIndex, 1);
        this.checkIfLoaded();
    }
    checkIfLoaded() {
        this.loaded = this.remainingFiles.length == 0;
        if (this.loaded) {
            this.loading = false;
            // console.log(this.requiredFor[0] + " CHUNK LOADED");
            if (this.loadedCallback) this.loadedCallback();
        }
    }
    loadFiles(files, loadType) {
        if (!files) return;
        for(let f in files){
            if (this.isAlreadyLoaded(files[f], loadType)) continue;
            switch(loadType){
                case 1:
                    this.loadScene.load.json(files[f], files[f]);
                    break;
                case 3:
                    this.loadScene.load.audio(files[f], files[f]);
                    break;
                case 2:
                    this.loadScene.load.image(files[f], files[f]);
                    break;
            }
            this.remainingFiles.push(files[f]);
        }
    }
    hasTag(tag) {
        return this.tag.some((t)=>t === tag);
    }
    isLoaded() {
        return this.loaded;
    }
    isLoading() {
        return this.loading;
    }
    isAlreadyLoaded(key, loadType) {
        var data = this.GetCacheDataForKey(key, loadType);
        return !(data === undefined || data === "__MISSING");
    }
    GetCacheDataForKey(key, loadType) {
        switch(loadType){
            case 1:
                return this.loadScene.cache.json.get(key);
            case 3:
                return this.loadScene.cache.audio.get(key);
            case 2:
                return this.loadScene.textures.get(key).key;
        }
    }
}


class $2fba7fa75fad9307$export$1786b98a6337e7e4 extends Phaser.Scene {
    constructor(){
        super({
            key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PROGRESSIVE_LOAD
        });
        this.loadQueue = [];
        this.loadedChunks = [];
    }
    //Load 
    init() {
        this.registry.set((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PROGRESSIVE_LOAD, this);
        this.loadQueue = [
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BIRTH
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BIRTH,
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.CRY
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.TALK
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).TALK,
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.TALK,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.POP
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.SOUNDTRACK
                ],
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.SOUNDTRACK
                ],
                loadedCallback: ()=>{
                    this.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.SOUNDTRACK).switchMusic();
                }
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.SCHOOL
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCHOOL,
                animations: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.SCHOOLEND
                ],
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PUBERTY
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PUBERTY,
                animations: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.PUBERTYEND
                ],
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.POP
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.FINDHER
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).FINDHER,
                animations: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.FINDHEREND
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BEERPONG
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BEERPONG,
                physics: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).PHYSICS.BEERPONG
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.COFFEE
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).COFFEE,
                animations: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.COFFEEEND
                ],
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MARRIAGE
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MARRIAGE,
                animations: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.MARRIAGEWIN,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.MARRIAGEFROWN
                ],
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.BOUNCE
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.KIDS
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).KIDS,
                animations: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDSSHOOTBABY,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.DADHEAD
                ],
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.CRY
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MIDLIFE,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.GRANDCHILDREN
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).MIDLIFE,
                animations: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.MIDLIFELEFTFOOT,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.MIDLIFERIGHTFOOT,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.MIDLIFEWIN
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.GRANDCHILDREN
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRANDCHILDREN,
                animations: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.GRANDPAMOVE,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.GRANDPALEFTHAND,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.GRANDPARIGHTHAND,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDTORSO,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDRIGHTLEG,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDLEFTLEG,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDDIEELECTRIC,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.KIDDIEFIRE
                ],
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.NOOO
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PILLS
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).PILLS,
                animations: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).ANIMATIONS.PILLSEND
                ],
                physics: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).PHYSICS.PILLS
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.DIE
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).DIE,
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.DIESONG,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.LIGHTNING
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.CREDITS
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).CREDITS
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.INSTRUMENT
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT,
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_1,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_2,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_3,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_4,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_5,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_6,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_7,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_FAIL,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.WIN,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.LOSE
                ],
                tag: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).TAGS.ARCADE,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.INSTRUMENT
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BURGER
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER,
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.WIN,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.LOSE,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.TRASH
                ],
                tag: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).TAGS.ARCADE,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BURGER
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.DISTRACTION
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION,
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.HELLO,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.PING_1,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.PING_2,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.LOSE,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.TV_OFF,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.TV_ON,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.VIBRATE,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.BOUNCE,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.POP,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.LOSE
                ],
                tag: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).TAGS.ARCADE,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.DISTRACTION
                ]
            }),
            new (0, $de6f59592cbbbb2f$export$2e2bcd8739ae039)(this, {
                requiredFor: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.GRID_FILL
                ],
                imagesKey: (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL,
                audio: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.FLASH,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.WIN,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.LOSE
                ],
                tag: [
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).TAGS.ARCADE,
                    (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.GRID_FILL
                ]
            })
        ];
    }
    preload() {
        this.load.on("filecomplete", (key, file)=>{
            //console.log("File complete: " + key);
            if (!this.currChunk) return;
            this.currChunk.handleFileComplete(key);
        }, this);
    }
    update() {
        this.loadNextChunkNew();
    }
    loadNextChunkNew() {
        //return if all chunks are loaded
        if (this.loadQueue.length == 0 && !this.currChunk) return;
        //Start loading next chunk if nothing is loading at the moment
        if (!this.currChunk) {
            //console.log("loading next chunk");
            this.currChunk = this.loadQueue.shift();
            return;
        }
        //Start loading current chunk if no chunk is loading already
        if (!this.currChunk.isLoaded() && !this.currChunk.isLoading()) {
            this.currChunk.Load();
            this.load.start();
        }
        //Add current chunk to loaded chunks after it is loaded
        if (this.currChunk.isLoaded()) {
            this.loadedChunks.push(this.currChunk);
            this.currChunk = undefined;
        }
    }
    prioritizeChunksWithTag(tag) {
        // console.log("Prioritizing chunks with tag: " + tag);
        var tagChunks = this.loadQueue.filter((chunk)=>chunk.hasTag(tag));
        var otherChunks = this.loadQueue.filter((chunk)=>!chunk.hasTag(tag));
        this.loadQueue = [
            ...tagChunks,
            ...otherChunks
        ];
    }
    isSceneLoaded(sceneName) {
        if (this.currChunk && this.currChunk.isBlockingScene(sceneName)) return false;
        for (let chunk of this.loadQueue){
            if (chunk.isBlockingScene(sceneName)) return false;
        }
        return true;
    }
}





const $e87dbb94a00ebc52$var$WHITE_IMG_DEPTH = 16;
const $e87dbb94a00ebc52$var$DARK_IMG_DEPTH = 15;
//animation
const $e87dbb94a00ebc52$var$MOUSE_OVER_SIZE = 1.2;
const $e87dbb94a00ebc52$var$ANIM_DURATION = 100;
const $e87dbb94a00ebc52$var$EASING = "Quad.easeOut";
const $e87dbb94a00ebc52$export$efbacf6570a21b5a = 250;
const $e87dbb94a00ebc52$var$SIM_CLICK_AFTER_ANIM_DURATION = 200;
var $e87dbb94a00ebc52$export$9e9c3b4596bcb2e8;
(function(KeyState) {
    KeyState[KeyState["Playing"] = 1] = "Playing";
    KeyState[KeyState["Listening"] = 2] = "Listening";
    KeyState[KeyState["Transitioning"] = 3] = "Transitioning";
})($e87dbb94a00ebc52$export$9e9c3b4596bcb2e8 || ($e87dbb94a00ebc52$export$9e9c3b4596bcb2e8 = {}));
class $e87dbb94a00ebc52$export$cd0f44441c3b7719 {
    constructor(scene, keyConfig, keyState){
        this.mouseOver = false;
        this.key = keyConfig.key;
        this.audio = keyConfig.audio;
        const xPos = keyConfig.x;
        const yPos = keyConfig.y;
        this.darkImage = scene.add.image(xPos, yPos, keyConfig.darkImage).setDepth($e87dbb94a00ebc52$var$DARK_IMG_DEPTH).setInteractive({
            useHandCursor: true,
            pixelPerfect: true,
            alphaTolerance: 1
        });
        this.darkImage.on("pointerover", ()=>{
            this.mouseOver = true;
            if (this.state == 1) this.setHighlight(true);
        }).on("pointerout", ()=>{
            this.mouseOver = false;
            if (this.state == 1) this.setHighlight(false);
        }).on("pointerdown", ()=>{
            if (this.state != 1) return;
            this.click();
        });
        this.whiteImage = scene.add.image(xPos, yPos, keyConfig.whiteImage).setDepth($e87dbb94a00ebc52$var$WHITE_IMG_DEPTH).setAlpha(0);
        this.errorImage = scene.add.image(xPos, yPos, keyConfig.whiteImage).setDepth($e87dbb94a00ebc52$var$WHITE_IMG_DEPTH + 0.1).setScale($e87dbb94a00ebc52$var$MOUSE_OVER_SIZE).setAlpha(0).setTint(0xff0000);
        this.scene = scene;
        this.state = keyState;
    }
    bounce() {
        this.whiteImage.setScale(1, 1);
        this.darkImage.setScale(1, 1);
        this.setHighlight(true);
    }
    setHighlight(highlighted, duration = $e87dbb94a00ebc52$var$ANIM_DURATION) {
        //if (highlighted && this.state != KeyState.Playing) return;
        if (this.darkTween) this.darkTween.stop();
        if (this.whiteTween) this.whiteTween.stop();
        if (highlighted) {
            this.whiteTween = this.scene.tweens.add({
                targets: this.whiteImage,
                alpha: 1,
                scaleX: $e87dbb94a00ebc52$var$MOUSE_OVER_SIZE,
                scaleY: $e87dbb94a00ebc52$var$MOUSE_OVER_SIZE,
                ease: $e87dbb94a00ebc52$var$EASING,
                duration: duration
            });
            this.darkTween = this.scene.tweens.add({
                targets: this.darkImage,
                scaleX: $e87dbb94a00ebc52$var$MOUSE_OVER_SIZE,
                scaleY: $e87dbb94a00ebc52$var$MOUSE_OVER_SIZE,
                ease: $e87dbb94a00ebc52$var$EASING,
                duration: duration
            });
        } else {
            this.whiteTween = this.scene.tweens.add({
                targets: this.whiteImage,
                alpha: 0,
                scaleX: 1,
                scaleY: 1,
                ease: $e87dbb94a00ebc52$var$EASING,
                duration: duration
            });
            this.darkTween = this.scene.tweens.add({
                targets: this.darkImage,
                scaleX: 1,
                scaleY: 1,
                ease: $e87dbb94a00ebc52$var$EASING,
                duration: duration
            });
        }
    }
    click() {
        this.bounce();
        setTimeout(()=>{
            this.scene.sound.play(this.audio);
        }, $e87dbb94a00ebc52$export$efbacf6570a21b5a);
        if (this.state == 1) this.clickCallback();
    }
    simulateClick() {
        //stage 1: animate highlight
        this.setHighlight(true, $e87dbb94a00ebc52$export$efbacf6570a21b5a);
        //stage 2: click + bounce
        setTimeout(()=>{
            this.bounce();
            this.scene.sound.play(this.audio);
        }, $e87dbb94a00ebc52$export$efbacf6570a21b5a);
        //stage 3: highlight out
        setTimeout(()=>{
            this.setHighlight(false, $e87dbb94a00ebc52$var$SIM_CLICK_AFTER_ANIM_DURATION);
        }, $e87dbb94a00ebc52$export$efbacf6570a21b5a + $e87dbb94a00ebc52$var$SIM_CLICK_AFTER_ANIM_DURATION);
    }
    displayMistake() {
        setTimeout(()=>{
            this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_FAIL);
        }, $e87dbb94a00ebc52$export$efbacf6570a21b5a);
        this.scene.tweens.add({
            targets: this.errorImage,
            alpha: 1,
            ease: $e87dbb94a00ebc52$var$EASING,
            duration: $e87dbb94a00ebc52$export$efbacf6570a21b5a,
            hold: 500,
            yoyo: true
        });
    }
    updateState(newState) {
        this.state = newState;
        this.setHighlight(this.mouseOver && this.state == 1);
    }
}





const $b61ad51a39bc02fc$var$CONFIG = {
    startPosition: {
        x: 400,
        y: 255
    },
    head: {
        xOffset: -3,
        yOffset: -32
    },
    leftHand: {
        xOffset: 45,
        yOffset: -10
    },
    rightHandTop: {
        xOffset: -53,
        yOffset: -13
    },
    rightHandBottom: {
        xOffset: -120,
        yOffset: 9
    }
};
const $b61ad51a39bc02fc$var$ANIMATION_CONFIG = {
    1: {
        charX: 320,
        charY: 240
    },
    2: {
        charX: 392,
        charY: 248
    },
    3: {
        charX: 464,
        charY: 256
    },
    4: {
        charX: 535,
        charY: 265
    },
    5: {
        charX: 606,
        charY: 273
    },
    6: {
        charX: 679,
        charY: 281
    },
    7: {
        charX: 750,
        charY: 290
    },
    idle: {
        charX: 350,
        charY: 255
    },
    playStart: {
        charX: 500,
        charY: 260
    }
};
class $b61ad51a39bc02fc$export$cb68cc2163cd3f1 {
    constructor(scene, gameState){
        this.scene = scene;
        this.state = gameState;
        this.updateState(gameState);
        //Add images
        this.character = this.scene.add.image($b61ad51a39bc02fc$var$CONFIG.startPosition.x, $b61ad51a39bc02fc$var$CONFIG.startPosition.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.CHARACTER_BODY).setDepth(5).setOrigin(0.7, 0.18);
        this.leftHand = this.scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.HAND_LEFT).setDepth(4).setOrigin(0.06, 0.72);
        this.rightHandTop = this.scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.HAND_RIGHT_TOP).setDepth(7).setOrigin(0.85, 0.70);
        this.rightHandBottom = this.scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.HAND_RIGHT_BOTTOM).setDepth(17).setOrigin(0.37, 0.35);
        this.head = this.scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.CHARACTER_HEAD).setDepth(6).setOrigin(0.4, 0.90);
        this.updateBodyPosition();
        this.scene.events.on("update", this.update, this);
    }
    updateState(newState) {
        if (newState == (0, $93de182afd578cb5$export$eb5ccdbd077479c).Playing) this.startPlayingAnimation();
        else if (newState == (0, $93de182afd578cb5$export$eb5ccdbd077479c).Listening) ;
        else if (newState == (0, $93de182afd578cb5$export$eb5ccdbd077479c).Transitioning) {
            if (this.state == (0, $93de182afd578cb5$export$eb5ccdbd077479c).Listening) //Going from listening to playing
            this.transitionAnimationListenToPlay();
            else if (this.state == (0, $93de182afd578cb5$export$eb5ccdbd077479c).Playing) //Going from playing to listening
            this.startIdleAnimation();
        }
        this.state = newState;
    }
    startIdleAnimation() {
        this.scene.time.addEvent({
            delay: 500,
            callback: ()=>{
                //Move character to center
                //Rotate hands down
                this.stopRightHandAnim();
                //Character move
                this.scene.tweens.add({
                    targets: this.character,
                    x: $b61ad51a39bc02fc$var$ANIMATION_CONFIG.idle.charX,
                    y: $b61ad51a39bc02fc$var$ANIMATION_CONFIG.idle.charY,
                    ease: "Quad.easeInOut",
                    duration: 500,
                    repeat: 0,
                    yoyo: false
                });
                this.stopLeftHandAnim();
                this.leftHandAnim = this.scene.tweens.add({
                    targets: this.leftHand,
                    angle: 50,
                    ease: "Cubic.easeInOut",
                    duration: 500
                });
                this.stopRightHandAnim();
                this.rightHandAnim = this.scene.tweens.add({
                    targets: this.rightHandBottom,
                    angle: -90,
                    ease: "Cubic.easeInOut",
                    duration: 1000
                });
            },
            callbackScope: this
        });
    }
    startPlayingAnimation() {
        this.startLeftHandAnim();
        this.startRightHandAnim();
    }
    transitionAnimationListenToPlay() {
        //Character move
        this.scene.tweens.add({
            targets: this.character,
            x: $b61ad51a39bc02fc$var$ANIMATION_CONFIG.playStart.charX,
            y: $b61ad51a39bc02fc$var$ANIMATION_CONFIG.playStart.charY,
            ease: "Quad.easeInOut",
            duration: 500,
            repeat: 0,
            yoyo: false,
            delay: 300
        });
        this.stopLeftHandAnim();
        this.leftHandAnim = this.scene.tweens.add({
            targets: this.leftHand,
            angle: 0,
            ease: "Cubic.easeInOut",
            duration: 1000
        });
        this.stopRightHandAnim();
        this.rightHandAnim = this.scene.tweens.add({
            targets: this.rightHandBottom,
            angle: 0,
            ease: "Cubic.easeInOut",
            duration: 1000
        });
    }
    updateBodyPosition() {
        var updateBodyPart = (img, origin, conf, followRotation = false)=>{
            img.setPosition(origin.x + conf.xOffset, origin.y + conf.yOffset);
            if (followRotation) img.setRotation(origin.rotation);
        };
        updateBodyPart(this.leftHand, this.character, $b61ad51a39bc02fc$var$CONFIG.leftHand);
        updateBodyPart(this.rightHandTop, this.character, $b61ad51a39bc02fc$var$CONFIG.rightHandTop);
        updateBodyPart(this.rightHandBottom, this.rightHandTop, $b61ad51a39bc02fc$var$CONFIG.rightHandBottom);
        updateBodyPart(this.head, this.character, $b61ad51a39bc02fc$var$CONFIG.head);
    }
    startLeftHandAnim() {
        this.stopLeftHandAnim();
        this.leftHandAnim = this.scene.tweens.add({
            targets: this.leftHand,
            angle: -5,
            ease: "Cubic.easeInOut",
            duration: 1000,
            repeat: -1,
            yoyo: true
        });
    }
    stopLeftHandAnim() {
        if (this.leftHandAnim) this.leftHandAnim.stop();
    }
    startRightHandAnim() {
        this.stopRightHandAnim();
        this.rightHandAnim = this.scene.tweens.add({
            targets: this.rightHandBottom,
            angle: -4,
            ease: "Cubic.easeInOut",
            duration: 1000,
            repeat: -1,
            yoyo: true
        });
    }
    stopRightHandAnim() {
        if (this.rightHandAnim) this.rightHandAnim.stop();
    }
    animateNote(note) {
        var fullTime = (0, $e87dbb94a00ebc52$export$efbacf6570a21b5a);
        //Character move
        this.scene.tweens.add({
            targets: this.character,
            x: $b61ad51a39bc02fc$var$ANIMATION_CONFIG[note.key].charX,
            y: $b61ad51a39bc02fc$var$ANIMATION_CONFIG[note.key].charY,
            ease: "Quad.easeInOut",
            duration: fullTime * 0.9,
            repeat: 0,
            yoyo: false
        });
        this.stopRightHandAnim();
        //Right hand move up
        this.scene.tweens.add({
            targets: this.rightHandBottom,
            angle: -20,
            ease: "Cubic.easeInOut",
            duration: fullTime * 0.1,
            repeat: 0,
            delay: fullTime - fullTime * 0.25,
            yoyo: false
        });
        //Right hand strike
        this.scene.tweens.add({
            targets: this.rightHandBottom,
            angle: 20,
            ease: "Cubic.easeInOut",
            duration: fullTime * 0.15,
            repeat: 0,
            yoyo: false,
            delay: fullTime - fullTime * 0.15
        });
        //Right hand reset
        this.scene.tweens.add({
            targets: this.rightHandBottom,
            angle: 0,
            ease: "Cubic.easeInOut",
            duration: fullTime * 0.2,
            repeat: 0,
            yoyo: false,
            delay: fullTime,
            onComplete: function() {
                this.startRightHandAnim();
            },
            onCompleteScope: this
        });
    }
    update() {
        this.updateBodyPosition();
    }
}



class $3f010fa5bfb89089$export$2e2bcd8739ae039 extends Phaser.GameObjects.Image {
    constructor(pointsToScene, x, y, scene, texture = (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.BACK){
        super(scene, x, y, texture);
        scene.storagePlugin.setItem("openArcadePopup", "1");
        this.setInteractive({
            useHandCursor: true
        });
        this.on("pointerup", ()=>{
            if (scene.rewardedBreakRequested) return;
            scene.scene.start(pointsToScene);
        });
        scene.add.existing(this);
    }
}


class $526fb0004cf1157b$export$2e2bcd8739ae039 extends Phaser.GameObjects.Image {
    constructor(x, y, scene, texture){
        super(scene, x, y, texture);
        this.setInteractive({
            useHandCursor: true
        });
        this.on("pointerup", ()=>{
            scene.restartGame();
        });
        scene.add.existing(this);
    }
}


class $bee7b1f49e5c2618$export$2e2bcd8739ae039 extends Phaser.GameObjects.Image {
    constructor(x, y, scene, texture, levelData){
        super(scene, x, y, texture);
        this.setInteractive({
            useHandCursor: true
        });
        this.on("pointerup", ()=>{
            let data = levelData();
            scene.arcadeContinueLevel(data);
        });
        scene.add.existing(this);
    }
}



const $d10c123547220493$var$config = {
    position: {
        x: 47,
        y: 45
    },
    spacing: 54,
    depth: 10,
    anim: {
        duration: 500,
        ease: "Quad.easeInOut"
    }
};
class $d10c123547220493$export$d79bf8862df78755 {
    constructor(scene, hearts){
        this.hearts = [];
        this.scene = scene;
        for(let i = 0; i < hearts; i++)this.hearts.push(new $d10c123547220493$var$Heart(scene, $d10c123547220493$var$config.position.x + i * $d10c123547220493$var$config.spacing, $d10c123547220493$var$config.position.y, true));
    }
    updateHearts(heartCount) {
        for(let i = 0; i < this.hearts.length; i++)this.hearts[i].setState(i < heartCount);
    }
}
class $d10c123547220493$var$Heart {
    constructor(scene, x, y, isFull){
        this.scene = scene;
        this.bg = scene.add.image(x, y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.HEART_EMPTY).setDepth($d10c123547220493$var$config.depth);
        this.heart = scene.add.image(x, y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.HEART).setDepth($d10c123547220493$var$config.depth + 1);
        this.isFull = isFull;
        if (!isFull) this.heart.setAlpha(0);
    }
    setState(full) {
        this.isFull = full;
        let targetAlpha = full ? 1 : 0;
        if (this.fadeTween) this.fadeTween.stop();
        this.fadeTween = this.scene.tweens.add({
            targets: this.heart,
            alpha: targetAlpha,
            delay: 250,
            duration: $d10c123547220493$var$config.anim.duration,
            ease: $d10c123547220493$var$config.anim.ease
        });
    }
}



var $93de182afd578cb5$export$eb5ccdbd077479c;
(function(GameState) {
    GameState[GameState["Playing"] = 1] = "Playing";
    GameState[GameState["Listening"] = 2] = "Listening";
    GameState[GameState["Transitioning"] = 3] = "Transitioning";
})($93de182afd578cb5$export$eb5ccdbd077479c || ($93de182afd578cb5$export$eb5ccdbd077479c = {}));
class $93de182afd578cb5$export$2d5bc55a67026bc1 extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.INSTRUMENT,
            duration: 999999999,
            showCountdown: 0,
            showHomeButton: false,
            timeToStart: 1000,
            startScreenColor: 0xCADA40,
            startText: "LISTEN\nAND REPEAT!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.END,
            showSkipButton: false,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BIRTH,
            endButtons: {
                normalNoSkip: {
                    x: -426.5,
                    y: 386,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 283,
                    y: 386,
                    scale: 1.30
                },
                skip: {
                    x: 570,
                    y: 386,
                    scale: 1.30
                }
            },
            isArcadeMinigame: true
        });
        this.minigameConfig = {
            lives: 3,
            startDifficulty: 2,
            notesPerDifficulty: 1,
            delayBeforeListeningStart: 2000,
            delayBeforePlayingStart: 1000,
            noteLength: {
                min: 500,
                max: 1250,
                step: 250
            }
        };
        this.keysConfig = [
            {
                key: 1,
                x: 205,
                y: 305,
                darkImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_DARK_1,
                whiteImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_WHITE_1,
                audio: (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_1
            },
            {
                key: 2,
                x: 278,
                y: 314,
                darkImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_DARK_2,
                whiteImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_WHITE_2,
                audio: (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_2
            },
            {
                key: 3,
                x: 360,
                y: 320,
                darkImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_DARK_3,
                whiteImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_WHITE_3,
                audio: (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_3
            },
            {
                key: 4,
                x: 433,
                y: 332,
                darkImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_DARK_4,
                whiteImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_WHITE_4,
                audio: (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_4
            },
            {
                key: 5,
                x: 500,
                y: 340,
                darkImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_DARK_5,
                whiteImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_WHITE_5,
                audio: (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_5
            },
            {
                key: 6,
                x: 575,
                y: 348,
                darkImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_DARK_6,
                whiteImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_WHITE_6,
                audio: (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_6
            },
            {
                key: 7,
                x: 642,
                y: 358,
                darkImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_DARK_7,
                whiteImage: (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BAR_WHITE_7,
                audio: (0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.INSTRUMENT_7
            }
        ];
        this.isRestart = false;
        this.keys = [];
        this.state = 2;
        this.difficulty = 1;
        this.currentSong = [];
        this.currentSongIndex = -1;
        this.nextNoteTime = 0;
        this.currentScore = 0;
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.keys = [];
        this.state = 2;
        this.currentSong = [];
        this.currentSongIndex = -1;
        this.nextNoteTime = 0;
        this.currentLives = this.minigameConfig.lives;
        this.currentScore = 0;
        this.difficulty = this.minigameConfig.startDifficulty;
        this.currentLives = this.minigameConfig.lives;
        this.isRestart = this.checkForRestart();
    }
    checkForRestart() {
        let key = this.sceneName + "restart";
        let restartInfo = this.storagePlugin.getItem(key, "");
        if (restartInfo) {
            let parsed = JSON.parse(restartInfo);
            this.difficulty = parsed.difficulty;
            this.currentScore = parsed.score;
            this.currentSong = parsed.song;
            this.storagePlugin.removeItem(key);
            return true;
        }
        return false;
    }
    _preload() {}
    _create() {
        this.createBackground();
        this.createCharacter();
        this.createKeys();
        this.pauseMusic(true);
        this.heartDisplay = new (0, $d10c123547220493$export$d79bf8862df78755)(this, this.currentLives);
        this.homeButton = new (0, $ecb7686a60e0dea3$export$2e2bcd8739ae039)(this, 40, this.renderer.height - 40).setDepth(30).setScrollFactor(0, 0, true).setScale(0.75);
        this.homeButton.addExitEvent(()=>{
            this.pauseMusic(false);
        });
        this.startListeningPhase(true);
    }
    onGameStarted() {}
    createBackground() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BACKGROUND).setOrigin(0, 0).setDepth(0).setScale(1.05, 1);
        this.add.image(0, 480, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.TABLE).setOrigin(0, 1).setDepth(10);
    }
    createCharacter() {
        this.character = new (0, $b61ad51a39bc02fc$export$cb68cc2163cd3f1)(this, 1);
    }
    createKeys() {
        this.keysConfig.forEach((config)=>{
            let key = new (0, $e87dbb94a00ebc52$export$cd0f44441c3b7719)(this, config, (0, $e87dbb94a00ebc52$export$9e9c3b4596bcb2e8).Playing);
            key.clickCallback = ()=>{
                this.handleKeyClick(config.key);
            };
            this.keys.push(key);
        });
    }
    startListeningPhase(firstTime = false) {
        if (!firstTime) this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.WIN, {
            volume: 0.2,
            delay: 0.75
        });
        this.updateGameState(3);
        this.time.addEvent({
            delay: this.minigameConfig.delayBeforeListeningStart,
            callback: ()=>{
                //Starts listening phase
                this.updateGameState(2);
                if (!firstTime) this.difficulty += 1;
                this.currentSongIndex = -1;
                this.updateCurrentSong();
            },
            callbackScope: this
        });
    }
    startPlayingPhase() {
        this.updateGameState(3);
        this.time.addEvent({
            delay: this.minigameConfig.delayBeforePlayingStart,
            callback: ()=>{
                this.updateGameState(1);
                this.currentSongIndex = 0;
            },
            callbackScope: this
        });
    }
    updateCurrentSong() {
        let notesToPlay = this.difficulty * this.minigameConfig.notesPerDifficulty;
        for(let i = this.currentSong.length; i < notesToPlay; i++)this.currentSong.push(this.getRandomNote());
    }
    getRandomNote() {
        //get random key from keyconfig, add random duration
        var note = this.keysConfig[this.getRandomInt(0, this.keysConfig.length - 1)];
        var maxTimeSteps = Math.round((this.minigameConfig.noteLength.max - this.minigameConfig.noteLength.min) / this.minigameConfig.noteLength.step);
        var noteLen = this.minigameConfig.noteLength.min + this.getRandomInt(0, maxTimeSteps) * this.minigameConfig.noteLength.step;
        return {
            key: note.key,
            time: noteLen
        };
    }
    updateGameState(newState) {
        this.state = newState;
        this.keys.forEach((key)=>{
            key.updateState(newState);
        });
        this.character.updateState(newState);
    }
    //Triggers when a key is clicked while in play mode
    handleKeyClick(keyCode) {
        this.character.animateNote({
            key: keyCode,
            time: 500
        });
        let expectedNote = this.currentSong[this.currentSongIndex];
        //Check for mistake
        if (keyCode != expectedNote.key) this.handleWrongNote(keyCode);
        else this.handleCorrectNote();
    }
    handleCorrectNote() {
        this.currentScore++;
        this.currentSongIndex++;
        //Transition out of playing phase if the whole song was played already
        if (this.currentSongIndex >= this.currentSong.length) this.startListeningPhase();
    }
    handleWrongNote(note) {
        this.currentLives--;
        this.heartDisplay.updateHearts(this.currentLives);
        this.keys.forEach((key)=>{
            if (key.key == note) key.displayMistake();
        });
        if (this.currentLives <= 0) this.triggerLose();
        else this.startListeningPhase(true);
    }
    _update(time, delta) {
        this.updateListeningPhase(time);
    }
    updateListeningPhase(time) {
        if (this.state != 2) return;
        //Transition out of listening phase if the whole song was played already
        if (this.currentSongIndex >= this.currentSong.length) {
            this.startPlayingPhase();
            return;
        }
        //Play the song if we are in listening phase
        if (time > this.nextNoteTime) this.playNextNote(time);
    }
    //Plays the next note of the song in listening phase
    playNextNote(startTime) {
        this.currentSongIndex++;
        if (this.currentSongIndex >= this.currentSong.length) return;
        let note = this.currentSong[this.currentSongIndex];
        this.nextNoteTime = startTime + note.time;
        this.keys.forEach((key)=>{
            if (key.key == note.key) key.simulateClick();
        });
    }
    _timeout() {}
    _afterLoss() {
        this.pauseMusic(false);
    }
    _afterWin() {}
    triggerLose() {
        this.homeButton.setVisible(false);
        setTimeout(()=>{
            this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.LOSE);
        }, 750);
        this.saveAndDisplayScore();
        this.updateGameState(3);
        this.loseGame(2000);
    }
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.winGame(1000);
    }
    saveAndDisplayScore() {
        var score = this.currentScore;
        var oldHighscore = this.getHighscore();
        var isNewHighscore = score > oldHighscore;
        this.displayScore(score, isNewHighscore, oldHighscore);
        if (isNewHighscore) this.setHighscore(score);
        this.sendFinalScoreAnalyticsEvent(score);
    }
    displayScore(score, isHighscore, oldHighscore) {
        this.endScoreDisplay.text = score.toString();
        let scoreLength = this.endScoreDisplay.text.length;
        if (scoreLength == 1) {
            this.endScoreDisplay.x = 241;
            this.highscoreImage.x = 272;
            this.highscoreImage.y = 320;
        }
        if (scoreLength == 2) {
            this.endScoreDisplay.x = 230;
            this.highscoreImage.x = 272;
            this.highscoreImage.y = 319;
        }
        if (scoreLength >= 3) {
            this.endScoreDisplay.x = 222;
            this.highscoreImage.x = 277;
            this.highscoreImage.y = 320;
        }
        this.highscoreImage.setAlpha(isHighscore ? 1 : 0);
    }
    pauseMusic(pause) {
        this.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.SOUNDTRACK).pauseMusic(pause);
    }
    getCustomLoseUIElements() {
        this.highscoreImage = this.add.image(277, 320, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.NEW_BEST).setDepth(3);
        this.endScoreDisplay = this.add.text(224, 318, "123", {
            fontFamily: "bloggerSans",
            fontSize: 35,
            color: "#EB5166",
            align: "center"
        }).setDepth(2);
        if (this.isRestart || this.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).REGISTRY.ADBLOCKENABLED)) {
            //Without continue button
            var backButton2 = new (0, $3f010fa5bfb89089$export$2e2bcd8739ae039)((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU, 150, 402, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BACK_2).setScale(1.1);
            var tryAgainButton2 = new (0, $526fb0004cf1157b$export$2e2bcd8739ae039)(299, 391, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.TRY_AGAIN_2).setScale(1.1).setDepth(2);
            return [
                backButton2,
                tryAgainButton2,
                this.endScoreDisplay,
                this.highscoreImage
            ];
        } else {
            //With continue button
            var backButton = new (0, $3f010fa5bfb89089$export$2e2bcd8739ae039)((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU, 235, 439, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.BACK).setScale(1.1);
            var continueButton = new (0, $bee7b1f49e5c2618$export$2e2bcd8739ae039)(304, 389, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.CONTINUE, ()=>{
                return this.getContinueData();
            }).setScale(1.1);
            var tryAgainButton = new (0, $526fb0004cf1157b$export$2e2bcd8739ae039)(153, 397, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).INSTRUMENT.TRY_AGAIN).setDepth(2);
            return [
                backButton,
                continueButton,
                tryAgainButton,
                this.endScoreDisplay,
                this.highscoreImage
            ];
        }
    }
    getContinueData() {
        return {
            difficulty: this.difficulty,
            score: this.currentScore,
            song: this.currentSong
        };
    }
}




class $34565ebbfbfa097d$export$c1e33676c826b984 extends Phaser.Scene {
    constructor(){
        super({
            key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.ARCADE_MINIGAME_LOADING
        });
    }
    preload() {}
    init(data) {
        this.progressiveLoadScene = this.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.PROGRESSIVE_LOAD);
        this.nextScene = data.next;
    }
    create() {
        if (this.nextScene) this.progressiveLoadScene.prioritizeChunksWithTag(this.nextScene);
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).MENU.BACKGROUND).setOrigin(0, 0).setDepth(0);
        new (0, $3f010fa5bfb89089$export$2e2bcd8739ae039)((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU, 50, 50, this);
        this.createLoadingText();
        this.createSpinner();
    }
    createLoadingText() {
        this.add.bitmapText(this.game.renderer.width / 2, this.game.renderer.height / 2, (0, $15b72a9ad2952278$export$fadd21211b40c08a).FONT.ATLAS, "LOADING", 75).setOrigin(0.5, 0.25).setDepth(1001).setCenterAlign();
    }
    createSpinner() {
        var spinner = this.add.image(this.game.renderer.width / 2, this.game.renderer.height / 2 + 100, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.SPINNER).setDepth(1002).setVisible(true);
        this.tweens.add({
            targets: spinner,
            angle: "+=360",
            duration: 1000,
            ease: "Linear",
            repeat: -1
        });
    }
    update(time, delta) {
        if (!this.nextScene) return;
        if (this.progressiveLoadScene.isSceneLoaded(this.nextScene)) this.loadNextScene();
    }
    loadNextScene() {
        this.scene.start(this.nextScene);
    }
}





const $0ccfeab63f78a1e3$var$CONFIG = {
    width: 250,
    height: 15,
    depth: 40,
    startTween: {
        from: {
            y: -100
        },
        ease: "Quad.easeOut",
        duration: 500
    },
    endTween: {
        to: {
            y: -100
        },
        ease: "Quad.easeIn",
        duration: 500,
        delay: 500
    }
};
class $0ccfeab63f78a1e3$export$53819c0e58f98d49 extends Phaser.GameObjects.Container {
    constructor(config){
        super(config.scene, config.position.x, $0ccfeab63f78a1e3$var$CONFIG.startTween.from.y);
        this.countdownStartX = 0;
        this.countdownMoveX = 0;
        this.config = config;
        this.currentDuration = config.duration;
        this.isCountingDown = false;
        this.setScale(0.9);
        this.createChildren();
        this.setLoadingBarPercentage(1);
        this.setScrollFactor(0);
        config.scene.add.existing(this);
        this.config.scene.tweens.add({
            targets: this,
            y: config.position.y,
            ease: $0ccfeab63f78a1e3$var$CONFIG.startTween.ease,
            duration: $0ccfeab63f78a1e3$var$CONFIG.startTween.duration
        });
    }
    startCountdown() {
        this.timer = this.config.scene.time.addEvent({
            delay: this.config.duration,
            callback: this.config.onComplete
        });
        this.isCountingDown = true;
        return this;
    }
    stopCountdown() {
        this.timer.paused = true;
        this.config.scene.tweens.add({
            targets: this,
            y: $0ccfeab63f78a1e3$var$CONFIG.endTween.to.y,
            ease: $0ccfeab63f78a1e3$var$CONFIG.endTween.ease,
            duration: $0ccfeab63f78a1e3$var$CONFIG.endTween.duration,
            delay: $0ccfeab63f78a1e3$var$CONFIG.endTween.delay
        });
    }
    getRemainingTimeShare() {
        return 1 - this.timer.getProgress();
    }
    getElapsedTime() {
        return this.timer.getProgress() * this.currentDuration;
    }
    getTotalTime() {
        return this.currentDuration;
    }
    destroy() {
        this.timer.remove(false);
        this.maskShape.destroy();
        super.destroy();
    }
    createChildren() {
        let c1 = this.config.scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.COUNTDOWN_1); //bg
        let c3 = this.config.scene.add.image(1, 2, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.COUNTDOWN_3); //white bg
        this.countdownImage = this.config.scene.add.image(this.x + 1, this.y + 2, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.COUNTDOWN_2).setScrollFactor(0).setScale(this.scaleX, this.scaleY);
        this.maskShape = this.config.scene.add.graphics().fillStyle(0xffffff, 0).beginPath().fillRect(this.countdownImage.getTopLeft().x, 0, this.countdownImage.displayWidth, 500).setDepth($0ccfeab63f78a1e3$var$CONFIG.depth + 1);
        this.countdownStartX = this.maskShape.x;
        this.countdownMoveX = this.countdownImage.displayWidth;
        var mask = this.maskShape.createGeometryMask();
        this.countdownImage.setMask(mask);
        this.add([
            c1,
            c3
        ]);
    }
    setLoadingBarPercentage(percentage) {
        this.maskShape.x = this.countdownStartX - (1 - percentage) * this.countdownMoveX;
    }
    onUpdate() {
        if (!this.isCountingDown) return;
        this.setLoadingBarPercentage(this.getRemainingTimeShare());
        this.updateCountdownDisplay();
    }
    updateCountdownDisplay() {
        if (!this.countdownImage) return;
        this.countdownImage.setPosition(this.x + 1, this.y + 2).setDepth(this.depth + 1);
    }
}





const $669b36e24dae83b6$var$CONFIG = {
    invalidBlockColor: (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.BLOCK_GREY,
    defaultDepth: 20,
    dragDepth: 21,
    moveTween: {
        duration: 100,
        spawnDuration: 300,
        ease: "Back.easeOut"
    },
    fadeTween: {
        duration: 500,
        delay: 100,
        ease: "Quad.easeInOut"
    }
};
class $669b36e24dae83b6$export$d96a8827a60d6b69 extends Phaser.GameObjects.Image {
    constructor(config, shape, scene, gridOrigin, cellSize){
        super(scene, scene.game.renderer.width / 2, scene.game.renderer.height + 200, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.BACK);
        this.gameLost = false;
        this.config = config;
        this.gridOrigin = gridOrigin;
        this.cellSize = cellSize;
        this.shape = shape;
        this.setDepth($669b36e24dae83b6$var$CONFIG.defaultDepth);
        this.setDisplaySize(this.cellSize + 1, this.cellSize);
        this.setInteractive({
            useHandCursor: true,
            draggable: true
        });
        this.on("dragstart", (pointer, dragX, dragY)=>{
            this.shape.handleDragStart(this.x, this.y);
        });
        this.on("drag", (pointer, dragX, dragY)=>{
            if (this.gameLost) return;
            this.shape.handleDrag(dragX, dragY);
        });
        this.on("dragend", (pointer, dragX, dragY, dropped)=>{
            if (this.gameLost) return;
            this.shape.handleDragEnd();
        });
        scene.add.existing(this);
    }
    handleDragStart() {
        this.depth = $669b36e24dae83b6$var$CONFIG.dragDepth;
        this.startX = this.x;
        this.startY = this.y;
    }
    updateDragPosition(xDiff, yDiff) {
        this.x = this.startX + xDiff;
        this.y = this.startY + yDiff;
    }
    setGridPosition(shapeGridPos, isSpawn = false) {
        this.depth = $669b36e24dae83b6$var$CONFIG.defaultDepth;
        this.gridPos = {
            x: this.config.gridOffset.x + shapeGridPos.x,
            y: this.config.gridOffset.y + shapeGridPos.y
        };
        let worldPos = this.getWorldPos(this.gridPos);
        this.shape.scene.tweens.add({
            targets: this,
            x: worldPos.x,
            y: worldPos.y,
            ease: $669b36e24dae83b6$var$CONFIG.moveTween.ease,
            duration: isSpawn ? $669b36e24dae83b6$var$CONFIG.moveTween.spawnDuration : $669b36e24dae83b6$var$CONFIG.moveTween.duration
        });
        return this;
    }
    getWorldPos(gridPos) {
        return {
            x: this.gridOrigin.x + this.cellSize * (gridPos.x + 0.5),
            y: this.gridOrigin.y + this.cellSize * (gridPos.y + 0.5)
        };
    }
    fadeOut() {
        this.disableInteractive();
        let worldPos = this.getWorldPos(this.gridPos);
        var img = this.shape.scene.add.image(worldPos.x, worldPos.y, $669b36e24dae83b6$var$CONFIG.invalidBlockColor).setDepth($669b36e24dae83b6$var$CONFIG.dragDepth + 1).setScale(this.scaleX, this.scaleY).setAlpha(1).setTintFill(0xffffff);
        this.shape.scene.tweens.add({
            targets: img,
            alpha: 0,
            ease: $669b36e24dae83b6$var$CONFIG.fadeTween.ease,
            duration: $669b36e24dae83b6$var$CONFIG.fadeTween.duration,
            delay: $669b36e24dae83b6$var$CONFIG.fadeTween.delay,
            onComplete: ()=>{
                img.destroy();
            }
        });
    }
    onGameLost() {
        this.disableInteractive();
        this.gameLost = true;
    }
    setHighlight(valid) {
        this.setTexture(valid ? this.shape.getBlockColor() : $669b36e24dae83b6$var$CONFIG.invalidBlockColor);
    }
    getGridPos() {
        return this.gridPos;
    }
}


class $88aab5b2814763dc$export$6428a7f2611ef1fa {
    constructor(scene, shapeConfig, gridManager){
        this.scene = scene;
        this.config = shapeConfig;
        this.gridManager = gridManager;
        this.gridPos = this.config.startPos;
        this.lastFrameGridPos = this.gridPos;
        this.lastValidGridPos = this.gridPos;
        this.blocks = [];
        //Spawn blocks, populate block array
        shapeConfig.blocks.forEach((blockConfig)=>{
            this.blocks.push(this.spawnBlock(blockConfig));
        });
        this.gridManager.updateOccupancyMap(this, true);
        this.displayPositionValidity(true);
    }
    spawnBlock(blockConfig) {
        return new (0, $669b36e24dae83b6$export$d96a8827a60d6b69)(blockConfig, this, this.scene, this.gridManager.getGridOrigin(), this.gridManager.getCellSize()).setGridPosition(this.gridPos, true);
    }
    handleDragStart(startX, startY) {
        this.dragStartX = startX;
        this.dragStartY = startY;
        this.gridManager.updateOccupancyMap(this, false);
        this.blocks.forEach((block)=>{
            block.handleDragStart();
        });
        this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
            detune: this.scene.getDetune()
        });
    }
    handleDrag(dragX, dragY) {
        this.dragXDiff = dragX - this.dragStartX;
        this.dragYDiff = dragY - this.dragStartY;
        var newGridPosCandidate = this.getDragGridPos();
        if (newGridPosCandidate.x !== this.lastFrameGridPos.x || newGridPosCandidate.y !== this.lastFrameGridPos.y) {
            let isNewPosValid = this.gridManager.isGridPosValid(newGridPosCandidate, this);
            this.displayPositionValidity(isNewPosValid);
            if (isNewPosValid) this.lastValidGridPos = newGridPosCandidate;
        }
        this.lastFrameGridPos = newGridPosCandidate;
        this.blocks.forEach((block)=>{
            block.updateDragPosition(this.dragXDiff, this.dragYDiff);
        }); //Smooth movement while dragging
    }
    handleDragEnd() {
        //snap each block to correct position
        this.gridPos = this.lastValidGridPos;
        // this.gridManager.debugLogShapePositions();
        this.blocks.forEach((block)=>{
            block.setGridPosition(this.gridPos);
        });
        this.displayPositionValidity(true);
        this.gridManager.updateOccupancyMap(this, true);
        this.gridManager.checkForBoardCompleted();
        this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
            detune: this.scene.getDetune()
        });
    }
    //highlights shape in red if position is not valid
    displayPositionValidity(posValid) {
        this.blocks.forEach((block)=>{
            block.setHighlight(posValid);
        });
    }
    fadeOut() {
        this.blocks.forEach((block)=>block.fadeOut());
    }
    onGameLost() {
        this.blocks.forEach((block)=>block.onGameLost());
    }
    destroy() {
        this.blocks.forEach((block)=>block.destroy());
    }
    getDragGridPos() {
        return {
            x: this.gridPos.x + Math.round(this.dragXDiff / this.gridManager.getCellSize()),
            y: this.gridPos.y + Math.round(this.dragYDiff / this.gridManager.getCellSize())
        };
    }
    collidesWith(shape, pos) {
        return false;
    }
    getGridPosition() {
        return this.gridPos;
    }
    getBlockColor() {
        return this.config.blockColor;
    }
    getBlocks() {
        return this.blocks;
    }
}


class $a59851f331e8148f$export$2e2bcd8739ae039 {
    //TODO delete those
    // private debugOccupancy: number[][] = [[],[],[],[],[],[],];
    // private maxGrid = 0;
    // private debugBlockColors = [CONST.GRID_FILL.BLOCK_BLUE, CONST.GRID_FILL.BLOCK_GREEN, CONST.GRID_FILL.BLOCK_ORANGE, CONST.GRID_FILL.BLOCK_PURPLE, CONST.GRID_FILL.BLOCK_RED, CONST.GRID_FILL.BLOCK_YELLOW];
    constructor(scene, position, gridConfig, gridSizeInfo){
        this.availableBlockColors = [
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.BLOCK_BLUE,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.BLOCK_GREEN,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.BLOCK_ORANGE,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.BLOCK_PURPLE,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.BLOCK_RED,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.BLOCK_YELLOW
        ];
        this.scene = scene;
        this.position = position;
        this.shapeConfig = this.interpretGridConfig(gridConfig);
        this.occupancyMap = [];
        this.cellSize = gridSizeInfo[this.rowCount].cellSize;
        this.position.y += gridSizeInfo[this.rowCount].yOffset;
    // this.scene.events.on('update', this.debugUpdate, this);
    }
    //TODO: delete this
    //    private debugUpdate(){
    //        var pointerPos = this.scene.input.activePointer.position;
    //        var pointerGridPos = this.debugWorldToGridPos({x: pointerPos.x, y: pointerPos.y});
    //         var key6 = this.scene.input.keyboard.addKey("SIX");
    //         var key1 = this.scene.input.keyboard.addKey("ONE");
    //         var key2 = this.scene.input.keyboard.addKey("TWO");
    //         var key3 = this.scene.input.keyboard.addKey("THREE");
    //         var key4 = this.scene.input.keyboard.addKey("FOUR");
    //         var key5 = this.scene.input.keyboard.addKey("FIVE");
    //         this.updateDebugOccupancy(key6, pointerGridPos, 5);
    //         this.updateDebugOccupancy(key1, pointerGridPos, 0);
    //         this.updateDebugOccupancy(key2, pointerGridPos, 1);
    //         this.updateDebugOccupancy(key3, pointerGridPos, 2);
    //         this.updateDebugOccupancy(key4, pointerGridPos, 3);
    //         this.updateDebugOccupancy(key5, pointerGridPos, 4);
    //    }
    //    //TODO: delete this
    //    private updateDebugOccupancy(key: any, pointerGridPos: any, value: number){
    //     if (key.isDown){
    //         if (!this.debugOccupancy[pointerGridPos.y]) this.debugOccupancy[pointerGridPos.y] = [];
    //         if (this.debugOccupancy[pointerGridPos.y][pointerGridPos.x] != value){
    //             this.debugOccupancy[pointerGridPos.y][pointerGridPos.x] = value;  
    //             var worlPos = this.gridToWorldPosition({x: pointerGridPos.x + 0.5, y: pointerGridPos.y + 0.5});
    //             this.scene.add.image(worlPos.x, worlPos.y, this.debugBlockColors[value]).setDepth(1000).setDisplaySize(this.cellSize, this.cellSize);
    //             if (value > this.maxGrid) this.maxGrid = value;
    //             this.debugPrintGridConfig();
    //         }
    //     }
    //    }
    //    //TODO: delete this
    //    private debugWorldToGridPos(pos: {x: integer, y: integer}){
    //         return new Phaser.Math.Vector2(Math.floor((pos.x - this.gridOrigin.x ) / this.cellSize),Math.floor((pos.y - this.gridOrigin.y ) / this.cellSize));
    //     }
    //     private debugPrintGridConfig(){
    //         let arr = this.debugOccupancy.filter(function (el) {
    //             return el.length > 0;
    //           });
    //         var string = "{\n       n: \"\",\n       g: " + JSON.stringify(arr) + ",\n       b: [[0,0]";
    //         for (var i = 0; i < this.maxGrid; i++){
    //             string += ",[0, 0]";
    //         }
    //         string += "],\n},";
    //         console.log(string);
    //     }
    interpretGridConfig(gridSetup) {
        this.availableBlockColors = [
            ...Phaser.Utils.Array.Shuffle(this.availableBlockColors)
        ];
        var shapeConfigs = [];
        let grid = gridSetup.g;
        let blockStartPositions = gridSetup.b;
        let name = gridSetup.n;
        //console.warn("Grid name: " + name);
        for(let i = 0; i < blockStartPositions.length; i++){
            let config = {
                blocks: [],
                startPos: {
                    x: blockStartPositions[i][0],
                    y: blockStartPositions[i][1]
                },
                blockColor: this.getRandomBlockColor()
            };
            shapeConfigs[i] = config;
        }
        //loop over the whole grid
        for(let i = 0; i < grid.length; i++)for(let j = 0; j < grid[i].length; j++){
            let currShape = grid[i][j];
            shapeConfigs[currShape].blocks.push({
                gridOffset: {
                    x: j,
                    y: i
                }
            });
        }
        this.rowCount = grid.length;
        this.columnCount = grid[0].length;
        this.gridName = name;
        return shapeConfigs;
    }
    getRandomBlockColor() {
        let blockColor = this.availableBlockColors.pop();
        return blockColor ? blockColor : (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.BLOCK_BLUE;
    }
    createGrid() {
        this.gridBg = this.scene.add.grid(this.position.x, this.position.y, this.columnCount * this.cellSize, this.rowCount * this.cellSize, this.cellSize, this.cellSize, 0x757474)//.setAltFillStyle(0x919191)
        //.setOutlineStyle()
        .setDepth(11);
        this.imageBg = this.scene.add.image(this.position.x, this.position.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.SCREEN).setDepth(10).setDisplaySize(this.columnCount * this.cellSize + 5, this.rowCount * this.cellSize + 5);
        this.gridOrigin = this.gridBg.getTopLeft();
        this.shapes = [];
        this.shapeConfig.forEach((config)=>{
            this.shapes.push(new (0, $88aab5b2814763dc$export$6428a7f2611ef1fa)(this.scene, config, this));
        });
    }
    getCellSize() {
        return this.cellSize;
    }
    getGridOrigin() {
        return this.gridOrigin;
    }
    gridToWorldPosition(pos) {
        return new Phaser.Math.Vector2(this.gridOrigin.x + pos.x * this.cellSize, this.gridOrigin.y + pos.y * this.cellSize);
    }
    isGridPosValid(pos, shape) {
        //Check if shape is colliding with any other shapes
        return !shape.getBlocks().some((block)=>{
            let blockPos = {
                x: pos.x + block.config.gridOffset.x,
                y: pos.y + block.config.gridOffset.y
            };
            return this.occupancyMap[blockPos.x.toString() + blockPos.y.toString()];
        });
    }
    updateOccupancyMap(shape, occupiesSpace) {
        shape.getBlocks().forEach((block)=>{
            let pos = block.getGridPos();
            this.occupancyMap[pos.x.toString() + pos.y.toString()] = occupiesSpace;
        });
    }
    checkForBoardCompleted() {
        if (this.isBoardCompleted()) this.scene.onLevelCompleted();
    }
    handleLevelCompleted() {
        this.shapes.forEach((shape)=>shape.fadeOut());
    }
    isBoardCompleted() {
        for(let i = 0; i < this.columnCount; i++)for(let j = 0; j < this.rowCount; j++){
            if (!this.occupancyMap[i.toString() + j.toString()]) return false;
        }
        return true;
    }
    onGameLost() {
        this.shapes.forEach((shape)=>shape.onGameLost());
    }
    destroy() {
        this.gridBg.destroy();
        this.imageBg.destroy();
        this.shapes.forEach((shape)=>shape.destroy());
    }
    getGridName() {
        return this.gridName;
    }
}


const $28cc6deb36dec1d2$export$cc32c6afed33d362 = {
    easy: [
        {
            n: "e1",
            g: [
                [
                    1,
                    1,
                    1,
                    2
                ],
                [
                    0,
                    1,
                    1,
                    2
                ],
                [
                    0,
                    0,
                    0,
                    2
                ],
                [
                    3,
                    3,
                    2,
                    2
                ]
            ],
            b: [
                [
                    3,
                    6
                ],
                [
                    -1,
                    8
                ],
                [
                    -6,
                    6
                ],
                [
                    0,
                    3
                ]
            ]
        },
        {
            n: "e2",
            g: [
                [
                    0,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    0,
                    1,
                    0,
                    0,
                    1
                ],
                [
                    0,
                    1,
                    1,
                    0,
                    1
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            ],
            b: [
                [
                    3,
                    8
                ],
                [
                    -2,
                    7
                ]
            ]
        },
        {
            n: "e3",
            g: [
                [
                    0,
                    0,
                    2,
                    2,
                    2,
                    3
                ],
                [
                    0,
                    0,
                    2,
                    1,
                    2,
                    3
                ],
                [
                    1,
                    0,
                    2,
                    1,
                    2,
                    3
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    2,
                    3
                ]
            ],
            b: [
                [
                    0,
                    7
                ],
                [
                    3,
                    6
                ],
                [
                    5,
                    6
                ],
                [
                    -7,
                    6
                ]
            ]
        },
        {
            n: "e4",
            g: [
                [
                    0,
                    1,
                    2,
                    2,
                    2
                ],
                [
                    0,
                    1,
                    1,
                    2,
                    2
                ],
                [
                    0,
                    0,
                    1,
                    2,
                    2
                ]
            ],
            b: [
                [
                    5,
                    5
                ],
                [
                    -3,
                    5
                ],
                [
                    -1,
                    5
                ]
            ]
        },
        {
            n: "e5",
            g: [
                [
                    0,
                    1,
                    1,
                    1,
                    3
                ],
                [
                    0,
                    0,
                    0,
                    1,
                    3
                ],
                [
                    2,
                    2,
                    0,
                    1,
                    3
                ],
                [
                    2,
                    2,
                    0,
                    3,
                    3
                ]
            ],
            b: [
                [
                    5,
                    6
                ],
                [
                    1,
                    7
                ],
                [
                    -1,
                    5
                ],
                [
                    -3,
                    6
                ]
            ]
        },
        {
            n: "e6",
            g: [
                [
                    3,
                    3,
                    1,
                    1
                ],
                [
                    3,
                    0,
                    0,
                    1
                ],
                [
                    3,
                    2,
                    0,
                    0
                ],
                [
                    3,
                    2,
                    2,
                    2
                ]
            ],
            b: [
                [
                    -1,
                    5
                ],
                [
                    3,
                    7
                ],
                [
                    -4,
                    5
                ],
                [
                    3,
                    6
                ]
            ]
        },
        {
            n: "e7",
            g: [
                [
                    0,
                    2,
                    2
                ],
                [
                    0,
                    2,
                    1
                ],
                [
                    0,
                    1,
                    1
                ]
            ],
            b: [
                [
                    1,
                    5
                ],
                [
                    -3,
                    5
                ],
                [
                    2,
                    6
                ],
                [
                    0,
                    0
                ]
            ]
        },
        {
            n: "e8",
            g: [
                [
                    0,
                    3,
                    3,
                    3,
                    3
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    2,
                    2,
                    2,
                    2,
                    1
                ],
                [
                    2,
                    2,
                    2,
                    1,
                    1
                ]
            ],
            b: [
                [
                    1,
                    7
                ],
                [
                    1,
                    6
                ],
                [
                    -3,
                    5
                ],
                [
                    -2,
                    6
                ]
            ]
        },
        {
            n: "e9",
            g: [
                [
                    0,
                    0,
                    0,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    0,
                    1,
                    2
                ],
                [
                    2,
                    1,
                    1,
                    1,
                    2
                ],
                [
                    2,
                    2,
                    2,
                    2,
                    2
                ]
            ],
            b: [
                [
                    1,
                    7
                ],
                [
                    -3,
                    6
                ],
                [
                    2,
                    6
                ]
            ]
        },
        {
            n: "e10",
            g: [
                [
                    2,
                    2,
                    0,
                    0
                ],
                [
                    1,
                    2,
                    0,
                    3
                ],
                [
                    1,
                    2,
                    2,
                    3
                ],
                [
                    1,
                    1,
                    3,
                    3
                ]
            ],
            b: [
                [
                    1,
                    7
                ],
                [
                    0,
                    5
                ],
                [
                    1,
                    7
                ],
                [
                    -4,
                    5
                ]
            ]
        },
        {
            n: "e11",
            g: [
                [
                    0,
                    0,
                    0,
                    1,
                    1,
                    1
                ],
                [
                    3,
                    3,
                    0,
                    0,
                    1,
                    1
                ],
                [
                    3,
                    3,
                    2,
                    2,
                    1,
                    1
                ],
                [
                    3,
                    3,
                    2,
                    2,
                    1,
                    1
                ]
            ],
            b: [
                [
                    7,
                    7
                ],
                [
                    -8,
                    6
                ],
                [
                    -2,
                    5
                ],
                [
                    4,
                    5
                ]
            ]
        },
        {
            n: "e12",
            g: [
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    2,
                    2,
                    2,
                    1,
                    0
                ],
                [
                    3,
                    3,
                    2,
                    1,
                    1
                ],
                [
                    3,
                    3,
                    2,
                    1,
                    1
                ]
            ],
            b: [
                [
                    7,
                    7
                ],
                [
                    -3,
                    5
                ],
                [
                    3,
                    5
                ],
                [
                    -4,
                    5
                ]
            ]
        },
        {
            n: "e13",
            g: [
                [
                    0,
                    0,
                    3,
                    3
                ],
                [
                    0,
                    1,
                    3,
                    3
                ],
                [
                    0,
                    1,
                    2,
                    2
                ],
                [
                    1,
                    1,
                    2,
                    2
                ]
            ],
            b: [
                [
                    -3,
                    6
                ],
                [
                    -1,
                    6
                ],
                [
                    3,
                    5
                ],
                [
                    0,
                    6
                ]
            ]
        },
        {
            n: "e14",
            g: [
                [
                    0,
                    0,
                    0,
                    1,
                    2,
                    2
                ],
                [
                    0,
                    0,
                    0,
                    1,
                    2,
                    2
                ],
                [
                    1,
                    0,
                    0,
                    1,
                    2,
                    2
                ],
                [
                    1,
                    0,
                    0,
                    1,
                    2,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    2,
                    2
                ]
            ],
            b: [
                [
                    -2,
                    8
                ],
                [
                    5,
                    7
                ],
                [
                    -2,
                    7
                ]
            ]
        },
        {
            n: "e15",
            g: [
                [
                    0,
                    0,
                    1,
                    2
                ],
                [
                    1,
                    0,
                    1,
                    2
                ],
                [
                    1,
                    0,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2
                ]
            ],
            b: [
                [
                    -3,
                    6
                ],
                [
                    4,
                    6
                ],
                [
                    -2,
                    6
                ]
            ]
        },
        {
            n: "e16",
            g: [
                [
                    0,
                    0,
                    0,
                    3,
                    3
                ],
                [
                    0,
                    0,
                    3,
                    3,
                    3
                ],
                [
                    0,
                    3,
                    3,
                    2,
                    3
                ],
                [
                    1,
                    1,
                    3,
                    2,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2,
                    2
                ]
            ],
            b: [
                [
                    3,
                    8
                ],
                [
                    1,
                    7
                ],
                [
                    -5,
                    7
                ],
                [
                    -2,
                    7
                ]
            ]
        },
        {
            n: "e17",
            g: [
                [
                    0,
                    2,
                    2,
                    2,
                    2
                ],
                [
                    0,
                    0,
                    1,
                    2,
                    2
                ],
                [
                    0,
                    0,
                    1,
                    1,
                    1
                ]
            ],
            b: [
                [
                    4,
                    5
                ],
                [
                    -2,
                    5
                ],
                [
                    -6,
                    6
                ]
            ]
        },
        {
            n: "e18",
            g: [
                [
                    0,
                    0,
                    1,
                    2,
                    2
                ],
                [
                    0,
                    0,
                    1,
                    1,
                    2
                ],
                [
                    0,
                    0,
                    1,
                    2,
                    2
                ]
            ],
            b: [
                [
                    -1,
                    5
                ],
                [
                    3,
                    5
                ],
                [
                    -1,
                    5
                ]
            ]
        },
        {
            n: "e19",
            g: [
                [
                    0,
                    1,
                    2,
                    3,
                    4
                ],
                [
                    0,
                    1,
                    2,
                    3,
                    4
                ],
                [
                    0,
                    1,
                    2,
                    3,
                    4
                ]
            ],
            b: [
                [
                    2,
                    5
                ],
                [
                    -1,
                    5
                ],
                [
                    2,
                    5
                ],
                [
                    -5,
                    5
                ],
                [
                    2,
                    5
                ]
            ]
        },
        {
            n: "e20",
            g: [
                [
                    0,
                    0,
                    0,
                    0,
                    3,
                    3
                ],
                [
                    1,
                    2,
                    2,
                    2,
                    3,
                    3
                ],
                [
                    1,
                    1,
                    1,
                    2,
                    3,
                    3
                ]
            ],
            b: [
                [
                    3,
                    5
                ],
                [
                    2,
                    4
                ],
                [
                    -4,
                    4
                ],
                [
                    -4,
                    5
                ]
            ]
        },
        {
            n: "e21",
            g: [
                [
                    0,
                    0,
                    0,
                    0,
                    1,
                    3
                ],
                [
                    2,
                    1,
                    1,
                    1,
                    1,
                    3
                ],
                [
                    2,
                    1,
                    3,
                    3,
                    3,
                    3
                ],
                [
                    2,
                    2,
                    2,
                    2,
                    3,
                    3
                ]
            ],
            b: [
                [
                    3,
                    7
                ],
                [
                    -4,
                    6
                ],
                [
                    1,
                    5
                ],
                [
                    4,
                    6
                ]
            ]
        },
        {
            n: "e22",
            g: [
                [
                    0,
                    1,
                    1,
                    1,
                    2
                ],
                [
                    0,
                    1,
                    0,
                    0,
                    2
                ],
                [
                    0,
                    1,
                    0,
                    0,
                    2
                ],
                [
                    0,
                    0,
                    0,
                    2,
                    2
                ]
            ],
            b: [
                [
                    -2,
                    6
                ],
                [
                    1,
                    7
                ],
                [
                    1,
                    6
                ]
            ]
        },
        {
            n: "e23",
            g: [
                [
                    0,
                    1,
                    2,
                    2,
                    2,
                    3
                ],
                [
                    0,
                    1,
                    2,
                    1,
                    2,
                    3
                ],
                [
                    0,
                    1,
                    1,
                    1,
                    2,
                    3
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    2,
                    3
                ]
            ],
            b: [
                [
                    -1,
                    6
                ],
                [
                    4,
                    7
                ],
                [
                    -1,
                    6
                ],
                [
                    -1,
                    6
                ]
            ]
        },
        {
            n: "e24",
            g: [
                [
                    0,
                    3,
                    3,
                    3,
                    3,
                    3
                ],
                [
                    0,
                    2,
                    2,
                    2,
                    2,
                    2
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    0
                ]
            ],
            b: [
                [
                    4,
                    6
                ],
                [
                    -5,
                    3
                ],
                [
                    -4,
                    6
                ],
                [
                    -2,
                    8
                ]
            ]
        },
        {
            n: "e25",
            g: [
                [
                    0,
                    0,
                    0,
                    2,
                    2
                ],
                [
                    1,
                    0,
                    2,
                    2,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    2
                ]
            ],
            b: [
                [
                    1,
                    6
                ],
                [
                    -3,
                    4
                ],
                [
                    2,
                    5
                ]
            ]
        },
        {
            n: "e26",
            g: [
                [
                    0,
                    0,
                    0,
                    2,
                    2
                ],
                [
                    0,
                    1,
                    1,
                    2,
                    2
                ],
                [
                    0,
                    1,
                    2,
                    2,
                    2
                ],
                [
                    0,
                    1,
                    2,
                    2,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2,
                    2
                ]
            ],
            b: [
                [
                    -2,
                    8
                ],
                [
                    3,
                    6
                ],
                [
                    -2,
                    7
                ]
            ]
        },
        {
            n: "e27",
            g: [
                [
                    0,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    0,
                    2,
                    2,
                    2,
                    3
                ],
                [
                    0,
                    0,
                    2,
                    3,
                    3
                ]
            ],
            b: [
                [
                    5,
                    5
                ],
                [
                    0,
                    7
                ],
                [
                    0,
                    4
                ],
                [
                    -4,
                    5
                ]
            ]
        },
        {
            n: "e28",
            g: [
                [
                    1,
                    1,
                    1,
                    1,
                    0
                ],
                [
                    1,
                    1,
                    1,
                    0,
                    0
                ],
                [
                    1,
                    1,
                    0,
                    0,
                    0
                ],
                [
                    1,
                    0,
                    0,
                    0,
                    0
                ]
            ],
            b: [
                [
                    -3,
                    6
                ],
                [
                    3,
                    6
                ]
            ]
        },
        {
            n: "e29",
            g: [
                [
                    1,
                    1,
                    2,
                    0
                ],
                [
                    1,
                    2,
                    2,
                    0
                ],
                [
                    1,
                    0,
                    0,
                    0
                ]
            ],
            b: [
                [
                    -5,
                    5
                ],
                [
                    0,
                    5
                ],
                [
                    3,
                    5
                ]
            ]
        }
    ],
    normal: [
        {
            n: "n1",
            g: [
                [
                    1,
                    1,
                    1,
                    2,
                    4
                ],
                [
                    1,
                    1,
                    2,
                    2,
                    4
                ],
                [
                    1,
                    3,
                    3,
                    3,
                    4
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    4
                ]
            ],
            b: [
                [
                    -2,
                    4
                ],
                [
                    5,
                    6
                ],
                [
                    1,
                    6
                ],
                [
                    0,
                    4
                ],
                [
                    -7,
                    6
                ]
            ]
        },
        {
            n: "n2",
            g: [
                [
                    0,
                    0,
                    0,
                    1,
                    1
                ],
                [
                    3,
                    3,
                    0,
                    0,
                    1
                ],
                [
                    3,
                    2,
                    2,
                    2,
                    1
                ],
                [
                    3,
                    3,
                    2,
                    1,
                    1
                ]
            ],
            b: [
                [
                    -1,
                    8
                ],
                [
                    1,
                    6
                ],
                [
                    -3,
                    4
                ],
                [
                    2,
                    5
                ]
            ]
        },
        {
            n: "n3",
            g: [
                [
                    0,
                    0,
                    0,
                    2,
                    2
                ],
                [
                    0,
                    0,
                    1,
                    1,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2,
                    2
                ],
                [
                    3,
                    3,
                    3,
                    3,
                    3
                ]
            ],
            b: [
                [
                    0,
                    7
                ],
                [
                    3,
                    5
                ],
                [
                    -5,
                    6
                ],
                [
                    0,
                    3
                ]
            ]
        },
        {
            n: "n4",
            g: [
                [
                    3,
                    3,
                    2,
                    0,
                    0
                ],
                [
                    3,
                    2,
                    2,
                    0,
                    0
                ],
                [
                    3,
                    2,
                    1,
                    0,
                    0
                ],
                [
                    3,
                    2,
                    1,
                    1,
                    1
                ]
            ],
            b: [
                [
                    -1,
                    6
                ],
                [
                    -2,
                    6
                ],
                [
                    3,
                    6
                ],
                [
                    -1,
                    6
                ]
            ]
        },
        {
            n: "n5",
            g: [
                [
                    0,
                    0,
                    0,
                    4,
                    4,
                    4
                ],
                [
                    3,
                    1,
                    0,
                    4,
                    1,
                    4
                ],
                [
                    3,
                    1,
                    1,
                    1,
                    1,
                    2
                ],
                [
                    3,
                    3,
                    3,
                    2,
                    2,
                    2
                ]
            ],
            b: [
                [
                    5,
                    7
                ],
                [
                    -1,
                    7
                ],
                [
                    -2,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    -5,
                    6
                ]
            ]
        },
        {
            n: "n6",
            g: [
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    3,
                    4,
                    4,
                    5
                ],
                [
                    1,
                    3,
                    3,
                    4,
                    5
                ],
                [
                    1,
                    3,
                    3,
                    4,
                    5
                ],
                [
                    1,
                    1,
                    5,
                    5,
                    5
                ]
            ],
            b: [
                [
                    -2,
                    10
                ],
                [
                    3,
                    5
                ],
                [
                    0,
                    0
                ],
                [
                    -1,
                    6
                ],
                [
                    -5,
                    6
                ],
                [
                    1,
                    6
                ]
            ]
        },
        {
            n: "n7",
            g: [
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    4,
                    0,
                    3,
                    1,
                    1,
                    1
                ],
                [
                    4,
                    3,
                    3,
                    3,
                    2,
                    2
                ],
                [
                    4,
                    4,
                    4,
                    2,
                    2,
                    2
                ]
            ],
            b: [
                [
                    1,
                    6
                ],
                [
                    -2,
                    7
                ],
                [
                    -5,
                    5
                ],
                [
                    4,
                    6
                ],
                [
                    4,
                    6
                ],
                [
                    0,
                    0
                ]
            ]
        },
        {
            n: "n9",
            g: [
                [
                    0,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    0,
                    0,
                    0,
                    2,
                    1
                ],
                [
                    3,
                    3,
                    0,
                    2,
                    1
                ],
                [
                    3,
                    2,
                    2,
                    2,
                    2
                ],
                [
                    3,
                    3,
                    3,
                    3,
                    2
                ]
            ],
            b: [
                [
                    3,
                    8
                ],
                [
                    2,
                    7
                ],
                [
                    -4,
                    6
                ],
                [
                    1,
                    7
                ]
            ]
        },
        {
            n: "n10",
            g: [
                [
                    0,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    0,
                    0,
                    3,
                    3,
                    1
                ],
                [
                    2,
                    3,
                    3,
                    3,
                    3
                ],
                [
                    2,
                    2,
                    2,
                    2,
                    3
                ]
            ],
            b: [
                [
                    2,
                    8
                ],
                [
                    0,
                    6
                ],
                [
                    3,
                    5
                ],
                [
                    -3,
                    5
                ]
            ]
        },
        {
            n: "n11",
            g: [
                [
                    0,
                    0,
                    3,
                    3,
                    3
                ],
                [
                    2,
                    0,
                    0,
                    3,
                    1
                ],
                [
                    2,
                    2,
                    0,
                    1,
                    1
                ],
                [
                    2,
                    2,
                    2,
                    1,
                    1
                ]
            ],
            b: [
                [
                    0,
                    7
                ],
                [
                    3,
                    5
                ],
                [
                    3,
                    5
                ],
                [
                    -4,
                    8
                ]
            ]
        },
        {
            n: "n12",
            g: [
                [
                    0,
                    1,
                    1,
                    2
                ],
                [
                    0,
                    1,
                    2,
                    2
                ],
                [
                    0,
                    1,
                    1,
                    2
                ],
                [
                    3,
                    1,
                    2,
                    3
                ],
                [
                    3,
                    3,
                    3,
                    3
                ]
            ],
            b: [
                [
                    3,
                    8
                ],
                [
                    -3,
                    7
                ],
                [
                    2,
                    7
                ],
                [
                    -1,
                    7
                ]
            ]
        },
        {
            n: "n13",
            g: [
                [
                    0,
                    1,
                    1,
                    2,
                    3
                ],
                [
                    0,
                    1,
                    2,
                    2,
                    3
                ],
                [
                    0,
                    1,
                    2,
                    2,
                    3
                ],
                [
                    0,
                    1,
                    4,
                    4,
                    3
                ],
                [
                    0,
                    0,
                    4,
                    4,
                    3
                ]
            ],
            b: [
                [
                    3,
                    7
                ],
                [
                    -1,
                    8
                ],
                [
                    -4,
                    8
                ],
                [
                    1,
                    7
                ],
                [
                    -1,
                    6
                ]
            ]
        },
        {
            n: "n14",
            g: [
                [
                    0,
                    4,
                    4,
                    4,
                    4
                ],
                [
                    0,
                    0,
                    0,
                    3,
                    4
                ],
                [
                    1,
                    1,
                    0,
                    3,
                    3
                ],
                [
                    1,
                    1,
                    1,
                    3,
                    2
                ],
                [
                    1,
                    2,
                    2,
                    2,
                    2
                ]
            ],
            b: [
                [
                    4,
                    9
                ],
                [
                    3,
                    5
                ],
                [
                    -2,
                    4
                ],
                [
                    -6,
                    6
                ],
                [
                    -2,
                    9
                ]
            ]
        },
        {
            n: "n15",
            g: [
                [
                    0,
                    0,
                    1,
                    1,
                    2,
                    2
                ],
                [
                    0,
                    0,
                    0,
                    1,
                    2,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    3,
                    3
                ],
                [
                    3,
                    3,
                    3,
                    3,
                    3,
                    3
                ],
                [
                    3,
                    3,
                    4,
                    4,
                    4,
                    4
                ]
            ],
            b: [
                [
                    3,
                    7
                ],
                [
                    5,
                    8
                ],
                [
                    -7,
                    7
                ],
                [
                    -3,
                    6
                ],
                [
                    -2,
                    6
                ]
            ]
        },
        {
            n: "n16",
            g: [
                [
                    0,
                    0,
                    0,
                    3,
                    3,
                    3
                ],
                [
                    0,
                    0,
                    1,
                    0,
                    3,
                    3
                ],
                [
                    1,
                    1,
                    2,
                    3,
                    2,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2,
                    2,
                    2
                ]
            ],
            b: [
                [
                    -3,
                    8
                ],
                [
                    5,
                    5
                ],
                [
                    -1,
                    6
                ],
                [
                    -3,
                    6
                ]
            ]
        },
        {
            n: "n17",
            g: [
                [
                    0,
                    0,
                    0,
                    2,
                    2,
                    2
                ],
                [
                    0,
                    1,
                    0,
                    2,
                    3,
                    3
                ],
                [
                    0,
                    1,
                    0,
                    3,
                    3,
                    3
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    4,
                    4,
                    4,
                    4,
                    4,
                    4
                ]
            ],
            b: [
                [
                    5,
                    8
                ],
                [
                    -2,
                    7
                ],
                [
                    -3,
                    8
                ],
                [
                    -1,
                    7
                ],
                [
                    0,
                    3
                ]
            ]
        },
        {
            n: "n18",
            g: [
                [
                    0,
                    0,
                    0,
                    2,
                    3,
                    3
                ],
                [
                    0,
                    1,
                    1,
                    2,
                    3,
                    3
                ],
                [
                    0,
                    1,
                    1,
                    2,
                    2,
                    2
                ],
                [
                    0,
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            ],
            b: [
                [
                    -1,
                    6
                ],
                [
                    2,
                    5
                ],
                [
                    -1,
                    7
                ],
                [
                    -4,
                    7
                ]
            ]
        },
        {
            n: "n19",
            g: [
                [
                    0,
                    0,
                    0,
                    0,
                    2,
                    3
                ],
                [
                    0,
                    1,
                    2,
                    2,
                    2,
                    3
                ],
                [
                    0,
                    1,
                    2,
                    2,
                    2,
                    3
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    2,
                    3
                ],
                [
                    3,
                    3,
                    3,
                    3,
                    3,
                    3
                ]
            ],
            b: [
                [
                    2,
                    7
                ],
                [
                    0,
                    7
                ],
                [
                    -5,
                    7
                ],
                [
                    1,
                    7
                ]
            ]
        },
        {
            n: "n20",
            g: [
                [
                    0,
                    0,
                    0,
                    1,
                    1,
                    2
                ],
                [
                    3,
                    0,
                    0,
                    4,
                    1,
                    2
                ],
                [
                    3,
                    3,
                    0,
                    4,
                    1,
                    2
                ],
                [
                    3,
                    3,
                    4,
                    4,
                    4,
                    2
                ]
            ],
            b: [
                [
                    -2,
                    6
                ],
                [
                    -1,
                    6
                ],
                [
                    -4,
                    6
                ],
                [
                    5,
                    5
                ],
                [
                    1,
                    6
                ]
            ]
        },
        {
            n: "n21",
            g: [
                [
                    0,
                    0,
                    0,
                    0,
                    3
                ],
                [
                    0,
                    1,
                    1,
                    0,
                    3
                ],
                [
                    0,
                    1,
                    2,
                    3,
                    3
                ],
                [
                    1,
                    1,
                    2,
                    2,
                    2
                ]
            ],
            b: [
                [
                    0,
                    6
                ],
                [
                    3,
                    5
                ],
                [
                    -5,
                    4
                ],
                [
                    2,
                    6
                ]
            ]
        },
        {
            n: "n22",
            g: [
                [
                    0,
                    1,
                    1,
                    1,
                    1,
                    3
                ],
                [
                    0,
                    0,
                    1,
                    1,
                    3,
                    3
                ],
                [
                    0,
                    0,
                    2,
                    2,
                    3,
                    3
                ],
                [
                    0,
                    2,
                    2,
                    2,
                    2,
                    2
                ]
            ],
            b: [
                [
                    4,
                    6
                ],
                [
                    5,
                    7
                ],
                [
                    -5,
                    5
                ],
                [
                    -3,
                    6
                ]
            ]
        },
        {
            n: "n23",
            g: [
                [
                    0,
                    0,
                    3,
                    3,
                    3
                ],
                [
                    0,
                    0,
                    1,
                    1,
                    3
                ],
                [
                    1,
                    0,
                    1,
                    2,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2,
                    2
                ]
            ],
            b: [
                [
                    5,
                    6
                ],
                [
                    1,
                    6
                ],
                [
                    -6,
                    4
                ],
                [
                    -3,
                    6
                ]
            ]
        }
    ],
    hard: [
        {
            n: "h1",
            g: [
                [
                    0,
                    0,
                    3,
                    3,
                    3,
                    3
                ],
                [
                    0,
                    0,
                    3,
                    4,
                    3,
                    3
                ],
                [
                    0,
                    0,
                    4,
                    4,
                    4,
                    3
                ],
                [
                    0,
                    1,
                    1,
                    4,
                    2,
                    3
                ],
                [
                    0,
                    0,
                    1,
                    2,
                    2,
                    2
                ],
                [
                    1,
                    1,
                    1,
                    2,
                    2,
                    2
                ]
            ],
            b: [
                [
                    2,
                    9
                ],
                [
                    5,
                    7
                ],
                [
                    -5,
                    7
                ],
                [
                    -9,
                    10
                ],
                [
                    6,
                    7
                ]
            ]
        },
        {
            n: "h2",
            g: [
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    4
                ],
                [
                    2,
                    2,
                    2,
                    1,
                    0,
                    4
                ],
                [
                    2,
                    3,
                    3,
                    1,
                    0,
                    4
                ],
                [
                    2,
                    2,
                    3,
                    1,
                    1,
                    4
                ],
                [
                    3,
                    3,
                    3,
                    4,
                    4,
                    4
                ]
            ],
            b: [
                [
                    3,
                    7
                ],
                [
                    -4,
                    6
                ],
                [
                    2,
                    7
                ],
                [
                    4,
                    6
                ],
                [
                    -4,
                    7
                ]
            ]
        },
        {
            n: "h3",
            g: [
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    3
                ],
                [
                    3,
                    3,
                    3,
                    3,
                    0,
                    3
                ],
                [
                    1,
                    1,
                    4,
                    3,
                    3,
                    3
                ],
                [
                    1,
                    1,
                    4,
                    4,
                    4,
                    4
                ],
                [
                    5,
                    5,
                    5,
                    5,
                    5,
                    5
                ],
                [
                    2,
                    2,
                    2,
                    2,
                    2,
                    2
                ]
            ],
            b: [
                [
                    2,
                    9
                ],
                [
                    -1,
                    7
                ],
                [
                    8,
                    5
                ],
                [
                    -1,
                    11
                ],
                [
                    -8,
                    8
                ],
                [
                    6,
                    8
                ]
            ]
        },
        {
            n: "h4",
            g: [
                [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1
                ],
                [
                    0,
                    3,
                    0,
                    0,
                    0,
                    1
                ],
                [
                    3,
                    3,
                    2,
                    2,
                    2,
                    1
                ],
                [
                    3,
                    3,
                    2,
                    4,
                    2,
                    1
                ],
                [
                    3,
                    2,
                    2,
                    4,
                    4,
                    4
                ],
                [
                    3,
                    3,
                    3,
                    3,
                    4,
                    4
                ]
            ],
            b: [
                [
                    3,
                    12
                ],
                [
                    -6,
                    9
                ],
                [
                    -2,
                    9
                ],
                [
                    7,
                    7
                ],
                [
                    -1,
                    6
                ]
            ]
        },
        {
            n: "h5",
            g: [
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    4
                ],
                [
                    0,
                    0,
                    1,
                    2,
                    2,
                    4
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    2,
                    4
                ],
                [
                    3,
                    2,
                    1,
                    2,
                    2,
                    4
                ],
                [
                    3,
                    2,
                    2,
                    2,
                    2,
                    4
                ],
                [
                    3,
                    3,
                    3,
                    3,
                    4,
                    4
                ]
            ],
            b: [
                [
                    1,
                    12
                ],
                [
                    4,
                    9
                ],
                [
                    -4,
                    9
                ],
                [
                    1,
                    5
                ],
                [
                    3,
                    8
                ],
                [
                    0,
                    0
                ]
            ]
        },
        {
            n: "h6",
            g: [
                [
                    0,
                    0,
                    5,
                    4,
                    4,
                    4
                ],
                [
                    0,
                    0,
                    5,
                    4,
                    4,
                    3
                ],
                [
                    0,
                    0,
                    5,
                    5,
                    5,
                    3
                ],
                [
                    0,
                    1,
                    5,
                    5,
                    5,
                    3
                ],
                [
                    0,
                    1,
                    1,
                    2,
                    2,
                    3
                ],
                [
                    1,
                    1,
                    2,
                    2,
                    2,
                    3
                ]
            ],
            b: [
                [
                    3,
                    8
                ],
                [
                    0,
                    5
                ],
                [
                    -3,
                    8
                ],
                [
                    -6,
                    7
                ],
                [
                    -7,
                    9
                ],
                [
                    3,
                    10
                ]
            ]
        },
        {
            n: "h7",
            g: [
                [
                    0,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    4,
                    4
                ],
                [
                    2,
                    2,
                    2,
                    3,
                    3,
                    4
                ],
                [
                    2,
                    2,
                    3,
                    3,
                    3,
                    4
                ],
                [
                    2,
                    3,
                    3,
                    3,
                    4,
                    4
                ]
            ],
            b: [
                [
                    -2,
                    10
                ],
                [
                    4,
                    8
                ],
                [
                    3,
                    5
                ],
                [
                    1,
                    7
                ],
                [
                    -3,
                    6
                ]
            ]
        },
        {
            n: "h8",
            g: [
                [
                    0,
                    0,
                    0,
                    2,
                    3,
                    3
                ],
                [
                    1,
                    0,
                    0,
                    2,
                    3,
                    3
                ],
                [
                    1,
                    1,
                    1,
                    2,
                    3,
                    3
                ],
                [
                    1,
                    4,
                    2,
                    2,
                    2,
                    3
                ],
                [
                    4,
                    4,
                    4,
                    4,
                    4,
                    3
                ]
            ],
            b: [
                [
                    3,
                    10
                ],
                [
                    2,
                    6
                ],
                [
                    -2,
                    7
                ],
                [
                    1,
                    7
                ],
                [
                    -2,
                    7
                ]
            ]
        },
        {
            n: "h9",
            g: [
                [
                    0,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    0,
                    1,
                    2,
                    2,
                    1,
                    3
                ],
                [
                    0,
                    0,
                    2,
                    2,
                    3,
                    3
                ],
                [
                    4,
                    4,
                    4,
                    2,
                    2,
                    3
                ],
                [
                    4,
                    4,
                    4,
                    2,
                    2,
                    3
                ]
            ],
            b: [
                [
                    6,
                    9
                ],
                [
                    -3,
                    10
                ],
                [
                    0,
                    7
                ],
                [
                    0,
                    6
                ],
                [
                    -1,
                    4
                ]
            ]
        }
    ]
};
const $28cc6deb36dec1d2$var$testLevels = [
    {
        n: "5x5",
        g: [
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0
            ]
        ],
        b: [
            [
                0,
                7
            ]
        ]
    },
    {
        n: "5x4",
        g: [
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0
            ]
        ],
        b: [
            [
                0,
                6
            ]
        ]
    },
    {
        n: "5x3",
        g: [
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0
            ]
        ],
        b: [
            [
                0,
                5
            ]
        ]
    },
    {
        n: "4x4",
        g: [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ],
        b: [
            [
                0,
                6
            ]
        ]
    },
    {
        n: "4x3",
        g: [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ],
        b: [
            [
                0,
                5
            ]
        ]
    },
    {
        n: "3x3",
        g: [
            [
                0,
                0,
                0
            ],
            [
                0,
                0,
                0
            ],
            [
                0,
                0,
                0
            ]
        ],
        b: [
            [
                0,
                5
            ]
        ]
    },
    {
        n: "6x6",
        g: [
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ]
        ],
        b: [
            [
                0,
                8
            ]
        ]
    },
    {
        n: "6x4",
        g: [
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ]
        ],
        b: [
            [
                0,
                6
            ]
        ]
    },
    {
        n: "6x5",
        g: [
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0
            ]
        ],
        b: [
            [
                0,
                7
            ]
        ]
    }
];


const $07c1f39f056ef1c8$var$CONFIG = {
    textColor: "#ffffff",
    tweenDuration: 300
};
class $07c1f39f056ef1c8$export$ec9f4d63c1b2b2d3 extends Phaser.GameObjects.Container {
    constructor(config){
        super(config.scene, config.position.x, config.position.y);
        this.currentScore = 0;
        this.config = config;
        this.setScrollFactor(0);
        this.createChildren();
        config.scene.add.existing(this);
    }
    setScore(score) {
        let oldScore = this.currentScore;
        this.currentScore = score;
        this.animateScoreChange(oldScore, this.currentScore);
    }
    animateScoreChange(from, to) {
        let scoreText = this.scoreText;
        this.config.scene.tweens.addCounter({
            from: from,
            to: to,
            duration: $07c1f39f056ef1c8$var$CONFIG.tweenDuration,
            onUpdate: function(tween) {
                var value = Math.floor(tween.getValue());
                scoreText.text = value.toString();
            }
        });
        this.scene.tweens.add({
            targets: this,
            x: "+=10",
            y: "+=10",
            duration: $07c1f39f056ef1c8$var$CONFIG.tweenDuration,
            ease: (t)=>{
                return this.wiggle(t, 3, 2);
            }
        });
    }
    wiggle(aProgress, aPeriod1, aPeriod2) {
        var current1 = aProgress * Math.PI * 2 * aPeriod1;
        var current2 = aProgress * (Math.PI * 2 * aPeriod2 + Math.PI / 2);
        return Math.sin(current1) * Math.cos(current2);
    }
    createChildren() {
        this.scoreText = this.config.scene.add.text(0, 0, "0", {
            fontFamily: "bloggerSans",
            fontSize: 35,
            color: $07c1f39f056ef1c8$var$CONFIG.textColor,
            align: "center"
        });
        this.add([
            this.scoreText
        ]);
    }
}






const $d7b76b24920e934a$var$minigameConfig = {
    levels: {
        spawnNewDelay: 1300,
        startCountdownDelay: 1300,
        cameraTweenDuration: 1000,
        cameraTweenDelay: 300,
        cameraTweenHold: 300,
        cameraTween: "Back.easeInOut"
    },
    difficulty: {
        levelChances: [
            {
                level: {
                    from: -1,
                    to: 5
                },
                easy: 1,
                normal: 0,
                hard: 0
            },
            {
                level: {
                    from: 5,
                    to: 10
                },
                easy: 0.5,
                normal: 0.5,
                hard: 0
            },
            {
                level: {
                    from: 10,
                    to: 20
                },
                easy: 0.2,
                normal: 0.6,
                hard: 0.2
            },
            {
                level: {
                    from: 10,
                    to: 20
                },
                easy: 0.2,
                normal: 0.6,
                hard: 0.2
            },
            {
                level: {
                    from: 20,
                    to: 999999
                },
                easy: 0.1,
                normal: 0.45,
                hard: 0.45
            }
        ]
    },
    scoring: {
        progressMultiplier: 1.08,
        defaultScorePerShape: 4,
        timeMultiplier: 2
    },
    grid: [
        {
            yOffset: 1337,
            cellSize: 1337
        },
        {
            yOffset: 30,
            cellSize: 37
        },
        {
            yOffset: 30,
            cellSize: 37
        },
        {
            yOffset: 30,
            cellSize: 37
        },
        {
            yOffset: 30,
            cellSize: 33
        },
        {
            yOffset: 30,
            cellSize: 28
        },
        {
            yOffset: 30,
            cellSize: 24
        }
    ],
    cameraPos: {
        y: 175
    }
};
class $d7b76b24920e934a$export$3c1d564c0d5a8f6a extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.GRID_FILL,
            duration: 999999999,
            showCountdown: 0,
            showHomeButton: false,
            timeToStart: 1000,
            startScreenColor: 0x5ED3FF,
            startText: "FILL THE\nGRID!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.END,
            showSkipButton: false,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BIRTH,
            endButtons: {
                normalNoSkip: {
                    x: -426.5,
                    y: 386,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 283,
                    y: 386,
                    scale: 1.30
                },
                skip: {
                    x: 570,
                    y: 386,
                    scale: 1.30
                }
            },
            isArcadeMinigame: true
        });
        this.difficulty = {
            durationMultiplier: 0.96,
            defaultShapeCount: 3,
            defaultDuration: 25000,
            minimumDuration: 10000
        };
        this.isRestart = false;
    }
    _init() {
        this.levelsCompleted = 0;
        this.currentScore = 0;
        this.isRestart = this.checkForRestart();
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.levelQueue = {
            easy: [],
            normal: [],
            hard: []
        };
        this.prepareLevelQueue();
        this.countdown = undefined;
        this.getRemoteConfig();
    }
    getRemoteConfig() {
        let remoteConf = this.remoteConf.getConfig("gG").split(";");
        this.difficulty.durationMultiplier = parseFloat(remoteConf[0]);
        this.difficulty.defaultShapeCount = parseInt(remoteConf[1]);
        this.difficulty.defaultDuration = parseInt(remoteConf[2]) * 100;
        this.difficulty.minimumDuration = parseInt(remoteConf[3]) * 100;
    // console.log("difficulty");
    // console.log(this.difficulty);
    }
    checkForRestart() {
        let key = this.sceneName + "restart";
        let restartInfo = this.storagePlugin.getItem(key, "");
        if (restartInfo) {
            let parsed = JSON.parse(restartInfo);
            this.levelsCompleted = parsed.levels;
            this.currentScore = parsed.score;
            this.storagePlugin.removeItem(key);
            return true;
        }
        return false;
    }
    prepareLevelQueue(easy = true, normal = true, hard = true) {
        if (easy) this.levelQueue.easy = Phaser.Utils.Array.Shuffle([
            ...(0, $28cc6deb36dec1d2$export$cc32c6afed33d362).easy
        ]);
        if (normal) this.levelQueue.normal = Phaser.Utils.Array.Shuffle([
            ...(0, $28cc6deb36dec1d2$export$cc32c6afed33d362).normal
        ]);
        if (hard) this.levelQueue.hard = Phaser.Utils.Array.Shuffle([
            ...(0, $28cc6deb36dec1d2$export$cc32c6afed33d362).hard
        ]);
    }
    _preload() {}
    _create() {
        this.createBackground();
        this.gameplayScoreDisplay = new (0, $07c1f39f056ef1c8$export$ec9f4d63c1b2b2d3)({
            scene: this,
            position: {
                x: 30,
                y: 10
            }
        });
        this.gameplayScoreDisplay.setScore(this.currentScore);
        this.homeButton = new (0, $ecb7686a60e0dea3$export$2e2bcd8739ae039)(this, 40, this.renderer.height - 40).setDepth(30).setScrollFactor(0, 0, true).setScale(0.75);
    }
    onGameStarted() {
        this.createNewGrid();
        this.createNewCountdown();
    }
    createBackground() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.BACKGROUND).setOrigin(0, 0).setDepth(0).setScrollFactor(0);
        this.add.image(this.game.renderer.width / 2, $d7b76b24920e934a$var$minigameConfig.cameraPos.y + 5, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.HANDS).setDepth(10);
        this.add.image(this.game.renderer.width / 2, $d7b76b24920e934a$var$minigameConfig.cameraPos.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.CAMERA).setDepth(9);
    }
    //Spawns new level
    createNewGrid() {
        this.currentLevel = this.getNextLevel(this.levelsCompleted);
        this.gridManager = new (0, $a59851f331e8148f$export$2e2bcd8739ae039)(this, {
            x: this.game.renderer.width / 2,
            y: $d7b76b24920e934a$var$minigameConfig.cameraPos.y
        }, this.currentLevel, $d7b76b24920e934a$var$minigameConfig.grid);
        this.gridManager.createGrid();
    }
    destroyCurrentGrid() {
        this.gridManager.destroy();
    }
    createNewCountdown() {
        this.countdown = new (0, $0ccfeab63f78a1e3$export$53819c0e58f98d49)({
            scene: this,
            position: {
                x: this.game.renderer.width / 2,
                y: 17
            },
            duration: this.getLevelDuration(this.currentLevel),
            onComplete: ()=>{
                this.triggerLose();
            }
        }).startCountdown();
    }
    getLevelDuration(level) {
        let levelSize = level.g[0].length * level.g.length;
        let shapeCount = level.b.length;
        let shapeMultiplier = shapeCount / this.difficulty.defaultShapeCount;
        let progressMultiplier = Math.pow(this.difficulty.durationMultiplier, this.levelsCompleted);
        return Math.max(this.difficulty.defaultDuration * shapeMultiplier * progressMultiplier, this.difficulty.minimumDuration);
    }
    getNextLevel(levelsCompleted) {
        //get easy/normal/hard leveldepending on how many levels completed
        var chances = $d7b76b24920e934a$var$minigameConfig.difficulty.levelChances.filter((c)=>{
            return c.level.from <= levelsCompleted && c.level.to > levelsCompleted;
        })[0];
        var rand = Math.random();
        rand -= chances.easy;
        if (rand <= 0) return this.getRandomLevel(this.levelQueue.easy);
        rand -= chances.normal;
        if (rand <= 0) return this.getRandomLevel(this.levelQueue.normal);
        rand -= chances.hard;
        if (rand <= 0) return this.getRandomLevel(this.levelQueue.hard);
        console.log("This shouldnt happen.");
        return this.getRandomLevel(this.levelQueue.normal);
    }
    getRandomLevel(arr) {
        if (arr.length < 1) this.prepareLevelQueue();
        return arr.pop();
    }
    onLevelCompleted() {
        this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.FLASH);
        setTimeout(()=>{
            this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.WIN, {
                detune: this.getDetune()
            });
        }, 400);
        this.sendLevelAnalyticsEvent(true);
        this.levelsCompleted++;
        this.updateScore();
        this.countdown.stopCountdown();
        this.gridManager.handleLevelCompleted();
        this.animateCameraNextLevel();
        setTimeout(()=>{
            this.destroyCurrentGrid();
            this.createNewGrid();
        }, $d7b76b24920e934a$var$minigameConfig.levels.spawnNewDelay);
        setTimeout(()=>{
            this.countdown.destroy();
            this.createNewCountdown();
        }, $d7b76b24920e934a$var$minigameConfig.levels.spawnNewDelay + $d7b76b24920e934a$var$minigameConfig.levels.startCountdownDelay);
    }
    updateScore() {
        let baseScore = $d7b76b24920e934a$var$minigameConfig.scoring.defaultScorePerShape * this.currentLevel.b.length;
        let timeMultiplier = $d7b76b24920e934a$var$minigameConfig.scoring.timeMultiplier * this.countdown.getRemainingTimeShare();
        let progressMultiplier = Math.pow($d7b76b24920e934a$var$minigameConfig.scoring.progressMultiplier, this.levelsCompleted);
        this.currentScore += Math.round(baseScore * timeMultiplier * progressMultiplier);
        this.gameplayScoreDisplay.setScore(this.currentScore);
    }
    animateCameraNextLevel() {
        this.tweens.add({
            targets: this.cameras.main,
            scrollY: "-=480",
            ease: $d7b76b24920e934a$var$minigameConfig.levels.cameraTween,
            duration: $d7b76b24920e934a$var$minigameConfig.levels.cameraTweenDuration,
            yoyo: true,
            repeat: 0,
            delay: $d7b76b24920e934a$var$minigameConfig.levels.cameraTweenDelay,
            hold: $d7b76b24920e934a$var$minigameConfig.levels.cameraTweenHold
        });
    }
    _update(time, delta) {
        if (this.countdown) this.countdown.onUpdate();
    }
    _timeout() {
    // this.loseGame();
    }
    _afterLoss() {}
    _afterWin() {}
    triggerLose() {
        this.homeButton.setVisible(false);
        this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.LOSE, {
            volume: 4
        });
        this.sendLevelAnalyticsEvent(false);
        this.sendFinalScoreAnalyticsEvent(this.currentScore);
        this.saveAndDisplayScore();
        //Disable grid
        this.gridManager.onGameLost();
        this.loseGame(2000);
    }
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.winGame(1000);
    }
    saveAndDisplayScore() {
        var score = this.currentScore;
        var oldHighscore = this.getHighscore();
        var isNewHighscore = score > oldHighscore;
        this.endScoreDisplay.text = score.toString();
        this.highscoreImage.setAlpha(isNewHighscore ? 1 : 0);
        let scoreLength = this.endScoreDisplay.text.length;
        this.highscoreImage.setPosition(this.highscoreImage.x + scoreLength * 17, this.highscoreImage.y - scoreLength * 1.4);
        if (isNewHighscore) this.setHighscore(score);
    }
    getCustomLoseUIElements() {
        this.endScoreDisplay = this.add.text(500, 250, "123456", {
            fontFamily: "bloggerSans",
            fontSize: 35,
            color: "#B7A26E",
            align: "center"
        }).setAngle(-4);
        this.highscoreImage = this.add.image(503, 291.4, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.NEW_BEST);
        if (this.isRestart || this.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).REGISTRY.ADBLOCKENABLED)) {
            //Without continue button
            var backButton2 = new (0, $3f010fa5bfb89089$export$2e2bcd8739ae039)((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU, 524, 334, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.ARCADE);
            var tryAgainButton2 = new (0, $526fb0004cf1157b$export$2e2bcd8739ae039)(632, 329, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.TRY_AGAIN_2);
            return [
                backButton2,
                tryAgainButton2,
                this.endScoreDisplay,
                this.highscoreImage
            ];
        } else {
            // With continue button
            var backButton = new (0, $3f010fa5bfb89089$export$2e2bcd8739ae039)((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU, 615, 365, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.BACK);
            var continueButton = new (0, $bee7b1f49e5c2618$export$2e2bcd8739ae039)(627, 328, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.CONTINUE, ()=>{
                return this.getContinueData();
            });
            var tryAgainButton = new (0, $526fb0004cf1157b$export$2e2bcd8739ae039)(520, 333, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).GRID_FILL.TRY_AGAIN);
            return [
                backButton,
                continueButton,
                tryAgainButton,
                this.endScoreDisplay,
                this.highscoreImage
            ];
        }
    }
    getContinueData() {
        return {
            levels: this.levelsCompleted,
            score: this.currentScore
        };
    }
    sendLevelAnalyticsEvent(completed) {
        let eventName = completed ? "Completed" : "Failed";
        let levelName = this.gridManager.getGridName();
        let value = completed ? this.countdown.getElapsedTime() : this.countdown.getTotalTime();
        const customDesignEvent = this.sceneName + ":" + levelName + ":" + eventName;
        this.analyticsPlugin.addDesignEventWithValue(customDesignEvent, Math.round(value));
    //console.log("gridfill event " + eventName + " " + levelName + " " + value);
    }
}






var $9affabeca4ec219a$export$23604669e62375d1;
(function(DistractionState) {
    DistractionState[DistractionState["Deactivated"] = 0] = "Deactivated";
    DistractionState[DistractionState["Starting"] = 1] = "Starting";
    DistractionState[DistractionState["Active"] = 2] = "Active";
    DistractionState[DistractionState["Ending"] = 3] = "Ending";
})($9affabeca4ec219a$export$23604669e62375d1 || ($9affabeca4ec219a$export$23604669e62375d1 = {}));
class $9affabeca4ec219a$export$2e2bcd8739ae039 {
    constructor(scene, config){
        this.disabled = false;
        this.pendingActivation = false;
        this.pendingDeactivation = false;
        this.scene = scene;
        this.config = config;
    }
    init() {
        this.changeState(0);
    }
    setCallbacks(onActivated, onDeactivated) {
        this.activeCallback = onActivated;
        this.deactivatedCallback = onDeactivated;
    }
    activate() {
        if (!this.canActivate()) this.pendingActivation = true;
        else {
            this.pendingActivation = false;
            this.changeState(1);
        }
    }
    deactivate() {
        if (this.state === 1) {
            this.pendingDeactivation = true;
            return;
        }
        if (!this.isActive()) return;
        this.changeState(3);
        this.pendingDeactivation = false;
    }
    changeState(newState) {
        this.state = newState;
        this.handleStateChange(newState);
    }
    handleStateChange(newState) {
        if (this.disabled) return;
        switch(newState){
            case 0:
                if (this.deactivatedCallback) this.deactivatedCallback();
                this.onDeactivated();
                //Instantly reactivate if needed
                if (this.pendingActivation) this.activate();
                break;
            case 1:
                this.onStarting();
                break;
            case 2:
                if (this.activeCallback) this.activeCallback();
                this.onActivated();
                if (this.pendingDeactivation) this.deactivate();
                break;
            case 3:
                this.onEnding();
                break;
            default:
                console.log("Unrecognized state: " + newState);
                break;
        }
    }
    isActive() {
        return this.state === 2;
    }
    canActivate() {
        return this.state === 0;
    }
    isPendingActivation() {
        return this.pendingActivation;
    }
    forceDisable() {
        this.disabled = true;
        this.onEnding();
    }
}


const $4dd412d8d83ec784$var$CONFIG = {
    vibration: {
        duration: 1000,
        timeBetweenPulses: 500
    },
    startTime: 500,
    endTime: 500
};
class $4dd412d8d83ec784$export$2e2bcd8739ae039 extends (0, $9affabeca4ec219a$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.phoneContainer = scene.add.container(config.x, config.y).setDepth(config.depth);
        this.phoneImg = scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE);
        this.phoneScreenImg = scene.add.image(3, -6, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE_MESSAGE_3).setAlpha(0);
        this.phoneBuzz_1 = scene.add.image(-85, 15, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE_BUZZ_1).setAlpha(0);
        this.phoneBuzz_2 = scene.add.image(35, -47, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE_BUZZ_2).setAlpha(0);
        let phoneShadow = scene.add.image(0, 16, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE_SHADOW);
        this.phoneImg.setInteractive({
            useHandCursor: true,
            pixelPerfect: true,
            alphaTolerance: 1
        });
        this.phoneImg.on("pointerup", ()=>{
            this.handleClick();
        });
        this.phoneContainer.add([
            phoneShadow,
            this.phoneImg,
            this.phoneScreenImg,
            this.phoneBuzz_1,
            this.phoneBuzz_2
        ]);
        this.init();
    }
    handleClick() {
        this.deactivate();
    }
    onDeactivated() {
        this.phoneImg.clearTint();
    }
    onStarting() {
        this.startVibrating();
        setTimeout(()=>{
            this.changeState((0, $9affabeca4ec219a$export$23604669e62375d1).Active);
        }, $4dd412d8d83ec784$var$CONFIG.startTime);
    }
    onActivated() {}
    onEnding() {
        this.stopVibrating();
        setTimeout(()=>{
            this.changeState((0, $9affabeca4ec219a$export$23604669e62375d1).Deactivated);
        }, $4dd412d8d83ec784$var$CONFIG.endTime);
    }
    onGameLost() {
        this.phoneImg.disableInteractive();
    }
    startVibrating() {
        let phoneScreen = this.phoneScreenImg;
        phoneScreen.setAlpha(1);
        let s = this.scene;
        this.screenTween = this.scene.tweens.addCounter({
            from: 0,
            to: 3,
            duration: 3 * $4dd412d8d83ec784$var$CONFIG.vibration.duration,
            onUpdate: function(tween) {
                var value = Math.floor(tween.getValue());
                switch(value){
                    case 0:
                        if (phoneScreen.texture.key === (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE_MESSAGE_1) break;
                        phoneScreen.setTexture((0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE_MESSAGE_1);
                        s.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.POP, {
                            detune: -200,
                            volume: 5
                        });
                        break;
                    case 1:
                        if (phoneScreen.texture.key === (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE_MESSAGE_2) break;
                        phoneScreen.setTexture((0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE_MESSAGE_2);
                        s.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.POP, {
                            detune: 0,
                            volume: 5
                        });
                        break;
                    case 2:
                        if (phoneScreen.texture.key === (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE_MESSAGE_3) break;
                        phoneScreen.setTexture((0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE_MESSAGE_3);
                        s.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.POP, {
                            detune: 200,
                            volume: 5
                        });
                        break;
                }
            }
        });
        this.vibratingTween = this.scene.tweens.add({
            targets: this.phoneContainer,
            x: "+=2",
            y: "+=2",
            angle: "+=1",
            duration: $4dd412d8d83ec784$var$CONFIG.vibration.duration,
            hold: $4dd412d8d83ec784$var$CONFIG.vibration.timeBetweenPulses,
            ease: (t)=>{
                return this.wiggle(t, 5, 5);
            },
            onStart: ()=>{
                this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.VIBRATE, {
                    volume: 14
                });
            },
            onRepeat: ()=>{
                this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.VIBRATE, {
                    volume: 14
                });
            },
            repeat: -1
        });
        this.vibratingTimeline = this.scene.tweens.timeline({
            targets: [
                this.phoneBuzz_1,
                this.phoneBuzz_2
            ],
            loop: -1,
            tweens: [
                {
                    alpha: 1,
                    duration: 100,
                    hold: $4dd412d8d83ec784$var$CONFIG.vibration.duration - 500,
                    ease: "Quad.easeInOut"
                },
                {
                    alpha: 0,
                    duration: 400,
                    hold: $4dd412d8d83ec784$var$CONFIG.vibration.timeBetweenPulses,
                    ease: "Quad.easeInOut"
                }
            ]
        });
    }
    stopVibrating() {
        if (this.vibratingTimeline) this.vibratingTimeline.stop();
        if (this.vibratingTween) this.vibratingTween.stop();
        if (this.screenTween) this.screenTween.stop();
        this.phoneBuzz_1.setAlpha(0);
        this.phoneBuzz_2.setAlpha(0);
        this.phoneScreenImg.setAlpha(0);
        this.phoneScreenImg.setTexture((0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.PHONE_MESSAGE_3);
        //Reset phone position
        this.phoneContainer.setAngle(0).setPosition(this.config.x, this.config.y);
    }
    wiggle(aProgress, aPeriod1, aPeriod2) {
        var current1 = aProgress * Math.PI * 2 * aPeriod1;
        var current2 = aProgress * (Math.PI * 2 * aPeriod2 + Math.PI / 2);
        return Math.sin(current1) * Math.cos(current2);
    }
}


const $ab1240a02d4f048f$var$config = {
    difficulty: {
        spawnTime: {
            start: {
                min: 2000,
                max: 3000
            },
            end: {
                min: 500,
                max: 1500
            }
        }
    },
    score: {
        max: 100
    }
};
class $ab1240a02d4f048f$export$2e2bcd8739ae039 {
    static{
        this.activeCount = 0 //how many distractions are currently active
        ;
    }
    constructor(distractions, startTime, scene){
        this.difficultyConfig = {
            timeToReachEnd: 30000,
            defaultScoreSpeed: -25,
            activeDistractionSpeedChange: 15,
            startSpawnTimeMultiplier: 1,
            endSpawnTimeMultipler: 1
        };
        this.distractions = [];
        this.lastActiveCount = 0;
        this.scene = scene;
        this.getRemoteConfig();
        this.distractions = distractions;
        this.spawner = new $ab1240a02d4f048f$var$DistractionSpawner(this);
        this.score = new $ab1240a02d4f048f$var$DistractionScore();
        this.survivalTimer = new $ab1240a02d4f048f$var$SurvivalTime(startTime);
        this.distractions.forEach((dist)=>{
            dist.setCallbacks(this.onDistractionActivated, this.onDistractionDeactivated);
        });
        $ab1240a02d4f048f$export$2e2bcd8739ae039.activeCount = 0;
    }
    getRemoteConfig() {
        let remoteConf = this.scene.remoteConf.getConfig("gD").split(";");
        this.difficultyConfig.timeToReachEnd = parseInt(remoteConf[0]) * 1000;
        this.difficultyConfig.defaultScoreSpeed = parseInt(remoteConf[1]) * -1;
        this.difficultyConfig.activeDistractionSpeedChange = parseInt(remoteConf[2]);
        this.difficultyConfig.startSpawnTimeMultiplier = parseInt(remoteConf[3]) / 100;
        this.difficultyConfig.endSpawnTimeMultipler = parseInt(remoteConf[4]) / 100;
    // console.log("difficulty");
    // console.log(this.difficultyConfig);
    }
    _update(time, delta) {
        this.spawner._update(time, delta);
        if (this.getActiveCount() != this.lastActiveCount) {
            this.lastActiveCount = this.getActiveCount();
            this.score.updateScoreChangeSpeed(this.getActiveCount(), this);
        }
        this.score.updateScore(delta);
        this.survivalTimer.updateTime(delta);
    }
    onDistractionActivated() {
        $ab1240a02d4f048f$export$2e2bcd8739ae039.activeCount++;
    // console.log("Active count: " + DistractionManager.activeCount + " (activated)");
    }
    onDistractionDeactivated() {
        $ab1240a02d4f048f$export$2e2bcd8739ae039.activeCount--;
    // console.log("Active count: " + DistractionManager.activeCount + " (deactivated)");
    }
    startSpawning() {
        this.survivalTimer.startTiming();
        this.spawner.startSpawning();
    }
    onGameLost() {
        //disable interactive in all distractions
        this.distractions.forEach((dist)=>dist.onGameLost());
        this.survivalTimer.stopTiming();
    }
    getActiveCount() {
        return $ab1240a02d4f048f$export$2e2bcd8739ae039.activeCount;
    }
    getDistractions() {
        return this.distractions;
    }
    getScore() {
        return this.score.getCurrentScore();
    }
    getSurvivalTimeInSeconds() {
        return Math.round(this.getSurvivalTime() / 1000);
    }
    getSurvivalTime() {
        return this.survivalTimer.getTime();
    }
}
class $ab1240a02d4f048f$var$DistractionScore {
    updateScoreChangeSpeed(activeDistractions, dManager) {
        this.scoreChangeSpeed = dManager.difficultyConfig.defaultScoreSpeed + activeDistractions * dManager.difficultyConfig.activeDistractionSpeedChange;
    }
    updateScore(delta) {
        this.currentScore += this.scoreChangeSpeed * delta / 1000;
        this.currentScore = Math.min(Math.max(this.currentScore, 0), $ab1240a02d4f048f$var$config.score.max);
    }
    getCurrentScore() {
        return this.currentScore;
    }
    constructor(){
        this.currentScore = 0;
        this.scoreChangeSpeed = 0;
    }
}
class $ab1240a02d4f048f$var$SurvivalTime {
    constructor(startTime){
        this.time = 0;
        this.isAlive = false;
        this.time = startTime;
    }
    updateTime(delta) {
        if (!this.isAlive) return;
        this.time += delta;
    }
    startTiming() {
        this.isAlive = true;
    }
    stopTiming() {
        this.isAlive = false;
    }
    getTime() {
        return this.time;
    }
}
class $ab1240a02d4f048f$var$DistractionSpawner {
    constructor(distractionManager){
        this.nextSpawnTimer = 0;
        this.isSpawning = false;
        this.dManager = distractionManager;
    }
    startSpawning() {
        this.isSpawning = true;
        this.calculateNextSpawnTime();
    }
    _update(time, delta) {
        if (!this.isSpawning) return;
        this.nextSpawnTimer -= delta;
        if (this.nextSpawnTimer < 0) {
            this.spawnRandomDistraction();
            this.calculateNextSpawnTime();
        }
    }
    //Activates 
    spawnRandomDistraction() {
        let availableDistractions = [];
        this.dManager.getDistractions().forEach((dist)=>{
            if (!dist.isPendingActivation()) availableDistractions.push(dist);
        });
        if (availableDistractions.length == 0) // console.log("Can't activate any distractions!!!");
        return;
        let nextDistraction = Phaser.Utils.Array.GetRandom(availableDistractions);
        nextDistraction.activate();
    }
    calculateNextSpawnTime() {
        let spawnDiff = $ab1240a02d4f048f$var$config.difficulty.spawnTime;
        let progress = Math.min(this.dManager.getSurvivalTime() / this.dManager.difficultyConfig.timeToReachEnd, 1);
        let min = Phaser.Math.Linear(spawnDiff.start.min * this.dManager.difficultyConfig.startSpawnTimeMultiplier, spawnDiff.end.min * this.dManager.difficultyConfig.endSpawnTimeMultipler, progress);
        let max = Phaser.Math.Linear(spawnDiff.start.max * this.dManager.difficultyConfig.startSpawnTimeMultiplier, spawnDiff.end.max * this.dManager.difficultyConfig.endSpawnTimeMultipler, progress);
        this.nextSpawnTimer = this.getRandomInt(min, max);
    }
    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}




const $3099e5f836e310eb$var$CONFIG = {
    animation: {
        movement: {
            duration: 750,
            ease: {
                in: "Quad.easeOut",
                out: "Quad.easeIn"
            },
            from: {
                x: -225,
                y: 30
            }
        },
        images: [
            {
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.BALL_1,
                offset: {
                    x: 20,
                    y: 0
                }
            },
            {
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.BALL_2,
                offset: {
                    x: 0,
                    y: 0
                }
            },
            {
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.BALL_3,
                offset: {
                    x: 0,
                    y: 1
                }
            },
            {
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.BALL_4,
                offset: {
                    x: 0,
                    y: -5
                }
            },
            {
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.BALL_5,
                offset: {
                    x: 0,
                    y: 2
                }
            },
            {
                key: (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.BALL_6,
                offset: {
                    x: 0,
                    y: 1
                }
            }
        ]
    }
};
class $3099e5f836e310eb$export$2e2bcd8739ae039 extends (0, $9affabeca4ec219a$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.container = scene.add.container(config.x + $3099e5f836e310eb$var$CONFIG.animation.movement.from.x, config.y + $3099e5f836e310eb$var$CONFIG.animation.movement.from.y).setDepth(config.depth);
        this.ballImg = scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.BALL_1);
        this.ballImg.setInteractive({
            useHandCursor: true,
            pixelPerfect: true,
            alphaTolerance: 1
        });
        this.ballImg.on("pointerup", ()=>{
            this.handleClick();
        });
        this.setBallImage(0);
        this.container.add([
            this.ballImg
        ]);
        this.init();
    }
    animateMovement(rollingIn) {
        if (this.moveTween) this.moveTween.stop();
        this.container.setPosition(this.config.x + (rollingIn ? $3099e5f836e310eb$var$CONFIG.animation.movement.from.x : 0), this.config.y + (rollingIn ? $3099e5f836e310eb$var$CONFIG.animation.movement.from.y : 0));
        this.moveTween = this.scene.tweens.add({
            targets: this.container,
            x: this.config.x + (rollingIn ? 0 : $3099e5f836e310eb$var$CONFIG.animation.movement.from.x),
            y: this.config.y + (rollingIn ? 0 : $3099e5f836e310eb$var$CONFIG.animation.movement.from.y),
            ease: rollingIn ? $3099e5f836e310eb$var$CONFIG.animation.movement.ease.in : $3099e5f836e310eb$var$CONFIG.animation.movement.ease.out,
            duration: $3099e5f836e310eb$var$CONFIG.animation.movement.duration,
            repeat: 0
        });
    }
    animateBallImages(rollingIn) {
        if (this.imgTween) this.imgTween.stop();
        this.setBallImage(rollingIn ? 0 : $3099e5f836e310eb$var$CONFIG.animation.images.length - 1);
        this.imgTween = this.scene.tweens.addCounter({
            targets: this,
            from: rollingIn ? 0 : $3099e5f836e310eb$var$CONFIG.animation.images.length + 0.3,
            to: rollingIn ? $3099e5f836e310eb$var$CONFIG.animation.images.length + 0.3 : 0,
            ease: rollingIn ? $3099e5f836e310eb$var$CONFIG.animation.movement.ease.in : $3099e5f836e310eb$var$CONFIG.animation.movement.ease.out,
            repeat: 0,
            delay: rollingIn ? 0 : 0,
            duration: $3099e5f836e310eb$var$CONFIG.animation.movement.duration,
            onUpdate: function(tween, key, targets) {
                var value = Math.max(0, Math.floor(tween.getValue() - 1));
                this.setBallImage(value);
            },
            onUpdateScope: this
        });
    }
    setBallImage(img) {
        img = Math.round(img) % $3099e5f836e310eb$var$CONFIG.animation.images.length;
        let conf = $3099e5f836e310eb$var$CONFIG.animation.images[img];
        this.ballImg.setTexture(conf.key);
        this.ballImg.setPosition(conf.offset.x, conf.offset.y);
    }
    animateActive(isActive) {
        if (isActive) this.activeTween = this.scene.tweens.add({
            targets: this.ballImg,
            scaleX: 1.1,
            scaleY: 1.1,
            ease: "Quad.easeOut",
            duration: 400,
            repeat: -1,
            yoyo: true,
            onStart: ()=>{
                this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.BOUNCE, {
                    detune: this.scene.getDetune(),
                    volume: 2
                });
            },
            onRepeat: ()=>{
                this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.BOUNCE, {
                    detune: this.scene.getDetune(),
                    volume: 2
                });
            }
        });
        else {
            this.ballImg.setScale(1);
            if (this.activeTween) this.activeTween.stop();
        }
    }
    handleClick() {
        this.deactivate();
    }
    onDeactivated() {
        this.ballImg.clearTint();
    }
    onStarting() {
        this.animateBallImages(true);
        this.animateMovement(true);
        setTimeout(()=>{
            this.changeState((0, $9affabeca4ec219a$export$23604669e62375d1).Active);
        }, $3099e5f836e310eb$var$CONFIG.animation.movement.duration);
    }
    onActivated() {
        this.animateActive(true);
    }
    onEnding() {
        this.animateBallImages(false);
        this.animateMovement(false);
        this.animateActive(false);
        setTimeout(()=>{
            this.changeState((0, $9affabeca4ec219a$export$23604669e62375d1).Deactivated);
        }, $3099e5f836e310eb$var$CONFIG.animation.movement.duration);
    }
    onGameLost() {
        this.ballImg.disableInteractive();
    }
}




const $dbad9ef185a53530$var$CONFIG = {
    animation: {
        movement: {
            duration: 800,
            ease: {
                in: "Back.easeOut",
                out: "Back.easeIn"
            },
            from: {
                x: 0,
                y: 150
            }
        }
    },
    hand: {
        duration: 500,
        x: 5,
        y: -50,
        angle: {
            from: 30,
            to: 15
        }
    }
};
class $dbad9ef185a53530$export$2e2bcd8739ae039 extends (0, $9affabeca4ec219a$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.container = scene.add.container(config.x + $dbad9ef185a53530$var$CONFIG.animation.movement.from.x, config.y + $dbad9ef185a53530$var$CONFIG.animation.movement.from.y).setDepth(config.depth);
        this.characterImg = scene.add.image(-29.6, -51, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.WINDOW_CHARACTER);
        this.handImg = scene.add.image($dbad9ef185a53530$var$CONFIG.hand.x, $dbad9ef185a53530$var$CONFIG.hand.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.WINDOW_HAND).setAngle($dbad9ef185a53530$var$CONFIG.hand.angle.from).setOrigin(0.12, 0.87);
        this.characterImg.on("pointerup", ()=>{
            this.handleClick();
        });
        this.container.add([
            this.handImg,
            this.characterImg
        ]);
        this.init();
        this.animateHand();
    }
    animateMovement(rollingIn) {
        this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.HELLO, {
            detune: this.scene.getDetune(),
            volume: 2
        });
        if (this.moveTween) this.moveTween.stop();
        this.container.setPosition(this.config.x + (rollingIn ? $dbad9ef185a53530$var$CONFIG.animation.movement.from.x : 0), this.config.y + (rollingIn ? $dbad9ef185a53530$var$CONFIG.animation.movement.from.y : 0));
        this.container.setScale(1, rollingIn ? 0.7 : 1);
        this.moveTween = this.scene.tweens.add({
            targets: this.container,
            x: this.config.x + (rollingIn ? 0 : $dbad9ef185a53530$var$CONFIG.animation.movement.from.x),
            y: this.config.y + (rollingIn ? 0 : $dbad9ef185a53530$var$CONFIG.animation.movement.from.y),
            scaleY: rollingIn ? 1 : 0.7,
            ease: rollingIn ? $dbad9ef185a53530$var$CONFIG.animation.movement.ease.in : $dbad9ef185a53530$var$CONFIG.animation.movement.ease.out,
            duration: $dbad9ef185a53530$var$CONFIG.animation.movement.duration,
            repeat: 0
        });
    }
    animateHand() {
        this.scene.tweens.add({
            targets: this.handImg,
            angle: $dbad9ef185a53530$var$CONFIG.hand.angle.to,
            ease: "Quad.easeInOut",
            duration: $dbad9ef185a53530$var$CONFIG.hand.duration,
            repeat: -1,
            yoyo: true
        });
    }
    animateActive(isActive) {
        if (isActive) this.activeTween = this.scene.tweens.add({
            targets: this.container,
            scaleY: 1.05,
            ease: "Quad.easeOut",
            duration: 250,
            repeat: -1,
            yoyo: true
        });
        else {
            this.container.setScale(1);
            if (this.activeTween) this.activeTween.stop();
        }
    }
    handleClick() {
        this.deactivate();
    }
    onDeactivated() {}
    onStarting() {
        this.characterImg.setInteractive({
            useHandCursor: true,
            pixelPerfect: true,
            alphaTolerance: 1
        });
        this.animateMovement(true);
        setTimeout(()=>{
            this.changeState((0, $9affabeca4ec219a$export$23604669e62375d1).Active);
        }, $dbad9ef185a53530$var$CONFIG.animation.movement.duration);
    }
    onActivated() {
        this.animateActive(true);
    }
    onEnding() {
        this.characterImg.disableInteractive();
        this.animateActive(false);
        this.animateMovement(false);
        setTimeout(()=>{
            this.changeState((0, $9affabeca4ec219a$export$23604669e62375d1).Deactivated);
        }, $dbad9ef185a53530$var$CONFIG.animation.movement.duration);
    }
    onGameLost() {
        this.characterImg.disableInteractive();
    }
}




const $5078f46f0ab2fd6a$var$CONFIG = {
    ballBounds: {
        x: {
            from: -62,
            to: 77
        },
        y: {
            from: -47,
            to: 45
        }
    },
    ballSpeed: {
        x: {
            from: 50,
            to: 70
        },
        y: {
            from: -50,
            to: 50
        },
        yChangeMax: 100
    },
    paddleTrigger: {
        left: -10,
        right: 25
    }
};
class $5078f46f0ab2fd6a$export$2e2bcd8739ae039 extends (0, $9affabeca4ec219a$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.ballSpeed = {
            x: 90,
            y: 30
        };
        this.container = scene.add.container(config.x, config.y).setDepth(config.depth);
        this.tvBackground = scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_SCREEN_DARK);
        this.tvBackground.setInteractive({
            useHandCursor: true,
            pixelPerfect: true,
            alphaTolerance: 1
        });
        this.tvBackground.on("pointerup", ()=>{
            this.handleClick();
        });
        this.pongContainer = scene.add.container(0, 0);
        this.scoreLeft = scene.add.image(-5, -37, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_TEXT_0);
        this.scoreRight = scene.add.image(20, -37, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_TEXT_0);
        this.paddleLeft = scene.add.image(-65, -3, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_PADDLE);
        this.paddleRight = scene.add.image(80, -3, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_PADDLE);
        this.ball = scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_BALL).setScale(1.5);
        this.pongContainer.add([
            this.scoreLeft,
            this.scoreRight,
            this.paddleLeft,
            this.paddleRight,
            this.ball
        ]);
        this.pongContainer.setVisible(false);
        this.container.add([
            this.tvBackground,
            this.pongContainer
        ]);
        this.init();
        this.scene.events.on("update", this.update, this);
    }
    update(time, delta) {
        this.updateBallPosition(delta);
        this.updatePaddlePosition(delta);
    }
    updateBallPosition(delta) {
        this.ball.setPosition(this.ball.x + this.ballSpeed.x * delta / 1000, this.ball.y + this.ballSpeed.y * delta / 1000);
        //paddle hit
        if (this.ball.x > $5078f46f0ab2fd6a$var$CONFIG.ballBounds.x.to || this.ball.x < $5078f46f0ab2fd6a$var$CONFIG.ballBounds.x.from) {
            if (!this.canActivate()) this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.PING_2, {
                volume: 2
            });
            this.ballSpeed.x = this.ballSpeed.x * -1;
            if (this.ball.x > $5078f46f0ab2fd6a$var$CONFIG.ballBounds.x.to) this.ball.x = $5078f46f0ab2fd6a$var$CONFIG.ballBounds.x.to;
            else this.ball.x = $5078f46f0ab2fd6a$var$CONFIG.ballBounds.x.from;
            //change Yspeed
            let ySpeedChange = Phaser.Math.Between(-$5078f46f0ab2fd6a$var$CONFIG.ballSpeed.yChangeMax, $5078f46f0ab2fd6a$var$CONFIG.ballSpeed.yChangeMax);
            this.ballSpeed.y = Phaser.Math.Clamp(this.ballSpeed.y + ySpeedChange, $5078f46f0ab2fd6a$var$CONFIG.ballSpeed.y.from, $5078f46f0ab2fd6a$var$CONFIG.ballSpeed.y.to);
        }
        //wall hit
        if (this.ball.y > $5078f46f0ab2fd6a$var$CONFIG.ballBounds.y.to || this.ball.y < $5078f46f0ab2fd6a$var$CONFIG.ballBounds.y.from) {
            if (!this.canActivate()) this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.PING_1, {
                volume: 2
            });
            this.ballSpeed.y = this.ballSpeed.y * -1;
        }
    }
    updatePaddlePosition(delta) {
        //move left paddle
        if (this.ball.x < $5078f46f0ab2fd6a$var$CONFIG.paddleTrigger.left) this.paddleLeft.y = Phaser.Math.Interpolation.SmoothStep((this.ball.x - this.paddleLeft.x) / ($5078f46f0ab2fd6a$var$CONFIG.paddleTrigger.left - this.paddleLeft.x), this.ball.y, this.paddleLeft.y);
        //move right paddle
        if (this.ball.x > $5078f46f0ab2fd6a$var$CONFIG.paddleTrigger.right) this.paddleRight.y = Phaser.Math.Interpolation.SmoothStep((this.ball.x - this.paddleRight.x) / ($5078f46f0ab2fd6a$var$CONFIG.paddleTrigger.right - this.paddleRight.x), this.ball.y, this.paddleRight.y);
    }
    handleClick() {
        this.deactivate();
    }
    onDeactivated() {
        this.tvBackground.clearTint();
    }
    onStarting() {
        this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.TV_ON, {
            volume: 2
        });
        this.pongContainer.setVisible(true);
        this.tvBackground.setTexture((0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_SCREEN_LIGHT);
        this.scoreLeft.setTexture(this.getRandomScoreText());
        this.scoreRight.setTexture(this.getRandomScoreText());
        setTimeout(()=>{
            this.changeState((0, $9affabeca4ec219a$export$23604669e62375d1).Active);
        }, 500);
    }
    getRandomScoreText() {
        return Phaser.Utils.Array.GetRandom([
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_TEXT_0,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_TEXT_1,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_TEXT_2,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_TEXT_3,
            (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_TEXT_4
        ]);
    }
    onActivated() {}
    onEnding() {
        this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.TV_ON, {
            volume: 2
        });
        this.pongContainer.setVisible(false);
        this.tvBackground.setTexture((0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TV_SCREEN_DARK);
        setTimeout(()=>{
            this.changeState((0, $9affabeca4ec219a$export$23604669e62375d1).Deactivated);
        }, 500);
    }
    onGameLost() {
        this.tvBackground.disableInteractive();
    }
}





class $58395644c39fd8e9$export$53819c0e58f98d49 {
    constructor(config){
        this.countdownStartX = 0;
        this.countdownMoveX = 0;
        this.config = config;
        this.createImages();
        this.displayScore(0);
    }
    createImages() {
        this.config.scene.add.image(this.config.position.x, this.config.position.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.COUNTDOWN_1).setDepth(this.config.depth); //bg
        this.config.scene.add.image(this.config.position.x, this.config.position.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.COUNTDOWN_2).setDepth(this.config.depth + 1); //white bg
        this.countdownImage = this.config.scene.add.image(this.config.position.x, this.config.position.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.COUNTDOWN_3).setDepth(this.config.depth + 2);
        this.maskShape = this.config.scene.add.graphics().fillStyle(0xffffff, 0).beginPath().fillRect(this.countdownImage.getTopLeft().x, 0, this.countdownImage.displayWidth, 500).setDepth(this.config.depth + 3);
        this.countdownStartX = this.maskShape.x;
        this.countdownMoveX = this.countdownImage.displayWidth;
        var mask = this.maskShape.createGeometryMask();
        this.countdownImage.setMask(mask);
    }
    displayScore(score) {
        let percentage = Phaser.Math.Clamp(score / this.config.maxValue, 0, 1);
        this.maskShape.x = this.countdownStartX - (1 - percentage) * this.countdownMoveX;
    }
}


const $3cc139208c00b3e6$var$minigameConfig = {
    loseScore: 100,
    distractions: {
        phone: {
            x: 730,
            y: 430,
            depth: 5
        },
        ball: {
            x: 190,
            y: 395,
            depth: 5
        },
        window: {
            x: 142,
            y: 315,
            depth: 2
        },
        tv: {
            x: 748,
            y: 164,
            depth: 5
        }
    }
};
class $3cc139208c00b3e6$export$40d0717fa63cb445 extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.DISTRACTION,
            duration: 999999999,
            showCountdown: 0,
            showHomeButton: false,
            timeToStart: 1000,
            startScreenColor: 0xFFD400,
            startText: "KEEP YOUR\nFOCUS!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.END,
            showSkipButton: false,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BIRTH,
            endButtons: {
                normalNoSkip: {
                    x: -426.5,
                    y: 386,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 283,
                    y: 386,
                    scale: 1.30
                },
                skip: {
                    x: 570,
                    y: 386,
                    scale: 1.30
                }
            },
            isArcadeMinigame: true
        });
        this.isRestart = false;
        this.startSurvivalTime = 0;
        this.playerLost = false;
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.distractions = [];
        this.distractionManager = null;
        this.playerLost = false;
        this.startSurvivalTime = 0;
        this.isRestart = this.checkForRestart();
    }
    checkForRestart() {
        let key = this.sceneName + "restart";
        let restartInfo = this.storagePlugin.getItem(key, "");
        if (restartInfo) {
            let parsed = JSON.parse(restartInfo);
            this.startSurvivalTime = parsed.time;
            this.storagePlugin.removeItem(key);
            return true;
        }
        return false;
    }
    _preload() {}
    _create() {
        this.createBackground();
        this.createCharacter();
        this.createDistractions();
        this.createDistractionDisplay();
    }
    createBackground() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.BACKGROUND).setOrigin(0, 0).setDepth(3);
        this.add.image(140.8, 176.3, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.WINDOW_FRONT).setDepth(4);
        this.add.image(137.8, 189, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.WINDOW_BACK).setDepth(1);
        this.add.image(427, 76, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.CLOUD).setDepth(45);
    }
    createCharacter() {
        new $3cc139208c00b3e6$var$Character(this);
    }
    createDistractions() {
        //hardcode spawning distractions
        let phone = new (0, $4dd412d8d83ec784$export$2e2bcd8739ae039)(this, $3cc139208c00b3e6$var$minigameConfig.distractions.phone);
        let ball = new (0, $3099e5f836e310eb$export$2e2bcd8739ae039)(this, $3cc139208c00b3e6$var$minigameConfig.distractions.ball);
        let window = new (0, $dbad9ef185a53530$export$2e2bcd8739ae039)(this, $3cc139208c00b3e6$var$minigameConfig.distractions.window);
        let tv = new (0, $5078f46f0ab2fd6a$export$2e2bcd8739ae039)(this, $3cc139208c00b3e6$var$minigameConfig.distractions.tv);
        this.distractions.push(...[
            phone,
            ball,
            window,
            tv
        ]);
        this.distractionManager = new (0, $ab1240a02d4f048f$export$2e2bcd8739ae039)(this.distractions, this.startSurvivalTime, this);
    }
    //Shows the "loading bar" of how much the player is distracted!
    createDistractionDisplay() {
        this.countdown = new (0, $58395644c39fd8e9$export$53819c0e58f98d49)({
            scene: this,
            position: {
                x: 407,
                y: 41
            },
            maxValue: 100,
            depth: 50
        });
    }
    _update(time, delta) {
        this.distractionManager._update(time, delta);
        this.checkScore();
    }
    checkScore() {
        let score = this.distractionManager.getScore();
        this.updateDistractionDisplay(score);
        if (score >= $3cc139208c00b3e6$var$minigameConfig.loseScore) this.triggerLose();
    }
    updateDistractionDisplay(score) {
        this.countdown.displayScore(score);
    }
    onGameStarted() {
        this.distractionManager.startSpawning();
    }
    _timeout() {
    // this.loseGame();
    }
    _afterLoss() {}
    _afterWin() {}
    triggerLose() {
        if (this.playerLost) return;
        this.playerLost = true;
        this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.LOSE, {
            volume: 4
        });
        this.distractionManager.onGameLost();
        this.saveAndDisplayScore();
        setTimeout(()=>{
            this.distractions.forEach((d)=>d.forceDisable());
        }, 2000);
        this.loseGame(2000);
    }
    triggerWin() {
        //trigger win after 1 second and load next scene
        this.winGame(1000);
    }
    saveAndDisplayScore() {
        var score = this.calculateScore();
        var oldHighscore = this.getHighscore();
        var isNewHighscore = score > oldHighscore;
        this.displayScore(score, isNewHighscore, oldHighscore);
        if (isNewHighscore) this.setHighscore(score);
        this.sendFinalScoreAnalyticsEvent(score);
    }
    calculateScore() {
        let score = this.distractionManager.getSurvivalTimeInSeconds();
        return score;
    }
    displayScore(score, isHighscore, oldHighscore) {
        this.survivalTimeText.text = score.toString();
        let scoreLength = this.survivalTimeText.text.length;
        if (scoreLength == 1) {
            this.survivalTimeText.x = 504;
            this.survivalTimeText.y = 152;
            this.highscoreImage.x = 501;
            this.highscoreImage.y = 152;
        }
        if (scoreLength == 2) {
            this.survivalTimeText.x = 491;
            this.survivalTimeText.y = 150;
            this.highscoreImage.x = 489;
            this.highscoreImage.y = 151;
        }
        if (scoreLength == 3) {
            this.survivalTimeText.x = 476.3;
            this.survivalTimeText.y = 151.6;
            this.highscoreImage.x = 476.8;
            this.highscoreImage.y = 152.6;
        }
        if (scoreLength >= 4) {
            this.survivalTimeText.x = 462.5;
            this.survivalTimeText.y = 150.8;
            this.highscoreImage.x = 460.5;
            this.highscoreImage.y = 152.6;
        }
        this.highscoreImage.setAlpha(isHighscore ? 1 : 0);
    }
    getCustomLoseUIElements() {
        this.highscoreImage = this.add.image(484, 152, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.NEW_BEST).setDepth(3);
        this.survivalTimeText = this.add.text(484, 152, "123", {
            fontFamily: "bloggerSans",
            fontSize: 35,
            color: "#C92A88",
            align: "center"
        }).setDepth(2);
        if (this.isRestart || this.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).REGISTRY.ADBLOCKENABLED)) {
            //Without continue button
            var backButton2 = new (0, $3f010fa5bfb89089$export$2e2bcd8739ae039)((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU, 686, 231, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.BACK).setScale(1.1);
            var tryAgainButton2 = new (0, $526fb0004cf1157b$export$2e2bcd8739ae039)(710.5, 302, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TRY_AGAIN_2).setScale(1.1).setDepth(2);
            return [
                backButton2,
                tryAgainButton2,
                this.survivalTimeText,
                this.highscoreImage
            ];
        } else {
            //With continue button
            var backButton = new (0, $3f010fa5bfb89089$export$2e2bcd8739ae039)((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU, 733, 380, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.BACK_2).setScale(1.1);
            var continueButton = new (0, $bee7b1f49e5c2618$export$2e2bcd8739ae039)(713, 303, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.CONTINUE, ()=>{
                return this.getContinueData();
            }).setScale(1.1);
            var tryAgainButton = new (0, $526fb0004cf1157b$export$2e2bcd8739ae039)(680, 233, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.TRY_AGAIN).setDepth(2);
            return [
                backButton,
                continueButton,
                tryAgainButton,
                this.survivalTimeText,
                this.highscoreImage
            ];
        }
    }
    getContinueData() {
        return {
            time: this.distractionManager.getSurvivalTime()
        };
    }
}
class $3cc139208c00b3e6$var$Character {
    constructor(scene){
        this.scene = scene;
        this.container = scene.add.container(420, 237).setDepth(4);
        this.characterArm = scene.add.container(-40, 65);
        let armImage = scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.ARM).setOrigin(0.80, 0.10);
        this.characterArm.add([
            armImage
        ]);
        this.characterHand = scene.add.container(-40, 65);
        this.handImage = scene.add.image(-20, 80, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.HAND).setOrigin(0.3, 0.6);
        this.characterHand.add([
            this.handImage
        ]);
        let characterBase = scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).DISTRACTION.CHARACTER);
        this.container.add([
            this.characterArm,
            characterBase,
            this.characterHand
        ]);
        this.animate(scene);
    }
    animate(scene) {
        this.characterArm.setAngle(-20);
        this.characterHand.setAngle(-20);
        scene.tweens.timeline({
            targets: [
                this.characterArm,
                this.characterHand
            ],
            loop: -1,
            tweens: [
                {
                    angle: 5,
                    duration: 5000,
                    ease: "Quad.easeInOut",
                    hold: 300,
                    onStart: function() {
                        this.setWriteAnimation(true);
                    },
                    onStartScope: this
                },
                {
                    angle: -20,
                    duration: 500,
                    ease: "Quad.easeInOut",
                    onStart: function() {
                        this.setWriteAnimation(false);
                    },
                    onStartScope: this
                }
            ]
        });
    }
    setWriteAnimation(playing) {
        if (this.writeTween) this.writeTween.stop();
        if (playing) this.writeTween = this.scene.tweens.add({
            targets: this.handImage,
            angle: "+=2",
            duration: 5000,
            hold: 750,
            yoyo: true,
            repeat: -1,
            ease: (t)=>{
                return this.wiggle(t, 7, 7);
            }
        });
    }
    wiggle(aProgress, aPeriod1, aPeriod2) {
        var current1 = aProgress * Math.PI * 2 * aPeriod1;
        var current2 = aProgress * (Math.PI * 2 * aPeriod2 + Math.PI / 2);
        return Math.sin(current1) * Math.cos(current2);
    }
}




const $d312646a6bbf0724$var$handConf = {
    handTexture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).GENERIC.TUTORIAL_HAND,
    origin: {
        x: 0.7,
        y: 0.26
    },
    pressedPos: {
        x: 32,
        y: -35,
        angle: 0
    },
    hoverPos: {
        x: 40,
        y: -40,
        angle: 30
    },
    startAnim: {
        ease: "Quad.easeInOut",
        duration: 300,
        delay: 100,
        hold: 150
    },
    moveAnim: {
        ease: "Quad.easeInOut",
        delay: 150,
        hold: 150
    },
    endAnim: {
        ease: "Quad.easeInOut",
        duration: 300,
        delay: 150,
        hold: 300
    }
};
var $d312646a6bbf0724$var$HandState;
(function(HandState) {
    HandState[HandState["Deactivated"] = 0] = "Deactivated";
    HandState[HandState["Starting"] = 1] = "Starting";
    HandState[HandState["Moving"] = 2] = "Moving";
    HandState[HandState["Ending"] = 3] = "Ending";
})($d312646a6bbf0724$var$HandState || ($d312646a6bbf0724$var$HandState = {}));
class $d312646a6bbf0724$export$157da258d59c5980 extends Phaser.GameObjects.Container {
    constructor(config, scene){
        super(scene, config.spawnPos.x, config.spawnPos.y);
        this.setDepth(config.depth);
        this.config = config;
        this.currentState = 0;
        this.setHandState(0);
        this.hasMoveAnim = typeof config.moveAnim !== "undefined";
        this.handImage = scene.add.image($d312646a6bbf0724$var$handConf.pressedPos.x, $d312646a6bbf0724$var$handConf.pressedPos.y, $d312646a6bbf0724$var$handConf.handTexture).setOrigin($d312646a6bbf0724$var$handConf.origin.x, $d312646a6bbf0724$var$handConf.origin.y).setAngle($d312646a6bbf0724$var$handConf.pressedPos.angle);
        // this.displayDebugGizmos(scene, config)
        this.add([
            this.handImage
        ]);
        scene.add.existing(this);
    }
    setHandState(newState) {
        this.currentState = newState;
        switch(newState){
            case 0:
                this.onDeactivated();
                break;
            case 1:
                this.onStarting();
                break;
            case 2:
                this.onMoving();
                break;
            case 3:
                this.onEnding();
                break;
        }
    }
    fade(fadeIn) {
        if (this.fadeTween) this.fadeTween.stop();
        this.fadeTween = this.scene.tweens.add({
            targets: this,
            alpha: fadeIn ? 1 : 0,
            duration: 200,
            ease: "Quad.easeInOut"
        });
    }
    onDeactivated() {
        //Hide hand and deactivate all tweens
        if (this.handTween) this.handTween.stop();
        if (this.moveTween) this.moveTween.stop();
        this.fade(false);
    }
    onStarting() {
        //Set to start position + animate down - press
        this.fade(true);
        this.setPosition(this.config.spawnPos.x, this.config.spawnPos.y);
        this.handImage.setPosition($d312646a6bbf0724$var$handConf.hoverPos.x, $d312646a6bbf0724$var$handConf.hoverPos.y).setAngle($d312646a6bbf0724$var$handConf.hoverPos.angle);
        if (this.handTween) this.handTween.stop();
        this.handTween = this.scene.tweens.add({
            targets: this.handImage,
            x: $d312646a6bbf0724$var$handConf.pressedPos.x,
            y: $d312646a6bbf0724$var$handConf.pressedPos.y,
            angle: $d312646a6bbf0724$var$handConf.pressedPos.angle,
            ease: $d312646a6bbf0724$var$handConf.startAnim.ease,
            duration: $d312646a6bbf0724$var$handConf.startAnim.duration,
            repeat: 0,
            yoyo: false,
            delay: $d312646a6bbf0724$var$handConf.startAnim.delay,
            hold: $d312646a6bbf0724$var$handConf.startAnim.hold,
            onComplete: ()=>{
                this.setHandState(2);
            }
        });
    }
    onMoving() {
        //Move container from start to end
        if (!this.hasMoveAnim || !this.config.moveAnim) {
            this.setHandState(3);
            return;
        }
        if (this.moveTween) this.moveTween.stop();
        this.moveTween = this.scene.tweens.add({
            targets: this,
            x: this.config.moveAnim.movePos.x,
            y: this.config.moveAnim.movePos.y,
            ease: $d312646a6bbf0724$var$handConf.moveAnim.ease,
            duration: this.config.moveAnim.time,
            repeat: 0,
            yoyo: false,
            delay: $d312646a6bbf0724$var$handConf.moveAnim.delay,
            hold: $d312646a6bbf0724$var$handConf.moveAnim.hold,
            onComplete: ()=>{
                this.setHandState(3);
            }
        });
    }
    onEnding() {
        //animate hand up - release
        this.handImage.setPosition($d312646a6bbf0724$var$handConf.pressedPos.x, $d312646a6bbf0724$var$handConf.pressedPos.y).setAngle($d312646a6bbf0724$var$handConf.pressedPos.angle);
        if (this.handTween) this.handTween.stop();
        this.handTween = this.scene.tweens.add({
            targets: this.handImage,
            x: $d312646a6bbf0724$var$handConf.hoverPos.x,
            y: $d312646a6bbf0724$var$handConf.hoverPos.y,
            angle: $d312646a6bbf0724$var$handConf.hoverPos.angle,
            ease: $d312646a6bbf0724$var$handConf.endAnim.ease,
            duration: $d312646a6bbf0724$var$handConf.endAnim.duration,
            repeat: 0,
            yoyo: false,
            delay: $d312646a6bbf0724$var$handConf.endAnim.delay,
            onComplete: ()=>{
                if (this.hasMoveAnim) this.fade(false);
                setTimeout(()=>{
                    if (this.currentState != 3) return; //Fix -> return before going to starting state if we deactivate hand while this timeout is running
                    this.setHandState(1);
                }, $d312646a6bbf0724$var$handConf.endAnim.hold);
            }
        });
    }
    show() {
        if (this.currentState != 0) return;
        this.setHandState(1);
    }
    hide() {
        if (this.currentState == 0) return;
        this.setHandState(0);
    }
    isActivated() {
        return this.currentState != 0;
    }
    displayDebugGizmos(scene, config) {
        let test = scene.add.image(config.spawnPos.x, config.spawnPos.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.BACK).setTint(0x00ff00).setDepth(20).setScale(0.2);
        if (config.moveAnim) {
            let test2 = scene.add.image(config.moveAnim.movePos.x, config.moveAnim.movePos.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BUTTONS.BACK).setTint(0xffff00).setDepth(20).setScale(0.2);
        }
    }
}


const $442dfbe69fc2658c$var$CONFIG = {
    depth: 100,
    handMoveTime: 1500,
    hintCountdown: {
        first: 2000,
        general: 4000
    },
    generalLocations: {
        center: {
            x: 427,
            y: 240
        },
        serve: {
            x: 725,
            y: 325
        },
        recycle: {
            x: 114,
            y: 144
        }
    }
};
class $442dfbe69fc2658c$export$8215200cb3a49e2 {
    constructor(scene, ingredients){
        this.hintCountdown = $442dfbe69fc2658c$var$CONFIG.hintCountdown.first;
        this.scene = scene;
        //Create tutorial hands
        this.ingredientHands = this.createIngredientHands(ingredients);
        this.serveHand = new (0, $d312646a6bbf0724$export$157da258d59c5980)({
            spawnPos: $442dfbe69fc2658c$var$CONFIG.generalLocations.serve,
            depth: $442dfbe69fc2658c$var$CONFIG.depth
        }, this.scene);
        this.recycleHand = new (0, $d312646a6bbf0724$export$157da258d59c5980)({
            spawnPos: $442dfbe69fc2658c$var$CONFIG.generalLocations.recycle,
            depth: $442dfbe69fc2658c$var$CONFIG.depth
        }, this.scene);
        this.isDragging = false;
        this.isHintActive = false;
        this.gameEnded = false;
        this.resetCountdown(2000);
    }
    createIngredientHands(ingredients) {
        let ingredientHands = [];
        ingredients.forEach((ingConf)=>{
            let hand = new (0, $d312646a6bbf0724$export$157da258d59c5980)({
                spawnPos: ingConf.spawn,
                moveAnim: {
                    movePos: $442dfbe69fc2658c$var$CONFIG.generalLocations.center,
                    time: $442dfbe69fc2658c$var$CONFIG.handMoveTime
                },
                depth: $442dfbe69fc2658c$var$CONFIG.depth
            }, this.scene);
            ingredientHands.push({
                ingredient: ingConf.ingredient,
                hand: hand
            });
        });
        return ingredientHands;
    }
    onUpdate(delta) {
        if (this.isDragging || this.isHintActive || this.gameEnded) return;
        this.updateCountdown(delta);
    }
    updateCountdown(delta) {
        this.hintCountdown -= delta;
        if (this.hintCountdown <= 0) this.activateNextHint();
    }
    resetCountdown(extraTime) {
        this.hintCountdown = extraTime + $442dfbe69fc2658c$var$CONFIG.hintCountdown.first; //TODO: differentiate between first burger and next burgers!!
    }
    activateNextHint() {
        this.isHintActive = true;
        if (this.activeHand) this.activeHand.hide();
        this.activeHand = this.getNextHand();
        this.activeHand.show();
    }
    getNextHand() {
        let hand;
        if (this.scene.isBurgerCompleted()) hand = this.serveHand;
        else if (this.scene.isBurgerCorrect()) {
            let nextIngredient = this.scene.getNextIngredient();
            hand = this.ingredientHands.filter((ih)=>ih.ingredient === nextIngredient)[0].hand;
        } else hand = this.recycleHand;
        return hand;
    }
    deactivateCurrentHint(extraTime = 0) {
        this.isHintActive = false;
        if (this.activeHand) this.activeHand.hide();
        this.resetCountdown(extraTime);
    }
    handleDrag(start) {
        this.isDragging = start;
        if (start) this.deactivateCurrentHint();
    }
    handleEndGame() {
        this.gameEnded = true;
        this.deactivateCurrentHint();
    }
    handleButtonClick() {
        this.deactivateCurrentHint(1500);
    }
}



const $55f1279a067d38aa$var$CONFIG = {
    position: {
        x: 427,
        y: 240
    },
    maxIngredientDistance: 90,
    nextIngredientPositionChange: {
        x: 0,
        y: -15
    },
    containerDepth: 10,
    interactive: {
        heightPerIngredient: 15,
        defaultHeight: 40
    }
};
class $55f1279a067d38aa$export$bfcb80ab9e656a78 {
    constructor(scene){
        this.currentIngredients = [];
        this.isDragging = false;
        this.scene = scene;
        this.resetBurger();
    }
    addIngredient(ingredient) {
        this.burgerContainer.add([
            ingredient.imgShadow,
            ingredient
        ]);
        ingredient.addToBurger(this.burgerContainer, this.nextIngredientPosition, this.currentIngredients.length === 0);
        this.currentIngredients.push(ingredient);
        this.nextIngredientPosition.y -= ingredient.config.height;
        this.burgerContainer.disableInteractive();
        this.burgerContainer.setInteractive({
            hitArea: new Phaser.Geom.Rectangle(-ingredient.displayWidth / 2, -ingredient.displayHeight / 2, ingredient.displayWidth, this.currentIngredients[0].displayHeight + this.currentIngredients.length * $55f1279a067d38aa$var$CONFIG.interactive.heightPerIngredient),
            hitAreaCallback: Phaser.Geom.Rectangle.Contains,
            useHandCursor: true,
            draggable: true
        });
        this.scene.onIngredientAdded(this.currentIngredients.length);
    }
    serve() {
        this.serveAnimation();
        this.resetBurger();
    }
    recycle() {
        this.recycleAnimation();
        this.resetBurger();
    }
    //check if coordinates are within adding distance
    isInRange(x, y) {
        return Phaser.Math.Distance.Between(x, y, $55f1279a067d38aa$var$CONFIG.position.x + this.nextIngredientPosition.x, $55f1279a067d38aa$var$CONFIG.position.y + this.nextIngredientPosition.y) < $55f1279a067d38aa$var$CONFIG.maxIngredientDistance;
    }
    getCurrentIngredientTypes() {
        return this.currentIngredients.map((val)=>val.getIngredientType());
    }
    resetBurger() {
        //Resets the burger state
        this.burgerContainer = this.scene.add.container($55f1279a067d38aa$var$CONFIG.position.x, $55f1279a067d38aa$var$CONFIG.position.y).setDepth($55f1279a067d38aa$var$CONFIG.containerDepth);
        this.burgerContainer.on("dragstart", (pointer, dragX, dragY)=>{
            this.isDragging = true;
            this.handleDragStart();
        });
        this.burgerContainer.on("drag", (pointer, dragX, dragY)=>{
            if (!this.isDragging) return;
            this.handleDrag(dragX, dragY);
        });
        this.burgerContainer.on("dragend", (pointer, dragX, dragY, dropped)=>{
            this.isDragging = false;
            this.handleDragEnd();
        });
        this.nextIngredientPosition = {
            x: 0,
            y: 0
        };
        this.currentIngredients = [];
    }
    handleDragStart() {
        this.scene.onIngredientDrag(true);
        this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
            detune: this.scene.getDetune()
        });
    }
    handleDrag(x, y) {
        this.burgerContainer.setPosition(x, y);
    }
    handleDragEnd() {
        this.scene.onIngredientDrag(false);
        this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
            detune: this.scene.getDetune()
        });
        //check for serve/recycle
        if (this.moveTween) this.moveTween.stop();
        this.moveTween = this.scene.tweens.add({
            targets: this.burgerContainer,
            x: $55f1279a067d38aa$var$CONFIG.position.x,
            y: $55f1279a067d38aa$var$CONFIG.position.y,
            duration: 500,
            ease: "Quad.easeOut"
        });
    }
    serveAnimation() {
        let target = this.burgerContainer;
        this.scene.tweens.add({
            targets: this.burgerContainer,
            y: "-=315",
            duration: 500,
            delay: 700,
            ease: "Back.easeInOut",
            onComplete: ()=>{
                target.destroy();
            }
        });
    }
    recycleAnimation() {
        let target = this.burgerContainer;
        this.scene.tweens.add({
            targets: this.burgerContainer,
            y: "+=700",
            duration: 500,
            delay: 500,
            ease: "Back.easeIn",
            onComplete: ()=>{
                target.destroy();
            }
        });
    }
    getBurgerPosition() {
        return {
            x: this.burgerContainer.x,
            y: this.burgerContainer.y
        };
    }
    isBurgerDragging() {
        return this.isDragging;
    }
}



const $b0306911a0f60a96$var$CONF = {
    text: {
        size: 35,
        colorString: "#F76B68",
        colorNum: 0xF76B68
    },
    depth: 65
};
class $b0306911a0f60a96$export$53819c0e58f98d49 extends Phaser.GameObjects.Container {
    constructor(config){
        super(config.scene, config.position.x, config.position.y);
        this.config = config;
        this.currentDuration = 1000;
        this.remainingDuration = 0;
        this.isCountingDown = false;
        this.createChildren();
        this.setDepth($b0306911a0f60a96$var$CONF.depth);
        config.scene.add.existing(this);
        config.scene.events.on("update", this.onUpdate, this);
    }
    start(duration) {
        this.currentDuration = duration;
        this.remainingDuration = duration;
        this.isCountingDown = true;
        return this;
    }
    pause() {
        this.isCountingDown = false;
    }
    restart(duration, startDelay) {
        this.isCountingDown = false;
        var countdownPercentage = this.getRemainingTimeShare();
        this.currentDuration = duration;
        this.remainingDuration = this.currentDuration * countdownPercentage; //For smoother animation when duration changes
        this.config.scene.tweens.addCounter({
            from: this.remainingDuration,
            to: this.currentDuration,
            ease: "Quad.easeInOut",
            duration: startDelay / 2,
            onUpdate: function(tween) {
                var value = Math.floor(tween.getValue());
                this.remainingDuration = value;
                this.updateDisplay();
            },
            onUpdateScope: this
        });
        setTimeout(()=>{
            this.start(duration);
        }, startDelay);
    }
    createChildren() {
        this.bg = this.config.scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.TIMER);
        //TOOD: decide text vs bitmaptext
        this.text = this.config.scene.add.text(-12, -13, "0:00", {
            fontFamily: "bloggerSans",
            fontSize: $b0306911a0f60a96$var$CONF.text.size,
            color: $b0306911a0f60a96$var$CONF.text.colorString,
            align: "center"
        });
        this.radialMask = this.config.scene.add.graphics();
        this.radialMask.setPosition(-40.5, 3.5);
        this.radialMask.setAngle(-90).setScale(1, -1);
        let white = this.config.scene.add.image(-41.4, 1.6, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.TIMER_CIRCLE).setScale(0.94, 1);
        this.add([
            this.bg,
            this.text,
            white,
            this.radialMask
        ]);
    }
    onUpdate(time, delta) {
        if (!this.isCountingDown) return;
        this.remainingDuration -= delta;
        if (this.remainingDuration < 0) {
            this.remainingDuration = 0;
            this.config.onComplete();
            this.pause();
        }
        this.updateDisplay();
    }
    updateDisplay() {
        var remainingPercentage = this.getRemainingTimeShare();
        this.text.text = this.formatTimeText(this.remainingDuration);
        this.updateMask(remainingPercentage);
    }
    updateMask(percentage) {
        let width = 22.5;
        let angle = Phaser.Math.DegToRad(360 * percentage);
        this.radialMask.clear();
        this.radialMask.lineStyle(width, $b0306911a0f60a96$var$CONF.text.colorNum, 1);
        this.radialMask.beginPath();
        this.radialMask.arc(0, 0, width / 2, 0, angle, false);
        this.radialMask.strokePath();
        this.radialMask.closePath();
    }
    formatTimeText(ms) {
        let seconds = Math.floor(ms / 1000 % 60);
        let minutes = Math.floor(ms / 60000 % 60);
        return minutes + ":" + (seconds < 10 ? "0" + seconds : seconds);
    }
    getRemainingTimeShare() {
        return this.remainingDuration / this.currentDuration;
    }
    getElapsedTime() {
        return this.currentDuration - this.remainingDuration;
    }
    getTotalTime() {
        return this.currentDuration;
    }
}



const $6f5fd631cf8c0ccf$var$CONFIG = {
    anchor: {
        x: 425,
        y: 800
    },
    origin: {
        x: 1,
        y: 0.33
    },
    texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.HAND,
    depth: 50,
    angleOffset: -90
};
class $6f5fd631cf8c0ccf$export$2e2bcd8739ae039 {
    constructor(scene){
        this.follow = true;
        this.scene = scene;
        this.hand = scene.add.image(420, 216, $6f5fd631cf8c0ccf$var$CONFIG.texture).setDepth($6f5fd631cf8c0ccf$var$CONFIG.depth).setOrigin($6f5fd631cf8c0ccf$var$CONFIG.origin.x, $6f5fd631cf8c0ccf$var$CONFIG.origin.y);
        this.scene.events.on("update", this.update, this);
    }
    update() {
        this.updateHandPosition();
    }
    updateHandPosition() {
        if (!this.follow) return;
        this.hand.x = this.scene.input.activePointer.x;
        this.hand.y = this.scene.input.activePointer.y;
        var angle = Phaser.Math.RadToDeg(Math.atan2($6f5fd631cf8c0ccf$var$CONFIG.anchor.x - this.hand.x, $6f5fd631cf8c0ccf$var$CONFIG.anchor.y - this.hand.y));
        this.hand.setAngle($6f5fd631cf8c0ccf$var$CONFIG.angleOffset - angle);
    }
    setFollow(follow) {
        this.follow = follow;
    }
}



const $5a75e58a771697f1$var$CONFIG = {
    dragDepth: 20,
    spawnMove: {
        duration: 500,
        ease: "Quad.easeOut"
    },
    burgerMove: {
        duration: 200,
        ease: "Back.easeIn"
    },
    fade: {
        duration: 500,
        ease: "Quad.easeInOut"
    },
    shadowOffset: {
        x: 6.5,
        y: 4
    }
};
class $5a75e58a771697f1$export$c357770f542fbd5c extends Phaser.GameObjects.Image {
    constructor(config, scene, spawner){
        super(scene, config.spawn.x, config.spawn.y, config.texture);
        this.addedToBurger = false;
        this.isDragging = false;
        this.config = config;
        this.spawner = spawner;
        this.setInteractive({
            useHandCursor: true,
            draggable: true,
            pixelPerfect: true
        });
        this.setAlpha(0);
        this.setOrigin(config.origin.x, config.origin.y);
        this.fade(true);
        this.setDepth(config.depth);
        this.imgShadow = scene.add.image(0, 0, this.config.shadow_texture).setOrigin(this.originX, this.originY).setTint(0x353535).setAlpha(0.3 * this.alpha);
        this.updateShadow();
        this.on("dragstart", (pointer, dragX, dragY)=>{
            this.isDragging = true;
            this.handleDragStart(scene);
        });
        this.on("drag", (pointer, dragX, dragY)=>{
            if (!this.isDragging) return;
            this.handleDrag(dragX, dragY);
        });
        this.on("dragend", (pointer, dragX, dragY, dropped)=>{
            this.isDragging = false;
            this.handleDragEnd(scene);
        });
        scene.add.existing(this);
    }
    updateShadow() {
        this.imgShadow.x = this.x + $5a75e58a771697f1$var$CONFIG.shadowOffset.x;
        this.imgShadow.y = this.y + $5a75e58a771697f1$var$CONFIG.shadowOffset.y;
        this.imgShadow.setDepth(this.depth - 2);
        if (!(this.isDragging || this.addedToBurger)) this.imgShadow.setAlpha(0.3 * this.alpha);
    }
    handleDragStart(scene) {
        this.setDepth($5a75e58a771697f1$var$CONFIG.dragDepth);
        this.updateShadow();
        this.fadeShadow(false);
        scene.onIngredientDrag(true);
        this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
            detune: this.scene.getDetune()
        });
    }
    handleDrag(x, y) {
        this.setPosition(x, y);
        this.updateShadow();
    }
    handleDragEnd(scene) {
        this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.GRAB, {
            detune: this.scene.getDetune()
        });
        this.spawner.onIngredientDropped(this.x, this.y);
        this.updateShadow();
        scene.onIngredientDrag(false);
    }
    addToBurger(container, pos, firstIngredient) {
        if (firstIngredient) this.fadeShadow(true);
        this.addedToBurger = true;
        this.disableInteractive();
        //Move to burger coordinates
        this.x -= container.x;
        this.y -= container.y;
        if (this.moveTween) this.moveTween.stop();
        this.moveTween = this.scene.tweens.add({
            targets: this,
            x: pos.x,
            y: pos.y,
            duration: $5a75e58a771697f1$var$CONFIG.burgerMove.duration,
            ease: $5a75e58a771697f1$var$CONFIG.burgerMove.ease,
            onUpdate: ()=>{
                this.updateShadow();
            }
        });
    }
    moveToSpawn() {
        if (this.moveTween) this.moveTween.stop();
        this.moveTween = this.scene.tweens.add({
            targets: this,
            x: this.config.spawn.x,
            y: this.config.spawn.y,
            duration: $5a75e58a771697f1$var$CONFIG.spawnMove.duration,
            ease: $5a75e58a771697f1$var$CONFIG.spawnMove.ease,
            onUpdate: ()=>{
                this.setDepth(this.config.depth);
                this.updateShadow();
            }
        });
        this.fadeShadow(true);
    }
    getIngredientType() {
        return this.config.ingredient;
    }
    fade(fadeIn) {
        if (this.fadeTween) this.fadeTween.stop();
        this.fadeTween = this.scene.tweens.add({
            targets: this,
            alpha: fadeIn ? 1 : 0,
            duration: $5a75e58a771697f1$var$CONFIG.fade.duration,
            ease: $5a75e58a771697f1$var$CONFIG.fade.ease,
            onUpdate: ()=>{
                this.updateShadow();
            }
        });
    }
    fadeShadow(fadeIn) {
        this.scene.tweens.add({
            targets: this.imgShadow,
            alpha: fadeIn ? 0.3 : 0,
            duration: 250,
            ease: $5a75e58a771697f1$var$CONFIG.fade.ease
        });
    }
}


class $e1a8c62e6aaf130b$export$8854dcba6d016ad6 {
    constructor(config, burger, scene){
        this.burger = burger;
        this.config = config;
        this.scene = scene;
        this.currentIngredient = this.spawnNewIngredient();
    }
    spawnNewIngredient() {
        return new (0, $5a75e58a771697f1$export$c357770f542fbd5c)(this.config, this.scene, this);
    }
    onIngredientDropped(x, y) {
        if (this.burger.isInRange(x, y)) {
            this.burger.addIngredient(this.currentIngredient);
            this.currentIngredient = this.spawnNewIngredient();
        } else this.currentIngredient.moveToSpawn();
    }
    disable() {
        this.currentIngredient.isDragging = false;
        this.currentIngredient.disableInteractive();
        this.currentIngredient.moveToSpawn();
    }
}



const $bc6e03505eb62fee$export$fa74c78a0037e9df = {
    first: {
        ingredients: [
            6,
            1,
            3,
            5,
            4,
            7
        ]
    },
    short: [
        // {ingredients: [IngredientsEnum.BunBottom, IngredientsEnum.Patty, IngredientsEnum.Cheese, IngredientsEnum.BunTop]},
        // {ingredients: [IngredientsEnum.BunBottom, IngredientsEnum.Cheese, IngredientsEnum.Cheese, IngredientsEnum.Cheese, IngredientsEnum.BunTop]},
        {
            ingredients: [
                6,
                1,
                7
            ]
        },
        {
            ingredients: [
                6,
                1,
                3,
                7
            ]
        },
        {
            ingredients: [
                6,
                1,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                4,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                2,
                3,
                7
            ]
        },
        {
            ingredients: [
                6,
                5,
                6,
                7
            ]
        },
        {
            ingredients: [
                6,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                4,
                2,
                7
            ]
        },
        {
            ingredients: [
                6,
                1,
                1,
                7
            ]
        },
        {
            ingredients: [
                6,
                1,
                4,
                7
            ]
        },
        {
            ingredients: [
                6,
                4,
                3,
                7
            ]
        },
        {
            ingredients: [
                6,
                1,
                2,
                1,
                7
            ]
        },
        {
            ingredients: [
                6,
                5,
                2,
                4,
                7
            ]
        },
        {
            ingredients: [
                6,
                5,
                3,
                3,
                7
            ]
        },
        {
            ingredients: [
                6,
                3,
                2,
                4,
                7
            ]
        },
        {
            ingredients: [
                6,
                5,
                5,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                4,
                2,
                1,
                7
            ]
        },
        {
            ingredients: [
                6,
                2,
                4,
                3,
                7
            ]
        },
        {
            ingredients: [
                6,
                3,
                6,
                3,
                7
            ]
        },
        {
            ingredients: [
                6,
                3,
                2,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                3,
                6,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                4,
                6,
                1,
                7
            ]
        },
        {
            ingredients: [
                6,
                2,
                6,
                5,
                7
            ]
        }
    ],
    normal: [
        // {ingredients: [IngredientsEnum.BunBottom, IngredientsEnum.Lettuce, IngredientsEnum.Patty, IngredientsEnum.Cheese, IngredientsEnum.Egg, IngredientsEnum.Tomato, IngredientsEnum.BunTop]},
        // {ingredients: [IngredientsEnum.BunBottom, IngredientsEnum.Patty, IngredientsEnum.Cheese, IngredientsEnum.BunBottom, IngredientsEnum.Patty, IngredientsEnum.Cheese,  IngredientsEnum.BunTop]},
        {
            ingredients: [
                6,
                3,
                5,
                3,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                2,
                4,
                1,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                4,
                2,
                4,
                2,
                4,
                7
            ]
        },
        {
            ingredients: [
                6,
                5,
                1,
                3,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                4,
                2,
                3,
                1,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                1,
                3,
                1,
                3,
                1,
                7
            ]
        },
        {
            ingredients: [
                6,
                1,
                3,
                5,
                4,
                7
            ]
        },
        {
            ingredients: [
                6,
                5,
                2,
                2,
                2,
                2,
                7
            ]
        },
        {
            ingredients: [
                6,
                3,
                5,
                5,
                2,
                7
            ]
        },
        {
            ingredients: [
                6,
                3,
                5,
                6,
                3,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                2,
                5,
                6,
                2,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                2,
                6,
                5,
                2,
                7
            ]
        },
        {
            ingredients: [
                6,
                6,
                1,
                5,
                3,
                7
            ]
        },
        {
            ingredients: [
                6,
                5,
                6,
                5,
                1,
                7
            ]
        },
        {
            ingredients: [
                6,
                3,
                1,
                2,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                3,
                1,
                3,
                2,
                7
            ]
        },
        {
            ingredients: [
                6,
                5,
                2,
                1,
                2,
                7
            ]
        }
    ],
    meme: [
        {
            ingredients: [
                6,
                4,
                1,
                4,
                1,
                4,
                7
            ]
        },
        {
            ingredients: [
                6,
                5,
                5,
                5,
                5,
                7
            ]
        },
        {
            ingredients: [
                6,
                6,
                7
            ]
        },
        {
            ingredients: [
                6,
                3,
                5
            ]
        },
        {
            ingredients: [
                6,
                4,
                7
            ]
        },
        {
            ingredients: [
                2
            ]
        },
        {
            ingredients: [
                6,
                6,
                6,
                6,
                7
            ]
        },
        {
            ingredients: [
                3,
                5,
                3
            ]
        },
        {
            ingredients: [
                5,
                1,
                5,
                1,
                5
            ]
        },
        {
            ingredients: [
                5,
                4,
                5
            ]
        }
    ]
};


const $6ddba54228c486ea$var$IngredientTextures = {
    1: {
        sat: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.P_S_EGGS
    },
    2: {
        sat: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.P_S_LETTUCE
    },
    3: {
        sat: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.P_S_CHEESE
    },
    4: {
        sat: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.P_S_TOMATO
    },
    5: {
        sat: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.P_S_PATTY
    },
    6: {
        sat: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.P_S_BUN_BOTTOM
    },
    7: {
        sat: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.P_S_BUN_TOP
    }
};
const $6ddba54228c486ea$var$config = {
    normalBurgersAfter: 5,
    memeBurgersAfter: 10
};
class $6ddba54228c486ea$export$e59e5161ede4bcd {
    constructor(scene){
        this.scene = scene;
        this.recipeDisplay = new $6ddba54228c486ea$var$RecipeDisplay(scene);
        this.recipeQueue = [];
    }
    nextRecipe(displayDelay, burgerCount, firstBurger = false) {
        if (this.recipeQueue.length < 1 || burgerCount == $6ddba54228c486ea$var$config.normalBurgersAfter || burgerCount == $6ddba54228c486ea$var$config.memeBurgersAfter) this.refillQueue(burgerCount);
        this.currentRecipe = this.recipeQueue.pop();
        if (firstBurger && burgerCount == 0) //Add predefined first burger
        this.currentRecipe = (0, $bc6e03505eb62fee$export$fa74c78a0037e9df).first;
        setTimeout(()=>{
            this.recipeDisplay.displayRecipe(this.currentRecipe);
        }, displayDelay);
        return this.currentRecipe;
    }
    refillQueue(burgerCount) {
        //TODO: empty queue first?
        if (burgerCount < $6ddba54228c486ea$var$config.normalBurgersAfter) this.recipeQueue.push(...(0, $bc6e03505eb62fee$export$fa74c78a0037e9df).short);
        else if (burgerCount == $6ddba54228c486ea$var$config.normalBurgersAfter) this.recipeQueue.push(...(0, $bc6e03505eb62fee$export$fa74c78a0037e9df).normal);
        else if (burgerCount == $6ddba54228c486ea$var$config.memeBurgersAfter) this.recipeQueue.push(...(0, $bc6e03505eb62fee$export$fa74c78a0037e9df).meme);
        else this.recipeQueue.push(...(0, $bc6e03505eb62fee$export$fa74c78a0037e9df).short, ...(0, $bc6e03505eb62fee$export$fa74c78a0037e9df).normal, ...(0, $bc6e03505eb62fee$export$fa74c78a0037e9df).meme);
        this.recipeQueue = Phaser.Utils.Array.Shuffle(this.recipeQueue);
    }
    isBurgerCompleted(burger) {
        let burgerIngredients = burger.getCurrentIngredientTypes();
        let recipeIngredients = this.currentRecipe.ingredients;
        if (burgerIngredients.length != recipeIngredients.length) return false;
        for(let i = 0; i < recipeIngredients.length; i++){
            if (burgerIngredients[i] !== recipeIngredients[i]) return false;
        }
        return true;
    }
    isBurgerCorrect(burger) {
        let burgerIngredients = burger.getCurrentIngredientTypes();
        let recipeIngredients = this.currentRecipe.ingredients;
        for(let i = 0; i < burgerIngredients.length; i++){
            if (burgerIngredients[i] !== recipeIngredients[i]) return false;
        }
        return true;
    }
    getNextIngredient(burger) {
        let burgerIngredients = burger.getCurrentIngredientTypes();
        let recipeIngredients = this.currentRecipe.ingredients;
        if (burgerIngredients.length >= recipeIngredients.length) return false;
        return recipeIngredients[burgerIngredients.length];
    }
    getCurrentRecipeName() {
        return this.currentRecipe.ingredients.join("");
    }
    getCurrentRecipeLength() {
        return this.currentRecipe.ingredients.length;
    }
}
class $6ddba54228c486ea$var$RecipeDisplay {
    constructor(scene){
        this.DisplayConfig = {
            pos: {
                active: {
                    x: 749,
                    y: 41
                },
                inactive: {
                    x: 940,
                    y: 64
                }
            },
            tween: {
                ease: "Quad.easeInOut",
                duration: 500
            },
            depth: 70,
            display: {
                startPos: {
                    x: -12,
                    y: 90
                },
                change: {
                    x: 2.14,
                    y: -16.4
                }
            }
        };
        this.scene = scene;
    }
    displayRecipe(recipe) {
        if (this.currentRecipeDisplay) this.slideRecipe(false);
        this.currentRecipeDisplay = this.createRecipeContainer(recipe);
        this.slideRecipe(true);
    }
    createRecipeContainer(recipe) {
        var cont = this.scene.add.container(this.DisplayConfig.pos.inactive.x, this.DisplayConfig.pos.inactive.y).setDepth(this.DisplayConfig.depth);
        var paper = this.scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.PAPER).setOrigin(0.69, 0.19);
        var ingredients = this.spawnIngredients(recipe);
        cont.add([
            paper,
            ...ingredients
        ]);
        return cont;
    }
    spawnIngredients(recipe) {
        let startPoint = {
            x: this.DisplayConfig.display.startPos.x - this.DisplayConfig.display.change.x * recipe.ingredients.length / 2,
            y: this.DisplayConfig.display.startPos.y - this.DisplayConfig.display.change.y * recipe.ingredients.length / 2
        };
        let imgs = [];
        for(let i = 0; i < recipe.ingredients.length; i++)imgs.push(this.scene.add.image(startPoint.x + i * this.DisplayConfig.display.change.x, startPoint.y + i * this.DisplayConfig.display.change.y, $6ddba54228c486ea$var$IngredientTextures[recipe.ingredients[i]].sat));
        return imgs;
    }
    slideRecipe(slideIn) {
        this.scene.tweens.add({
            targets: this.currentRecipeDisplay,
            x: slideIn ? this.DisplayConfig.pos.active.x : this.DisplayConfig.pos.inactive.x,
            y: slideIn ? this.DisplayConfig.pos.active.y : this.DisplayConfig.pos.inactive.y,
            ease: this.DisplayConfig.tween.ease,
            duration: this.DisplayConfig.tween.duration,
            delay: slideIn ? 2 * this.DisplayConfig.tween.duration : 0
        });
    }
}






var $87ce6d3e7c3a5780$export$d1256e69e8211e17;
(function(IngredientsEnum) {
    IngredientsEnum[IngredientsEnum["Egg"] = 1] = "Egg";
    IngredientsEnum[IngredientsEnum["Lettuce"] = 2] = "Lettuce";
    IngredientsEnum[IngredientsEnum["Cheese"] = 3] = "Cheese";
    IngredientsEnum[IngredientsEnum["Tomato"] = 4] = "Tomato";
    IngredientsEnum[IngredientsEnum["Patty"] = 5] = "Patty";
    IngredientsEnum[IngredientsEnum["BunBottom"] = 6] = "BunBottom";
    IngredientsEnum[IngredientsEnum["BunTop"] = 7] = "BunTop";
})($87ce6d3e7c3a5780$export$d1256e69e8211e17 || ($87ce6d3e7c3a5780$export$d1256e69e8211e17 = {}));
const $87ce6d3e7c3a5780$export$c8ac2d9a786b9f80 = "firstBurgerCompleted";
const $87ce6d3e7c3a5780$var$minigameConfig = {
    ingredients: [
        {
            ingredient: 1,
            spawn: {
                x: 110,
                y: 419
            },
            texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_EGGS,
            shadow_texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_S_EGGS,
            height: 10,
            depth: 5,
            origin: {
                x: 0.5,
                y: 0.5
            }
        },
        {
            ingredient: 2,
            spawn: {
                x: 309,
                y: 375
            },
            texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_LETTUCE,
            shadow_texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_S_LETTUCE,
            height: 10,
            depth: 5,
            origin: {
                x: 0.5,
                y: 0.5
            }
        },
        {
            ingredient: 3,
            spawn: {
                x: 196,
                y: 343
            },
            texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_CHEESE,
            shadow_texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_S_CHEESE,
            height: 5,
            depth: 5,
            origin: {
                x: 0.5,
                y: 0.37
            }
        },
        {
            ingredient: 4,
            spawn: {
                x: 199,
                y: 248
            },
            texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_TOMATO,
            shadow_texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_S_TOMATO,
            height: 7,
            depth: 5,
            origin: {
                x: 0.5,
                y: 0.5
            }
        },
        {
            ingredient: 5,
            spawn: {
                x: 263,
                y: 167
            },
            texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_PATTY,
            shadow_texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_S_PATTY,
            height: 15,
            depth: 5,
            origin: {
                x: 0.5,
                y: 0.5
            }
        },
        {
            ingredient: 6,
            spawn: {
                x: 72,
                y: 317
            },
            texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_BUN_BOTTOM,
            shadow_texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_S_BUN_BOTTOM,
            height: 12,
            depth: 5,
            origin: {
                x: 0.5,
                y: 0.5
            }
        },
        {
            ingredient: 7,
            spawn: {
                x: 50,
                y: 260
            },
            texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_BUN_TOP,
            shadow_texture: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.I_S_BUN_TOP,
            height: 12,
            depth: 6,
            origin: {
                x: 0.5,
                y: 0.5
            }
        }
    ]
};
class $87ce6d3e7c3a5780$export$7c3b6f91bb8b702a extends (0, $7bc149abaca018eb$export$a95ae84b8ab23d68) {
    constructor(){
        super({
            sceneName: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BURGER,
            duration: 999999999,
            showCountdown: 0,
            showHomeButton: false,
            timeToStart: 1000,
            startScreenColor: 0xFF9900,
            startText: "BURGER\nMADNESS!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.END,
            showSkipButton: false,
            nextScene: (0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.BIRTH,
            endButtons: {
                normalNoSkip: {
                    x: -426.5,
                    y: 386,
                    scale: 1.30
                },
                normalWithSkip: {
                    x: 283,
                    y: 386,
                    scale: 1.30
                },
                skip: {
                    x: 570,
                    y: 386,
                    scale: 1.30
                }
            },
            isArcadeMinigame: true
        });
        this.isRestart = false;
        this.isFirstBurger = true;
        this.ingredients = [];
        this.currentScore = 0;
        this.difficulty = {
            baseTime: 3000,
            defaultTimePerIngredient: 3000,
            minimumTimePerIngredient: 1000,
            durationMultiplier: 0.96,
            firstBurgerTime: 120000
        };
    }
    _init() {
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.ingredients = [];
        this.currentScore = 0;
        this.isRestart = this.checkForRestart();
        this.getRemoteConfig();
        this.isFirstBurger = !JSON.parse(this.storagePlugin.getItem($87ce6d3e7c3a5780$export$c8ac2d9a786b9f80, "false"));
    }
    getRemoteConfig() {
        let remoteConf = this.remoteConf.getConfig("gB").split(";");
        this.difficulty.durationMultiplier = parseFloat(remoteConf[0]);
        this.difficulty.baseTime = parseInt(remoteConf[1]) * 100;
        this.difficulty.defaultTimePerIngredient = parseInt(remoteConf[2]) * 100;
        this.difficulty.minimumTimePerIngredient = parseInt(remoteConf[3]) * 100;
    }
    checkForRestart() {
        let key = this.sceneName + "restart";
        let restartInfo = this.storagePlugin.getItem(key, "");
        if (restartInfo) {
            let parsed = JSON.parse(restartInfo);
            this.currentScore = parsed.score;
            this.storagePlugin.removeItem(key);
            return true;
        }
        return false;
    }
    _preload() {}
    _create() {
        this.createBackground();
        this.createRecipe();
        this.createBurger();
        this.createIngredients();
        this.createButtons();
        this.createCountdown();
        this.hand = new (0, $6f5fd631cf8c0ccf$export$2e2bcd8739ae039)(this);
        this.serveAnim = new $87ce6d3e7c3a5780$var$ServeAnim(this);
        this.trashAnim = new $87ce6d3e7c3a5780$var$TrashAnim(this);
        this.hintSystem = new (0, $442dfbe69fc2658c$export$8215200cb3a49e2)(this, $87ce6d3e7c3a5780$var$minigameConfig.ingredients);
    }
    createBackground() {
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.ROPE).setOrigin(0, 0).setDepth(60);
        this.add.image(427, 218, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.BOARD).setDepth(1);
    }
    createRecipe() {
        this.recipe = new (0, $6ddba54228c486ea$export$e59e5161ede4bcd)(this);
    }
    createBurger() {
        this.burger = new (0, $55f1279a067d38aa$export$bfcb80ab9e656a78)(this);
    }
    createIngredients() {
        $87ce6d3e7c3a5780$var$minigameConfig.ingredients.forEach((ingConf)=>{
            let ing = new (0, $e1a8c62e6aaf130b$export$8854dcba6d016ad6)(ingConf, this.burger, this);
            this.ingredients.push(ing);
        });
    }
    createButtons() {
        this.serveButton = new $87ce6d3e7c3a5780$var$ServeButton(728, 329, -38, -34, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.PLATE_OUTLINE, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.PLATE, ()=>{
            this.tryServeBurger();
        }, this);
        this.trashButton = new $87ce6d3e7c3a5780$var$ServeButton(89.5, 131, 59, -1, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.TRASH_OUTLINE, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.TRASH, ()=>{
            this.tryRecycleBurger();
        }, this);
    }
    createCountdown() {
        this.countdown = new (0, $b0306911a0f60a96$export$53819c0e58f98d49)({
            scene: this,
            position: {
                x: 85,
                y: 47
            },
            onComplete: ()=>{
                this.onCountdownCompleted();
            }
        });
    }
    onCountdownCompleted() {
        this.sendBurgerAnalyticsEvent(false, true);
        this.triggerLose();
    }
    onIngredientDrag(start) {
        this.hintSystem.handleDrag(start);
    }
    tryServeBurger() {
        if (!this.countdown.isCountingDown) return;
        this.forceShowButtonOutline(false);
        if (this.recipe.isBurgerCompleted(this.burger)) {
            setTimeout(()=>{
                this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.WIN, {
                    detune: this.getDetune()
                });
            }, 400);
            this.sendBurgerAnalyticsEvent(true);
            this.currentScore++;
            this.showNextRecipe();
            this.storagePlugin.setItem($87ce6d3e7c3a5780$export$c8ac2d9a786b9f80, true.toString());
        } else {
            this.sendBurgerAnalyticsEvent(false, false);
            this.triggerLose();
        }
        this.hintSystem.handleButtonClick();
        this.burger.serve();
        this.serveAnim.animate();
    }
    tryRecycleBurger() {
        this.forceShowButtonOutline(false);
        this.hintSystem.handleButtonClick();
        this.burger.recycle();
        this.trashAnim.animate();
    }
    isBurgerCompleted() {
        return this.recipe.isBurgerCompleted(this.burger);
    }
    isBurgerCorrect() {
        return this.recipe.isBurgerCorrect(this.burger);
    }
    getNextIngredient() {
        return this.recipe.getNextIngredient(this.burger);
    }
    showNextRecipe() {
        this.forceShowButtonOutline(false);
        var recipe = this.recipe.nextRecipe(750, this.currentScore, this.isFirstBurger);
        var nextDuration = this.getNextBurgerDuration(recipe);
        if (this.isFirstBurger && this.currentScore == 0) nextDuration = this.difficulty.firstBurgerTime;
        this.countdown.restart(nextDuration, 1750);
    }
    getNextBurgerDuration(recipe) {
        let progressMultiplier = Math.pow(this.difficulty.durationMultiplier, this.currentScore);
        let tpi = this.difficulty.defaultTimePerIngredient * progressMultiplier;
        return this.difficulty.baseTime + recipe.ingredients.length * Math.max(tpi, this.difficulty.minimumTimePerIngredient);
    }
    _update(time, delta) {
        this.checkBurgerButtonDistance();
        this.hintSystem.onUpdate(delta);
    }
    onIngredientAdded(length) {
        if (length >= this.recipe.getCurrentRecipeLength()) this.forceShowButtonOutline(true);
    }
    forceShowButtonOutline(show) {
        this.serveButton.forceFade(show);
        this.trashButton.forceFade(show);
    }
    checkBurgerButtonDistance() {
        this.serveButton.checkBurgerVicinity(this.burger.getBurgerPosition().x, this.burger.getBurgerPosition().y, !this.burger.isBurgerDragging());
        this.trashButton.checkBurgerVicinity(this.burger.getBurgerPosition().x, this.burger.getBurgerPosition().y, !this.burger.isBurgerDragging());
    }
    onGameStarted() {
        this.showNextRecipe();
    }
    _timeout() {}
    _afterLoss() {}
    _afterWin() {}
    triggerLose() {
        setTimeout(()=>{
            this.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.LOSE, {
                volume: 4
            });
        }, 500);
        this.sendFinalScoreAnalyticsEvent(this.currentScore);
        this.saveAndDisplayScore();
        this.countdown.pause();
        this.ingredients.forEach((ing)=>ing.disable());
        this.hintSystem.handleEndGame();
        this.serveButton.disableInteractive();
        this.trashButton.disableInteractive();
        setTimeout(()=>{
            this.hand.setFollow(false);
            this.add.graphics().fillStyle(0x535353, 0.33).fillRect(0, 0, this.game.renderer.width, this.game.renderer.height).setDepth(500);
        }, 2000);
        this.loseGame(2000);
    }
    triggerWin() {
    //not used in arcade
    }
    saveAndDisplayScore() {
        var score = this.currentScore;
        var oldHighscore = this.getHighscore();
        var isNewHighscore = score > oldHighscore;
        this.displayScore(score, isNewHighscore, oldHighscore);
        if (isNewHighscore) this.setHighscore(score);
    }
    displayScore(score, isHighscore, oldHighscore) {
        this.endScoreDisplay.text = score.toString();
        let scoreLength = this.endScoreDisplay.text.length;
        this.burgerImage.setPosition(this.burgerImage.x + scoreLength * 20, this.burgerImage.y - scoreLength * 1);
        this.highscoreImage.setPosition(this.burgerImage.x + 54, this.burgerImage.y + 17);
        this.highscoreImage.setAlpha(isHighscore ? 1 : 0);
    }
    getCustomLoseUIElements() {
        this.endScoreDisplay = this.add.text(525, 200, "123", {
            fontFamily: "bloggerSans",
            fontSize: 35,
            color: "#ED8340",
            align: "center"
        }).setAngle(-4).setDepth(2);
        this.burgerImage = this.add.image(600, 214, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.BURGERS_TEXT).setScale(0.55).setDepth(2);
        this.highscoreImage = this.add.image(680, 225, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.NEW_BEST).setDepth(2);
        if (this.isRestart || this.registry.get((0, $15b72a9ad2952278$export$fadd21211b40c08a).REGISTRY.ADBLOCKENABLED)) {
            //Without continue button
            var backButton2 = new (0, $3f010fa5bfb89089$export$2e2bcd8739ae039)((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU, 515, 375, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.ARCADE_BUTTON).setAngle(0).setScale(0.55).setDepth(2);
            var tryAgainButton2 = new (0, $526fb0004cf1157b$export$2e2bcd8739ae039)(660, 367, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.TRY_AGAIN_BUTTON).setAngle(0).setScale(0.55).setDepth(2);
            return [
                backButton2,
                tryAgainButton2,
                this.endScoreDisplay,
                this.burgerImage,
                this.highscoreImage
            ];
        } else {
            //With continue button
            var backButton = new (0, $3f010fa5bfb89089$export$2e2bcd8739ae039)((0, $15b72a9ad2952278$export$fadd21211b40c08a).SCENES.MENU, 588, 412, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.BACK_TO_ARCADE).setScale(0.55);
            var continueButton = new (0, $bee7b1f49e5c2618$export$2e2bcd8739ae039)(663, 356, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.CONTINUE_BUTTON, ()=>{
                return this.getContinueData();
            }).setScale(0.55);
            var tryAgainButton = new (0, $526fb0004cf1157b$export$2e2bcd8739ae039)(515, 364, this, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.TRY_AGAIN_BUTTON_2).setScale(0.55);
            return [
                backButton,
                continueButton,
                tryAgainButton,
                this.endScoreDisplay,
                this.burgerImage,
                this.highscoreImage
            ];
        }
    }
    getContinueData() {
        return {
            score: this.currentScore
        };
    }
    sendBurgerAnalyticsEvent(completed, isTimeout = false) {
        let eventName = completed ? "Completed" : isTimeout ? "TooSlow" : "Wrong";
        let burgerName = this.recipe.getCurrentRecipeName();
        let value = completed ? this.countdown.getElapsedTime() : this.countdown.getTotalTime();
        const customDesignEvent = this.sceneName + ":" + burgerName + ":" + eventName;
        this.analyticsPlugin.addDesignEventWithValue(customDesignEvent, Math.round(value));
    // console.log("burger event " + eventName + " " + burgerName + " " + value);
    }
}
class $87ce6d3e7c3a5780$var$ServeButton extends Phaser.GameObjects.Image {
    constructor(x, y, xOffset, yOffset, outlineTexture, texture, onClick, scene){
        super(scene, x, y, texture);
        this.isEnabled = true;
        this.maxBurgerDistance = 100;
        this.isHovering = false;
        this.isForcedFadeIn = false;
        this.isBurgerClose = false;
        this.outlineVisible = false;
        this.outline = scene.add.image(x + xOffset, y + yOffset, outlineTexture).setAlpha(0);
        this.onClickFun = onClick;
        this.setInteractive({
            useHandCursor: true
        });
        this.on("pointerup", ()=>{
            if (!this.isEnabled) return;
            onClick();
            this.isEnabled = false;
            setTimeout(()=>{
                this.isEnabled = true;
            }, 1500);
        });
        this.on("pointerover", ()=>{
            if (!this.isEnabled) return;
            this.isHovering = true;
            this.updateOutline();
        });
        this.on("pointerout", ()=>{
            this.isHovering = false;
            this.updateOutline();
        });
        scene.add.existing(this);
    }
    checkBurgerVicinity(burgerX, burgerY, dropped) {
        if (Phaser.Math.Distance.Between(this.x, this.y, burgerX, burgerY) < this.maxBurgerDistance) {
            this.isBurgerClose = true;
            this.updateOutline();
            if (dropped && this.isEnabled) this.onClickFun();
        } else {
            this.isBurgerClose = false;
            this.updateOutline();
        }
    }
    updateOutline() {
        let visible = this.isHovering || this.isForcedFadeIn || this.isBurgerClose;
        if (this.outlineVisible != visible) {
            this.outlineVisible = visible;
            this.fadeOutline(this.outlineVisible);
        }
    }
    fadeOutline(fadeIn) {
        if (this.fadeTween) this.fadeTween.stop();
        this.fadeTween = this.scene.tweens.add({
            targets: this.outline,
            alpha: fadeIn ? 1 : 0,
            duration: 200,
            ease: "Quad.easeOut"
        });
    }
    forceFade(fadeIn) {
        this.isForcedFadeIn = fadeIn;
        this.updateOutline();
    }
}
class $87ce6d3e7c3a5780$var$ServeAnim {
    constructor(scene){
        this.conf = {
            move: {
                x: 427,
                y: 240
            },
            startPos: {
                x: 427,
                y: -75
            },
            ease: "Back.easeInOut",
            duration: 500,
            hold: 200
        };
        this.scene = scene;
        let plate = scene.add.image(0, 0, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.PLATE);
        let hand = scene.add.image(19, -339, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.HAND).setAngle(90);
        this.cont = scene.add.container(this.conf.startPos.x, this.conf.startPos.y).setDepth(9);
        this.cont.add([
            plate,
            hand
        ]);
    }
    animate() {
        if (this.tween) this.tween.stop();
        this.tween = this.scene.tweens.add({
            targets: this.cont,
            x: this.conf.move.x,
            y: this.conf.move.y,
            ease: this.conf.ease,
            duration: this.conf.duration,
            hold: this.conf.hold,
            yoyo: true
        });
    }
}
class $87ce6d3e7c3a5780$var$TrashAnim {
    constructor(scene){
        this.conf = {
            move: {
                x: 424,
                y: 400
            },
            startPos: {
                x: 424,
                y: 590
            },
            ease: "Back.easeInOut",
            duration: 500,
            hold: 500
        };
        this.scene = scene;
        this.bin = scene.add.image(this.conf.startPos.x, this.conf.startPos.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.TRASH).setScale(1.5).setDepth(7);
        this.bin_front = scene.add.image(this.conf.startPos.x, this.conf.startPos.y, (0, $15b72a9ad2952278$export$fadd21211b40c08a).BURGER.TRASH_TOP).setScale(1.5).setDepth(11).setOrigin(0.49, 0.49);
    }
    animate() {
        this.scene.sound.play((0, $15b72a9ad2952278$export$fadd21211b40c08a).AUDIO.TRASH, {
            volume: 8
        });
        if (this.tween) this.tween.stop();
        this.tween = this.scene.tweens.add({
            targets: [
                this.bin,
                this.bin_front
            ],
            x: this.conf.move.x,
            y: this.conf.move.y,
            ease: this.conf.ease,
            duration: this.conf.duration,
            hold: this.conf.hold,
            yoyo: true
        });
    }
}




//var gameanalytics = require('gameanalytics');
const $977946e4419609b8$var$defaultConfig = [
    {
        key: "aE",
        value: "true"
    },
    {
        key: "gO",
        value: "3012"
    },
    {
        key: "gB",
        value: "0.96;25;27;8"
    },
    {
        key: "gD",
        value: "80;30;18;80;35"
    },
    {
        key: "gG",
        value: "0.96;4;250;100"
    },
    {
        key: "hBe",
        value: "true"
    }
];
class $977946e4419609b8$export$8dc21adde702114f extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager){
        super(pluginManager);
        this.remoteConfigsAvailable = false;
        this.initialized = false;
    }
    initialize() {
        if (this.analyticsDisabled()) this.onRemoteConfigUpdated();
        this.initialized = true;
    }
    onRemoteConfigUpdated() {
        this.remoteConfigsAvailable = true;
        this.logConfigs();
        if (this.configsCallback) this.configsCallback();
    }
    logConfigs() {
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("REMOTE CONFIGS ");
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("aE: " + this.getConfig("aE"));
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("gO: " + this.getConfig("gO"));
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("gB: " + this.getConfig("gB"));
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("gD: " + this.getConfig("gD"));
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("gG: " + this.getConfig("gG"));
    }
    configsAvailable() {
        return this.remoteConfigsAvailable;
    }
    setConfigsCallback(cb) {
        this.configsCallback = cb;
    }
    getConfig(key, forceDefault = false) {
        let defaultValue = $977946e4419609b8$var$defaultConfig.filter((dc)=>{
            return dc.key == key;
        })[0];
        if (this.analyticsDisabled() || forceDefault) return defaultValue.value;
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("Getting remote config value for " + key + " from gameanalytics.");
    //return gameanalytics.GameAnalytics.getRemoteConfigsValueAsString(key, defaultValue.value);
    }
    analyticsDisabled() {
        return !(0, $ca2834f16a956c4f$export$29cd7b75162a9425).AnalyticsEnabled;
    }
}


const $d7288bdde04b3a7b$var$audioEnabledKey = "audioEnabled";
class $d7288bdde04b3a7b$export$82c9ecd3e5f5431c extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager){
        super(pluginManager);
        this.storagePlugin = pluginManager.get("StoragePlugin");
        this.audioEnabled = JSON.parse(this.storagePlugin.getItem($d7288bdde04b3a7b$var$audioEnabledKey, "true"));
        this.isCommercialBreak = false;
        this.pluginManager.game.sound.mute = !this.audioEnabled;
        this.initialized = false;
    }
    initialize() {
        this.initialized = true;
    }
    toggleAudioEnabled() {
        this.audioEnabled = !this.audioEnabled;
        this.storagePlugin.setItem($d7288bdde04b3a7b$var$audioEnabledKey, this.audioEnabled.toString());
        this.updateAudioMute();
        return this.isAudioEnabled();
    }
    isAudioEnabled() {
        return this.audioEnabled;
    }
    beforeCommercialBreak() {
        this.isCommercialBreak = true;
        this.updateAudioMute();
    }
    afterCommercialBreak() {
        this.isCommercialBreak = false;
        this.updateAudioMute();
    }
    updateAudioMute() {
        this.pluginManager.game.sound.mute = !this.audioEnabled || this.isCommercialBreak;
    }
}


var $135a551d03a1b190$exports = {};
"use strict";
Object.defineProperty($135a551d03a1b190$exports, "__esModule", {
    value: true
});
$135a551d03a1b190$exports.storageFactory = void 0;
function $135a551d03a1b190$var$storageFactory(getStorage) {
    var inMemoryStorage = {};
    function isSupported() {
        try {
            var testKey = "__some_random_key_you_are_not_going_to_use__";
            getStorage().setItem(testKey, testKey);
            getStorage().removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }
    function clear() {
        if (isSupported()) getStorage().clear();
        else inMemoryStorage = {};
    }
    function getItem(name) {
        if (isSupported()) return getStorage().getItem(name);
        if (inMemoryStorage.hasOwnProperty(name)) return inMemoryStorage[name];
        return null;
    }
    function key(index) {
        if (isSupported()) return getStorage().key(index);
        else return Object.keys(inMemoryStorage)[index] || null;
    }
    function removeItem(name) {
        if (isSupported()) getStorage().removeItem(name);
        else delete inMemoryStorage[name];
    }
    function setItem(name, value) {
        if (isSupported()) getStorage().setItem(name, value);
        else inMemoryStorage[name] = String(value);
    }
    function length() {
        if (isSupported()) return getStorage().length;
        else return Object.keys(inMemoryStorage).length;
    }
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
        key: key,
        get length () {
            return length();
        }
    };
}
$135a551d03a1b190$exports.storageFactory = $135a551d03a1b190$var$storageFactory;



const $7f742d17b21c8ef7$var$local = (0, $135a551d03a1b190$exports.storageFactory)(()=>localStorage);
class $7f742d17b21c8ef7$export$4b75421604609cf7 extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager){
        super(pluginManager);
        this.initialized = false;
    }
    initialize() {
        this.initialized = true;
    }
    getItem(key, defaultValue = "") {
        var item = $7f742d17b21c8ef7$var$local.getItem(key);
        return item ? item : defaultValue;
    }
    setItem(key, value) {
        (0, $853b94ecf165ba5a$export$9e165481be275d2d).Debug("Saving key: " + key + " value: " + value);
        $7f742d17b21c8ef7$var$local.setItem(key, value);
    }
    removeItem(key) {
        $7f742d17b21c8ef7$var$local.removeItem(key);
    }
    isLocalStorageSupported() {
        try {
            const testKey = "isLocalStorageSupported";
            localStorage.setItem(testKey, testKey);
            localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }
}



/*
This plugin was sourced from:
https://phaser.discourse.group/t/matter-physics-in-phaser-v3-60-to-v3-80/13398/2

Problem with matter physics is that it depends on frame rate - physics is running much faster on high refresh rate displays,
which is a problem. We want physics to run framerate independent.
This plugin runs matter physics manually and simulates 60fps, regardless of actual fps.  
*/ const { DESTROY: $77e4cef0ea5be10c$var$DESTROY, SHUTDOWN: $77e4cef0ea5be10c$var$SHUTDOWN, START: $77e4cef0ea5be10c$var$START, UPDATE: $77e4cef0ea5be10c$var$UPDATE } = Phaser.Scenes.Events;
class $77e4cef0ea5be10c$export$76bd3940c138cad1 extends Phaser.Plugins.ScenePlugin {
    boot() {
        console.debug("boot");
        if (!this.systems.matterPhysics) throw new Error("Matter Physics must be enabled in this scene");
        if (this.systems.matterPhysics.config.autoUpdate) throw new Error("Matter Physics config must have `autoUpdate: false`");
        this.systems.events.on($77e4cef0ea5be10c$var$START, this.sceneStart, this).on($77e4cef0ea5be10c$var$SHUTDOWN, this.sceneShutdown, this).on($77e4cef0ea5be10c$var$DESTROY, this.sceneDestroy, this).on($77e4cef0ea5be10c$var$UPDATE, this.sceneUpdate, this);
    }
    sceneDestroy() {
        this.systems.events.off($77e4cef0ea5be10c$var$START, this.sceneStart, this).off($77e4cef0ea5be10c$var$SHUTDOWN, this.sceneShutdown, this).off($77e4cef0ea5be10c$var$DESTROY, this.sceneDestroy, this).off($77e4cef0ea5be10c$var$UPDATE, this.sceneUpdate, this);
    }
    sceneStart() {}
    sceneShutdown() {}
    sceneUpdate(time, delta) {
        const { matterPhysics: matterPhysics } = this.systems;
        const { deltaMin: deltaMin } = matterPhysics.world.runner;
        this.accum += delta;
        while(this.accum >= deltaMin){
            matterPhysics.step(deltaMin);
            this.accum -= deltaMin;
        }
    }
    constructor(...args){
        super(...args);
        this.accum = 0;
    }
}


let $ad2bcec7a0192558$var$game = new Phaser.Game({
    width: 853,
    height: 480,
    plugins: {
        scene: [
            {
                key: "MatterFixedStepPlugin",
                plugin: (0, $77e4cef0ea5be10c$export$76bd3940c138cad1),
                start: true
            }
        ],
        global: [
            {
                key: "AnalyticsPlugin",
                plugin: (0, $a04efaba6a5d950c$export$ca681bfeb2cf0fca),
                mapping: "analyticsPlugin",
                start: true
            },
            {
                key: "StoragePlugin",
                plugin: (0, $7f742d17b21c8ef7$export$4b75421604609cf7),
                mapping: "storagePlugin",
                start: true
            },
            {
                key: "RemoteConfigPlugin",
                plugin: (0, $977946e4419609b8$export$8dc21adde702114f),
                mapping: "remoteConf",
                start: true
            },
            {
                key: "AudioPlugin",
                plugin: (0, $d7288bdde04b3a7b$export$82c9ecd3e5f5431c),
                mapping: "audioPlugin",
                start: true
            }
        ]
    },
    scale: {
        mode: Phaser.Scale.FIT
    },
    scene: [
        (0, $1bb8838b0c7bd3a3$export$50427b92ba00a41),
        (0, $2fba7fa75fad9307$export$1786b98a6337e7e4),
        (0, $7e3af3e6538b9494$export$ec537e24d5ef2139),
        (0, $30cfeaa254875b8b$export$fe1abc4519a61930),
        (0, $34565ebbfbfa097d$export$c1e33676c826b984),
        (0, $ffdb1caf6db2742b$export$d42c6d2da3053304),
        (0, $33500910613e6aaf$export$4a2ac4fa72bb5140),
        (0, $9334cc922d718eb2$export$c5fb64a6647e1351),
        (0, $55a4f57c2002ed7f$export$c5ecf9bedad0bf2e),
        (0, $f71eb2c7da145579$export$83762f717266aaef),
        (0, $0ad3efc9ab2217f0$export$55db55b27d5d4dcf),
        (0, $d621c1ba691ee78d$export$c0554d6699482cc0),
        (0, $2fa2f6cfba7e42f9$export$7b93822fe073925a),
        (0, $62561b551dfdb023$export$ccdc95a7053a49a5),
        (0, $e5a649cd055144f1$export$d81351cf6cbef71d),
        (0, $1601d6b360480467$export$cfa3c5ea0599add0),
        (0, $3d0adf22ccdc05d5$export$3d56d16ec65b7a75),
        (0, $c23539df4af788c4$export$9a600b9240d23e2b),
        (0, $c5a171bd85d76b9f$export$7a21c539aa1c4c75),
        (0, $93de182afd578cb5$export$2d5bc55a67026bc1),
        (0, $d7b76b24920e934a$export$3c1d564c0d5a8f6a),
        (0, $3cc139208c00b3e6$export$40d0717fa63cb445),
        (0, $87ce6d3e7c3a5780$export$7c3b6f91bb8b702a)
    ],
    physics: {
        default: "matter",
        matter: {
            debug: false,
            autoUpdate: false
        }
    }
});


//# sourceMappingURL=index.9c100c84.js.map
